const ir = (t) => {
  const e = t.fields && Object.entries(t.fields).map(
    (r) => `filter[${r[0]}]=${r[1].operation}:${r[1].value}`
  );
  return t.sort ? e ? `${e.join("&")}&sort=${t.sort}` : `sort=${t.sort}` : e && e.join("&");
}, cr = (t) => {
  const e = t.include && t.include.join(), r = t.fields && Object.entries(t.fields).map(
    (s) => `fields[${s[0]}]=${s[1].join()}`
  );
  if (e && r)
    return `include=${e}&${r.join("&")}`;
  if (!e && r)
    return r.join("&");
  if (e && !r)
    return `include=${e}`;
}, w = ({
  includes: t,
  filter: e,
  pagination: r = { page: "1", per: "25" }
}) => {
  const s = `page=${r.page}&per=${r.per}`;
  return t && !e ? `?${cr(t)}&${s}` : e && !t ? `?${ir(e)}&${s}` : e && t ? `?${cr(t)}&${ir(
    e
  )}&${s}` : !e && !t && r ? `?${s}` : "";
}, Mt = (t, e) => {
  const r = { ...t };
  for (const s in e)
    e[s] instanceof Object && !Array.isArray(e[s]) && t[s] ? r[s] = Mt(t[s], e[s]) : r.hasOwnProperty(s) || (r[s] = e[s]);
  return r;
}, Ts = (t) => ({
  query: (e) => t.post("v1/callback_requests", e)
}), Ss = (t) => ({
  query: (e) => t.post("v1/requests", e)
}), As = (t) => ({
  query: (e) => t.post("v1/requests", e)
}), Rs = (t) => ({
  query: (e, r) => t.put(`v1/requests/${e}`, r)
}), Es = (t) => ({
  prebooking: {
    createPrebooking: As(t).query,
    updatePrebooking: Rs(t).query
  },
  lpRequest: {
    createLpRequest: Ss(t).query
  },
  callBackRequest: {
    createCallbackRequest: Ts(t).query
  }
}), Cs = (t) => ({
  query: (e) => t.post(`v1/user/houses/${e.houseId}/owner_bookings`, {
    owner_booking: e.period
  })
}), Os = (t) => ({
  query: (e) => t.get(`v1/user/houses/${e.houseId}/calendar_exports`)
}), Ps = (t) => ({
  query: (e) => t.get(
    `v2/user/houses/${e.houseId}/contracts/${e.contractId}`
  )
}), Ns = (t) => ({
  query: (e) => t.get(`v1/user/houses/${e.houseId}/periods`)
}), Ds = (t) => ({
  houses: {
    calendar: {
      getCalendarExports: Os(t).query
    },
    contracts: {
      getContractById: Ps(t).query
    },
    bookings: {
      owner: {
        modifyOwnerBooking: Cs(t).query
      }
    },
    periods: {
      getPeriods: Ns(t).query
    }
  }
}), js = (t) => ({
  query: (e) => t.post("v3/requests", e.request)
}), Us = (t) => ({
  query: (e) => t.put(`v3/requests/${e.request_uuid}`, e.request)
}), Ls = (t) => ({
  request: {
    makeHouseRequest: js(t).query,
    updateInquiry: Us(t).query
  }
}), Bs = (t) => ({
  query: (e) => t.post("v3/user/auth", e)
}), Hs = (t) => ({
  query: (e) => t.post("v3/user/auth/sign_in", e)
}), Fs = (t) => ({
  query: (e) => t.post("v3/user/auth/sign_in_with_token", e)
}), Ms = (t) => ({
  query: (e) => t.post("v3/user/auth/sign_up_with_token", e)
}), Zs = (t) => ({
  query: (e) => t.post("v3/user/auth/finish_signup", e)
}), zs = (t) => ({
  query: (e) => t.post(
    `v3/user/automatic_proposals/${e.automaticProposalId}/automatic_proposal_comments/${e.automaticProposalHouseId}`,
    { automatic_proposal_comment: e.automatic_proposal_comment }
  )
}), Vs = (t) => ({
  query: (e) => t.put(
    `v3/user/automatic_proposals/${e.automaticProposalId}/automatic_proposal_comments/${e.automaticProposalHouseId}`,
    { automatic_proposal_comment: e.automatic_proposal_comment }
  )
}), ur = (t) => {
  let e = t[0].toUpperCase();
  for (let r = 1; r < t.length; r++)
    [" ", "-"].includes(t[r - 1]) ? e += t[r].toUpperCase() : e += t[r].toLowerCase();
  return e;
}, dr = (t) => t.relationships ? Ws(t) : {
  id: t.id,
  type: t.type,
  ...t.meta ? { meta: t.meta } : {},
  ...t.attributes
}, lr = (t) => {
  const e = {};
  return t && Object.keys(t).forEach((s) => {
    const n = t == null ? void 0 : t[s].data;
    Array.isArray(n) ? e[`${s}Ids`] = n.map(({ id: a }) => a) : e[`${s}Id`] = (n == null ? void 0 : n.id) || null;
  }), e;
}, fr = (t) => {
  const e = t.relationships, r = t.attributes;
  return t != null && t.attributes ? { id: t.id, ...r, ...lr(e) } : { ...t, ...lr(e) };
}, Ws = (t) => {
  var s;
  const e = {}, r = t == null ? void 0 : t.relationships;
  if (r)
    for (const [n, a] of Object.entries(r))
      Array.isArray(a.data) ? e[`${n}Ids`] = a.data.map((o) => o.id) : e[`${n}Id`] = (s = a.data) == null ? void 0 : s.id;
  return {
    id: t.id,
    type: t.type,
    ...t.attributes,
    ...t.meta ? { meta: t.meta } : {},
    ...e
  };
}, yr = (t) => Array.isArray(t) ? t.map((e) => dr(e)) : dr(t), Gs = (t) => {
  const e = {}, r = {};
  return t.map((s) => s.type).forEach((s) => {
    e[s] ? e[s] = 2 : e[s] = 1;
  }), Object.values(e).forEach((s, n) => {
    const a = Object.keys(e)[n], o = t.filter((d) => d.type === a), i = t.find((d) => d.type === a);
    s > 1 ? r[`${a}s`] = yr(o) : i && (r[`${a}s`] = yr(i));
  }), r;
}, ne = (t) => {
  const { data: e, headers: r, included: s, meta: n } = t;
  if (e && typeof e != "string") {
    const a = Array.isArray(e) ? e.map((i) => fr(i)) : fr(e), o = s ? Gs(s) : null;
    return {
      data: a,
      headers: r,
      ...n ? { meta: n } : {},
      ...o ? { included: o } : {}
    };
  }
  return t;
};
function Br(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: Js } = Object.prototype, { getPrototypeOf: Zt } = Object, { iterator: st, toStringTag: Hr } = Symbol, nt = ((t) => (e) => {
  const r = Js.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Z = (t) => (t = t.toLowerCase(), (e) => nt(e) === t), at = (t) => (e) => typeof e === t, { isArray: $e } = Array, ve = at("undefined");
function Pe(t) {
  return t !== null && !ve(t) && t.constructor !== null && !ve(t.constructor) && B(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Fr = Z("ArrayBuffer");
function Ks(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Fr(t.buffer), e;
}
const Xs = at("string"), B = at("function"), Mr = at("number"), Ne = (t) => t !== null && typeof t == "object", Qs = (t) => t === !0 || t === !1, Me = (t) => {
  if (nt(t) !== "object")
    return !1;
  const e = Zt(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Hr in t) && !(st in t);
}, Ys = (t) => {
  if (!Ne(t) || Pe(t))
    return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, en = Z("Date"), tn = Z("File"), rn = Z("Blob"), sn = Z("FileList"), nn = (t) => Ne(t) && B(t.pipe), an = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || B(t.append) && ((e = nt(t)) === "formdata" || // detect form-data instance
  e === "object" && B(t.toString) && t.toString() === "[object FormData]"));
}, on = Z("URLSearchParams"), [cn, un, dn, ln] = ["ReadableStream", "Request", "Response", "Headers"].map(Z), fn = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function De(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let s, n;
  if (typeof t != "object" && (t = [t]), $e(t))
    for (s = 0, n = t.length; s < n; s++)
      e.call(null, t[s], s, t);
  else {
    if (Pe(t))
      return;
    const a = r ? Object.getOwnPropertyNames(t) : Object.keys(t), o = a.length;
    let i;
    for (s = 0; s < o; s++)
      i = a[s], e.call(null, t[i], i, t);
  }
}
function Zr(t, e) {
  if (Pe(t))
    return null;
  e = e.toLowerCase();
  const r = Object.keys(t);
  let s = r.length, n;
  for (; s-- > 0; )
    if (n = r[s], e === n.toLowerCase())
      return n;
  return null;
}
const le = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), zr = (t) => !ve(t) && t !== le;
function vt() {
  const { caseless: t, skipUndefined: e } = zr(this) && this || {}, r = {}, s = (n, a) => {
    const o = t && Zr(r, a) || a;
    Me(r[o]) && Me(n) ? r[o] = vt(r[o], n) : Me(n) ? r[o] = vt({}, n) : $e(n) ? r[o] = n.slice() : (!e || !ve(n)) && (r[o] = n);
  };
  for (let n = 0, a = arguments.length; n < a; n++)
    arguments[n] && De(arguments[n], s);
  return r;
}
const yn = (t, e, r, { allOwnKeys: s } = {}) => (De(e, (n, a) => {
  r && B(n) ? t[a] = Br(n, r) : t[a] = n;
}, { allOwnKeys: s }), t), hn = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), mn = (t, e, r, s) => {
  t.prototype = Object.create(e.prototype, s), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, pn = (t, e, r, s) => {
  let n, a, o;
  const i = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (n = Object.getOwnPropertyNames(t), a = n.length; a-- > 0; )
      o = n[a], (!s || s(o, t, e)) && !i[o] && (e[o] = t[o], i[o] = !0);
    t = r !== !1 && Zt(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, gn = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const s = t.indexOf(e, r);
  return s !== -1 && s === r;
}, vn = (t) => {
  if (!t)
    return null;
  if ($e(t))
    return t;
  let e = t.length;
  if (!Mr(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, _n = ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && Zt(Uint8Array)), qn = (t, e) => {
  const s = (t && t[st]).call(t);
  let n;
  for (; (n = s.next()) && !n.done; ) {
    const a = n.value;
    e.call(t, a[0], a[1]);
  }
}, bn = (t, e) => {
  let r;
  const s = [];
  for (; (r = t.exec(e)) !== null; )
    s.push(r);
  return s;
}, wn = Z("HTMLFormElement"), kn = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, s, n) {
    return s.toUpperCase() + n;
  }
), hr = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), In = Z("RegExp"), Vr = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), s = {};
  De(r, (n, a) => {
    let o;
    (o = e(n, a, t)) !== !1 && (s[a] = o || n);
  }), Object.defineProperties(t, s);
}, $n = (t) => {
  Vr(t, (e, r) => {
    if (B(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const s = t[r];
    if (B(s)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, xn = (t, e) => {
  const r = {}, s = (n) => {
    n.forEach((a) => {
      r[a] = !0;
    });
  };
  return $e(t) ? s(t) : s(String(t).split(e)), r;
}, Tn = () => {
}, Sn = (t, e) => t != null && Number.isFinite(t = +t) ? t : e;
function An(t) {
  return !!(t && B(t.append) && t[Hr] === "FormData" && t[st]);
}
const Rn = (t) => {
  const e = new Array(10), r = (s, n) => {
    if (Ne(s)) {
      if (e.indexOf(s) >= 0)
        return;
      if (Pe(s))
        return s;
      if (!("toJSON" in s)) {
        e[n] = s;
        const a = $e(s) ? [] : {};
        return De(s, (o, i) => {
          const d = r(o, n + 1);
          !ve(d) && (a[i] = d);
        }), e[n] = void 0, a;
      }
    }
    return s;
  };
  return r(t, 0);
}, En = Z("AsyncFunction"), Cn = (t) => t && (Ne(t) || B(t)) && B(t.then) && B(t.catch), Wr = ((t, e) => t ? setImmediate : e ? ((r, s) => (le.addEventListener("message", ({ source: n, data: a }) => {
  n === le && a === r && s.length && s.shift()();
}, !1), (n) => {
  s.push(n), le.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  B(le.postMessage)
), On = typeof queueMicrotask < "u" ? queueMicrotask.bind(le) : typeof process < "u" && process.nextTick || Wr, Pn = (t) => t != null && B(t[st]), l = {
  isArray: $e,
  isArrayBuffer: Fr,
  isBuffer: Pe,
  isFormData: an,
  isArrayBufferView: Ks,
  isString: Xs,
  isNumber: Mr,
  isBoolean: Qs,
  isObject: Ne,
  isPlainObject: Me,
  isEmptyObject: Ys,
  isReadableStream: cn,
  isRequest: un,
  isResponse: dn,
  isHeaders: ln,
  isUndefined: ve,
  isDate: en,
  isFile: tn,
  isBlob: rn,
  isRegExp: In,
  isFunction: B,
  isStream: nn,
  isURLSearchParams: on,
  isTypedArray: _n,
  isFileList: sn,
  forEach: De,
  merge: vt,
  extend: yn,
  trim: fn,
  stripBOM: hn,
  inherits: mn,
  toFlatObject: pn,
  kindOf: nt,
  kindOfTest: Z,
  endsWith: gn,
  toArray: vn,
  forEachEntry: qn,
  matchAll: bn,
  isHTMLForm: wn,
  hasOwnProperty: hr,
  hasOwnProp: hr,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Vr,
  freezeMethods: $n,
  toObjectSet: xn,
  toCamelCase: kn,
  noop: Tn,
  toFiniteNumber: Sn,
  findKey: Zr,
  global: le,
  isContextDefined: zr,
  isSpecCompliantForm: An,
  toJSONObject: Rn,
  isAsyncFn: En,
  isThenable: Cn,
  setImmediate: Wr,
  asap: On,
  isIterable: Pn
};
function $(t, e, r, s, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), s && (this.request = s), n && (this.response = n, this.status = n.status ? n.status : null);
}
l.inherits($, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: l.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Gr = $.prototype, Jr = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  Jr[t] = { value: t };
});
Object.defineProperties($, Jr);
Object.defineProperty(Gr, "isAxiosError", { value: !0 });
$.from = (t, e, r, s, n, a) => {
  const o = Object.create(Gr);
  l.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const i = t && t.message ? t.message : "Error", d = e == null && t ? t.code : e;
  return $.call(o, i, d, r, s, n), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", a && Object.assign(o, a), o;
};
const Nn = null;
function _t(t) {
  return l.isPlainObject(t) || l.isArray(t);
}
function Kr(t) {
  return l.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function mr(t, e, r) {
  return t ? t.concat(e).map(function(n, a) {
    return n = Kr(n), !r && a ? "[" + n + "]" : n;
  }).join(r ? "." : "") : e;
}
function Dn(t) {
  return l.isArray(t) && !t.some(_t);
}
const jn = l.toFlatObject(l, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function ot(t, e, r) {
  if (!l.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = l.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, g) {
    return !l.isUndefined(g[p]);
  });
  const s = r.metaTokens, n = r.visitor || c, a = r.dots, o = r.indexes, d = (r.Blob || typeof Blob < "u" && Blob) && l.isSpecCompliantForm(e);
  if (!l.isFunction(n))
    throw new TypeError("visitor must be a function");
  function u(y) {
    if (y === null)
      return "";
    if (l.isDate(y))
      return y.toISOString();
    if (l.isBoolean(y))
      return y.toString();
    if (!d && l.isBlob(y))
      throw new $("Blob is not supported. Use a Buffer instead.");
    return l.isArrayBuffer(y) || l.isTypedArray(y) ? d && typeof Blob == "function" ? new Blob([y]) : Buffer.from(y) : y;
  }
  function c(y, p, g) {
    let A = y;
    if (y && !g && typeof y == "object") {
      if (l.endsWith(p, "{}"))
        p = s ? p : p.slice(0, -2), y = JSON.stringify(y);
      else if (l.isArray(y) && Dn(y) || (l.isFileList(y) || l.endsWith(p, "[]")) && (A = l.toArray(y)))
        return p = Kr(p), A.forEach(function(R, N) {
          !(l.isUndefined(R) || R === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? mr([p], N, a) : o === null ? p : p + "[]",
            u(R)
          );
        }), !1;
    }
    return _t(y) ? !0 : (e.append(mr(g, p, a), u(y)), !1);
  }
  const f = [], h = Object.assign(jn, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: _t
  });
  function _(y, p) {
    if (!l.isUndefined(y)) {
      if (f.indexOf(y) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      f.push(y), l.forEach(y, function(A, U) {
        (!(l.isUndefined(A) || A === null) && n.call(
          e,
          A,
          l.isString(U) ? U.trim() : U,
          p,
          h
        )) === !0 && _(A, p ? p.concat(U) : [U]);
      }), f.pop();
    }
  }
  if (!l.isObject(t))
    throw new TypeError("data must be an object");
  return _(t), e;
}
function pr(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(s) {
    return e[s];
  });
}
function zt(t, e) {
  this._pairs = [], t && ot(t, this, e);
}
const Xr = zt.prototype;
Xr.append = function(e, r) {
  this._pairs.push([e, r]);
};
Xr.toString = function(e) {
  const r = e ? function(s) {
    return e.call(this, s, pr);
  } : pr;
  return this._pairs.map(function(n) {
    return r(n[0]) + "=" + r(n[1]);
  }, "").join("&");
};
function Un(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Qr(t, e, r) {
  if (!e)
    return t;
  const s = r && r.encode || Un;
  l.isFunction(r) && (r = {
    serialize: r
  });
  const n = r && r.serialize;
  let a;
  if (n ? a = n(e, r) : a = l.isURLSearchParams(e) ? e.toString() : new zt(e, r).toString(s), a) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class Ln {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, s) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: s ? s.synchronous : !1,
      runWhen: s ? s.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    l.forEach(this.handlers, function(s) {
      s !== null && e(s);
    });
  }
}
const gr = Ln, Yr = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Bn = typeof URLSearchParams < "u" ? URLSearchParams : zt, Hn = typeof FormData < "u" ? FormData : null, Fn = typeof Blob < "u" ? Blob : null, Mn = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Bn,
    FormData: Hn,
    Blob: Fn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Vt = typeof window < "u" && typeof document < "u", qt = typeof navigator == "object" && navigator || void 0, Zn = Vt && (!qt || ["ReactNative", "NativeScript", "NS"].indexOf(qt.product) < 0), zn = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), Vn = Vt && window.location.href || "http://localhost", Wn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Vt,
  hasStandardBrowserEnv: Zn,
  hasStandardBrowserWebWorkerEnv: zn,
  navigator: qt,
  origin: Vn
}, Symbol.toStringTag, { value: "Module" })), j = {
  ...Wn,
  ...Mn
};
function Gn(t, e) {
  return ot(t, new j.classes.URLSearchParams(), {
    visitor: function(r, s, n, a) {
      return j.isNode && l.isBuffer(r) ? (this.append(s, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    },
    ...e
  });
}
function Jn(t) {
  return l.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Kn(t) {
  const e = {}, r = Object.keys(t);
  let s;
  const n = r.length;
  let a;
  for (s = 0; s < n; s++)
    a = r[s], e[a] = t[a];
  return e;
}
function es(t) {
  function e(r, s, n, a) {
    let o = r[a++];
    if (o === "__proto__")
      return !0;
    const i = Number.isFinite(+o), d = a >= r.length;
    return o = !o && l.isArray(n) ? n.length : o, d ? (l.hasOwnProp(n, o) ? n[o] = [n[o], s] : n[o] = s, !i) : ((!n[o] || !l.isObject(n[o])) && (n[o] = []), e(r, s, n[o], a) && l.isArray(n[o]) && (n[o] = Kn(n[o])), !i);
  }
  if (l.isFormData(t) && l.isFunction(t.entries)) {
    const r = {};
    return l.forEachEntry(t, (s, n) => {
      e(Jn(s), n, r, 0);
    }), r;
  }
  return null;
}
function Xn(t, e, r) {
  if (l.isString(t))
    try {
      return (e || JSON.parse)(t), l.trim(t);
    } catch (s) {
      if (s.name !== "SyntaxError")
        throw s;
    }
  return (r || JSON.stringify)(t);
}
const Wt = {
  transitional: Yr,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const s = r.getContentType() || "", n = s.indexOf("application/json") > -1, a = l.isObject(e);
    if (a && l.isHTMLForm(e) && (e = new FormData(e)), l.isFormData(e))
      return n ? JSON.stringify(es(e)) : e;
    if (l.isArrayBuffer(e) || l.isBuffer(e) || l.isStream(e) || l.isFile(e) || l.isBlob(e) || l.isReadableStream(e))
      return e;
    if (l.isArrayBufferView(e))
      return e.buffer;
    if (l.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let i;
    if (a) {
      if (s.indexOf("application/x-www-form-urlencoded") > -1)
        return Gn(e, this.formSerializer).toString();
      if ((i = l.isFileList(e)) || s.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return ot(
          i ? { "files[]": e } : e,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return a || n ? (r.setContentType("application/json", !1), Xn(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || Wt.transitional, s = r && r.forcedJSONParsing, n = this.responseType === "json";
    if (l.isResponse(e) || l.isReadableStream(e))
      return e;
    if (e && l.isString(e) && (s && !this.responseType || n)) {
      const o = !(r && r.silentJSONParsing) && n;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (i) {
        if (o)
          throw i.name === "SyntaxError" ? $.from(i, $.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: j.classes.FormData,
    Blob: j.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
l.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  Wt.headers[t] = {};
});
const Gt = Wt, Qn = l.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Yn = (t) => {
  const e = {};
  let r, s, n;
  return t && t.split(`
`).forEach(function(o) {
    n = o.indexOf(":"), r = o.substring(0, n).trim().toLowerCase(), s = o.substring(n + 1).trim(), !(!r || e[r] && Qn[r]) && (r === "set-cookie" ? e[r] ? e[r].push(s) : e[r] = [s] : e[r] = e[r] ? e[r] + ", " + s : s);
  }), e;
}, vr = Symbol("internals");
function Se(t) {
  return t && String(t).trim().toLowerCase();
}
function Ze(t) {
  return t === !1 || t == null ? t : l.isArray(t) ? t.map(Ze) : String(t);
}
function ea(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let s;
  for (; s = r.exec(t); )
    e[s[1]] = s[2];
  return e;
}
const ta = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function lt(t, e, r, s, n) {
  if (l.isFunction(s))
    return s.call(this, e, r);
  if (n && (e = r), !!l.isString(e)) {
    if (l.isString(s))
      return e.indexOf(s) !== -1;
    if (l.isRegExp(s))
      return s.test(e);
  }
}
function ra(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, s) => r.toUpperCase() + s);
}
function sa(t, e) {
  const r = l.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((s) => {
    Object.defineProperty(t, s + r, {
      value: function(n, a, o) {
        return this[s].call(this, e, n, a, o);
      },
      configurable: !0
    });
  });
}
class it {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, s) {
    const n = this;
    function a(i, d, u) {
      const c = Se(d);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const f = l.findKey(n, c);
      (!f || n[f] === void 0 || u === !0 || u === void 0 && n[f] !== !1) && (n[f || d] = Ze(i));
    }
    const o = (i, d) => l.forEach(i, (u, c) => a(u, c, d));
    if (l.isPlainObject(e) || e instanceof this.constructor)
      o(e, r);
    else if (l.isString(e) && (e = e.trim()) && !ta(e))
      o(Yn(e), r);
    else if (l.isObject(e) && l.isIterable(e)) {
      let i = {}, d, u;
      for (const c of e) {
        if (!l.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        i[u = c[0]] = (d = i[u]) ? l.isArray(d) ? [...d, c[1]] : [d, c[1]] : c[1];
      }
      o(i, r);
    } else
      e != null && a(r, e, s);
    return this;
  }
  get(e, r) {
    if (e = Se(e), e) {
      const s = l.findKey(this, e);
      if (s) {
        const n = this[s];
        if (!r)
          return n;
        if (r === !0)
          return ea(n);
        if (l.isFunction(r))
          return r.call(this, n, s);
        if (l.isRegExp(r))
          return r.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = Se(e), e) {
      const s = l.findKey(this, e);
      return !!(s && this[s] !== void 0 && (!r || lt(this, this[s], s, r)));
    }
    return !1;
  }
  delete(e, r) {
    const s = this;
    let n = !1;
    function a(o) {
      if (o = Se(o), o) {
        const i = l.findKey(s, o);
        i && (!r || lt(s, s[i], i, r)) && (delete s[i], n = !0);
      }
    }
    return l.isArray(e) ? e.forEach(a) : a(e), n;
  }
  clear(e) {
    const r = Object.keys(this);
    let s = r.length, n = !1;
    for (; s--; ) {
      const a = r[s];
      (!e || lt(this, this[a], a, e, !0)) && (delete this[a], n = !0);
    }
    return n;
  }
  normalize(e) {
    const r = this, s = {};
    return l.forEach(this, (n, a) => {
      const o = l.findKey(s, a);
      if (o) {
        r[o] = Ze(n), delete r[a];
        return;
      }
      const i = e ? ra(a) : String(a).trim();
      i !== a && delete r[a], r[i] = Ze(n), s[i] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return l.forEach(this, (s, n) => {
      s != null && s !== !1 && (r[n] = e && l.isArray(s) ? s.join(", ") : s);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const s = new this(e);
    return r.forEach((n) => s.set(n)), s;
  }
  static accessor(e) {
    const s = (this[vr] = this[vr] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function a(o) {
      const i = Se(o);
      s[i] || (sa(n, o), s[i] = !0);
    }
    return l.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
it.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
l.reduceDescriptors(it.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(s) {
      this[r] = s;
    }
  };
});
l.freezeMethods(it);
const M = it;
function ft(t, e) {
  const r = this || Gt, s = e || r, n = M.from(s.headers);
  let a = s.data;
  return l.forEach(t, function(i) {
    a = i.call(r, a, n.normalize(), e ? e.status : void 0);
  }), n.normalize(), a;
}
function ts(t) {
  return !!(t && t.__CANCEL__);
}
function xe(t, e, r) {
  $.call(this, t ?? "canceled", $.ERR_CANCELED, e, r), this.name = "CanceledError";
}
l.inherits(xe, $, {
  __CANCEL__: !0
});
function rs(t, e, r) {
  const s = r.config.validateStatus;
  !r.status || !s || s(r.status) ? t(r) : e(new $(
    "Request failed with status code " + r.status,
    [$.ERR_BAD_REQUEST, $.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function na(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function aa(t, e) {
  t = t || 10;
  const r = new Array(t), s = new Array(t);
  let n = 0, a = 0, o;
  return e = e !== void 0 ? e : 1e3, function(d) {
    const u = Date.now(), c = s[a];
    o || (o = u), r[n] = d, s[n] = u;
    let f = a, h = 0;
    for (; f !== n; )
      h += r[f++], f = f % t;
    if (n = (n + 1) % t, n === a && (a = (a + 1) % t), u - o < e)
      return;
    const _ = c && u - c;
    return _ ? Math.round(h * 1e3 / _) : void 0;
  };
}
function oa(t, e) {
  let r = 0, s = 1e3 / e, n, a;
  const o = (u, c = Date.now()) => {
    r = c, n = null, a && (clearTimeout(a), a = null), t(...u);
  };
  return [(...u) => {
    const c = Date.now(), f = c - r;
    f >= s ? o(u, c) : (n = u, a || (a = setTimeout(() => {
      a = null, o(n);
    }, s - f)));
  }, () => n && o(n)];
}
const Je = (t, e, r = 3) => {
  let s = 0;
  const n = aa(50, 250);
  return oa((a) => {
    const o = a.loaded, i = a.lengthComputable ? a.total : void 0, d = o - s, u = n(d), c = o <= i;
    s = o;
    const f = {
      loaded: o,
      total: i,
      progress: i ? o / i : void 0,
      bytes: d,
      rate: u || void 0,
      estimated: u && i && c ? (i - o) / u : void 0,
      event: a,
      lengthComputable: i != null,
      [e ? "download" : "upload"]: !0
    };
    t(f);
  }, r);
}, _r = (t, e) => {
  const r = t != null;
  return [(s) => e[0]({
    lengthComputable: r,
    total: t,
    loaded: s
  }), e[1]];
}, qr = (t) => (...e) => l.asap(() => t(...e)), ia = j.hasStandardBrowserEnv ? ((t, e) => (r) => (r = new URL(r, j.origin), t.protocol === r.protocol && t.host === r.host && (e || t.port === r.port)))(
  new URL(j.origin),
  j.navigator && /(msie|trident)/i.test(j.navigator.userAgent)
) : () => !0, ca = j.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, s, n, a, o) {
      if (typeof document > "u")
        return;
      const i = [`${t}=${encodeURIComponent(e)}`];
      l.isNumber(r) && i.push(`expires=${new Date(r).toUTCString()}`), l.isString(s) && i.push(`path=${s}`), l.isString(n) && i.push(`domain=${n}`), a === !0 && i.push("secure"), l.isString(o) && i.push(`SameSite=${o}`), document.cookie = i.join("; ");
    },
    read(t) {
      if (typeof document > "u")
        return null;
      const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
      return e ? decodeURIComponent(e[1]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ua(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function da(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function ss(t, e, r) {
  let s = !ua(e);
  return t && (s || r == !1) ? da(t, e) : e;
}
const br = (t) => t instanceof M ? { ...t } : t;
function fe(t, e) {
  e = e || {};
  const r = {};
  function s(u, c, f, h) {
    return l.isPlainObject(u) && l.isPlainObject(c) ? l.merge.call({ caseless: h }, u, c) : l.isPlainObject(c) ? l.merge({}, c) : l.isArray(c) ? c.slice() : c;
  }
  function n(u, c, f, h) {
    if (l.isUndefined(c)) {
      if (!l.isUndefined(u))
        return s(void 0, u, f, h);
    } else
      return s(u, c, f, h);
  }
  function a(u, c) {
    if (!l.isUndefined(c))
      return s(void 0, c);
  }
  function o(u, c) {
    if (l.isUndefined(c)) {
      if (!l.isUndefined(u))
        return s(void 0, u);
    } else
      return s(void 0, c);
  }
  function i(u, c, f) {
    if (f in e)
      return s(u, c);
    if (f in t)
      return s(void 0, u);
  }
  const d = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: i,
    headers: (u, c, f) => n(br(u), br(c), f, !0)
  };
  return l.forEach(Object.keys({ ...t, ...e }), function(c) {
    const f = d[c] || n, h = f(t[c], e[c], c);
    l.isUndefined(h) && f !== i || (r[c] = h);
  }), r;
}
const ns = (t) => {
  const e = fe({}, t);
  let { data: r, withXSRFToken: s, xsrfHeaderName: n, xsrfCookieName: a, headers: o, auth: i } = e;
  if (e.headers = o = M.from(o), e.url = Qr(ss(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), i && o.set(
    "Authorization",
    "Basic " + btoa((i.username || "") + ":" + (i.password ? unescape(encodeURIComponent(i.password)) : ""))
  ), l.isFormData(r)) {
    if (j.hasStandardBrowserEnv || j.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (l.isFunction(r.getHeaders)) {
      const d = r.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(d).forEach(([c, f]) => {
        u.includes(c.toLowerCase()) && o.set(c, f);
      });
    }
  }
  if (j.hasStandardBrowserEnv && (s && l.isFunction(s) && (s = s(e)), s || s !== !1 && ia(e.url))) {
    const d = n && a && ca.read(a);
    d && o.set(n, d);
  }
  return e;
}, la = typeof XMLHttpRequest < "u", fa = la && function(t) {
  return new Promise(function(r, s) {
    const n = ns(t);
    let a = n.data;
    const o = M.from(n.headers).normalize();
    let { responseType: i, onUploadProgress: d, onDownloadProgress: u } = n, c, f, h, _, y;
    function p() {
      _ && _(), y && y(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let g = new XMLHttpRequest();
    g.open(n.method.toUpperCase(), n.url, !0), g.timeout = n.timeout;
    function A() {
      if (!g)
        return;
      const R = M.from(
        "getAllResponseHeaders" in g && g.getAllResponseHeaders()
      ), P = {
        data: !i || i === "text" || i === "json" ? g.responseText : g.response,
        status: g.status,
        statusText: g.statusText,
        headers: R,
        config: t,
        request: g
      };
      rs(function(H) {
        r(H), p();
      }, function(H) {
        s(H), p();
      }, P), g = null;
    }
    "onloadend" in g ? g.onloadend = A : g.onreadystatechange = function() {
      !g || g.readyState !== 4 || g.status === 0 && !(g.responseURL && g.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, g.onabort = function() {
      g && (s(new $("Request aborted", $.ECONNABORTED, t, g)), g = null);
    }, g.onerror = function(N) {
      const P = N && N.message ? N.message : "Network Error", ue = new $(P, $.ERR_NETWORK, t, g);
      ue.event = N || null, s(ue), g = null;
    }, g.ontimeout = function() {
      let N = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const P = n.transitional || Yr;
      n.timeoutErrorMessage && (N = n.timeoutErrorMessage), s(new $(
        N,
        P.clarifyTimeoutError ? $.ETIMEDOUT : $.ECONNABORTED,
        t,
        g
      )), g = null;
    }, a === void 0 && o.setContentType(null), "setRequestHeader" in g && l.forEach(o.toJSON(), function(N, P) {
      g.setRequestHeader(P, N);
    }), l.isUndefined(n.withCredentials) || (g.withCredentials = !!n.withCredentials), i && i !== "json" && (g.responseType = n.responseType), u && ([h, y] = Je(u, !0), g.addEventListener("progress", h)), d && g.upload && ([f, _] = Je(d), g.upload.addEventListener("progress", f), g.upload.addEventListener("loadend", _)), (n.cancelToken || n.signal) && (c = (R) => {
      g && (s(!R || R.type ? new xe(null, t, g) : R), g.abort(), g = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const U = na(n.url);
    if (U && j.protocols.indexOf(U) === -1) {
      s(new $("Unsupported protocol " + U + ":", $.ERR_BAD_REQUEST, t));
      return;
    }
    g.send(a || null);
  });
}, ya = (t, e) => {
  const { length: r } = t = t ? t.filter(Boolean) : [];
  if (e || r) {
    let s = new AbortController(), n;
    const a = function(u) {
      if (!n) {
        n = !0, i();
        const c = u instanceof Error ? u : this.reason;
        s.abort(c instanceof $ ? c : new xe(c instanceof Error ? c.message : c));
      }
    };
    let o = e && setTimeout(() => {
      o = null, a(new $(`timeout ${e} of ms exceeded`, $.ETIMEDOUT));
    }, e);
    const i = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), t = null);
    };
    t.forEach((u) => u.addEventListener("abort", a));
    const { signal: d } = s;
    return d.unsubscribe = () => l.asap(i), d;
  }
}, ha = ya, ma = function* (t, e) {
  let r = t.byteLength;
  if (!e || r < e) {
    yield t;
    return;
  }
  let s = 0, n;
  for (; s < r; )
    n = s + e, yield t.slice(s, n), s = n;
}, pa = async function* (t, e) {
  for await (const r of ga(t))
    yield* ma(r, e);
}, ga = async function* (t) {
  if (t[Symbol.asyncIterator]) {
    yield* t;
    return;
  }
  const e = t.getReader();
  try {
    for (; ; ) {
      const { done: r, value: s } = await e.read();
      if (r)
        break;
      yield s;
    }
  } finally {
    await e.cancel();
  }
}, wr = (t, e, r, s) => {
  const n = pa(t, e);
  let a = 0, o, i = (d) => {
    o || (o = !0, s && s(d));
  };
  return new ReadableStream({
    async pull(d) {
      try {
        const { done: u, value: c } = await n.next();
        if (u) {
          i(), d.close();
          return;
        }
        let f = c.byteLength;
        if (r) {
          let h = a += f;
          r(h);
        }
        d.enqueue(new Uint8Array(c));
      } catch (u) {
        throw i(u), u;
      }
    },
    cancel(d) {
      return i(d), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, kr = 64 * 1024, { isFunction: He } = l, va = (({ Request: t, Response: e }) => ({
  Request: t,
  Response: e
}))(l.global), {
  ReadableStream: Ir,
  TextEncoder: $r
} = l.global, xr = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, _a = (t) => {
  t = l.merge.call({
    skipUndefined: !0
  }, va, t);
  const { fetch: e, Request: r, Response: s } = t, n = e ? He(e) : typeof fetch == "function", a = He(r), o = He(s);
  if (!n)
    return !1;
  const i = n && He(Ir), d = n && (typeof $r == "function" ? ((y) => (p) => y.encode(p))(new $r()) : async (y) => new Uint8Array(await new r(y).arrayBuffer())), u = a && i && xr(() => {
    let y = !1;
    const p = new r(j.origin, {
      body: new Ir(),
      method: "POST",
      get duplex() {
        return y = !0, "half";
      }
    }).headers.has("Content-Type");
    return y && !p;
  }), c = o && i && xr(() => l.isReadableStream(new s("").body)), f = {
    stream: c && ((y) => y.body)
  };
  n && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((y) => {
    !f[y] && (f[y] = (p, g) => {
      let A = p && p[y];
      if (A)
        return A.call(p);
      throw new $(`Response type '${y}' is not supported`, $.ERR_NOT_SUPPORT, g);
    });
  });
  const h = async (y) => {
    if (y == null)
      return 0;
    if (l.isBlob(y))
      return y.size;
    if (l.isSpecCompliantForm(y))
      return (await new r(j.origin, {
        method: "POST",
        body: y
      }).arrayBuffer()).byteLength;
    if (l.isArrayBufferView(y) || l.isArrayBuffer(y))
      return y.byteLength;
    if (l.isURLSearchParams(y) && (y = y + ""), l.isString(y))
      return (await d(y)).byteLength;
  }, _ = async (y, p) => {
    const g = l.toFiniteNumber(y.getContentLength());
    return g ?? h(p);
  };
  return async (y) => {
    let {
      url: p,
      method: g,
      data: A,
      signal: U,
      cancelToken: R,
      timeout: N,
      onDownloadProgress: P,
      onUploadProgress: ue,
      responseType: H,
      headers: ut,
      withCredentials: Ue = "same-origin",
      fetchOptions: tr
    } = ns(y), rr = e || fetch;
    H = H ? (H + "").toLowerCase() : "text";
    let Le = ha([U, R && R.toAbortSignal()], N), Te = null;
    const de = Le && Le.unsubscribe && (() => {
      Le.unsubscribe();
    });
    let sr;
    try {
      if (ue && u && g !== "get" && g !== "head" && (sr = await _(ut, A)) !== 0) {
        let te = new r(p, {
          method: "POST",
          body: A,
          duplex: "half"
        }), he;
        if (l.isFormData(A) && (he = te.headers.get("content-type")) && ut.setContentType(he), te.body) {
          const [dt, Be] = _r(
            sr,
            Je(qr(ue))
          );
          A = wr(te.body, kr, dt, Be);
        }
      }
      l.isString(Ue) || (Ue = Ue ? "include" : "omit");
      const z = a && "credentials" in r.prototype, nr = {
        ...tr,
        signal: Le,
        method: g.toUpperCase(),
        headers: ut.normalize().toJSON(),
        body: A,
        duplex: "half",
        credentials: z ? Ue : void 0
      };
      Te = a && new r(p, nr);
      let ee = await (a ? rr(Te, tr) : rr(p, nr));
      const ar = c && (H === "stream" || H === "response");
      if (c && (P || ar && de)) {
        const te = {};
        ["status", "statusText", "headers"].forEach((or) => {
          te[or] = ee[or];
        });
        const he = l.toFiniteNumber(ee.headers.get("content-length")), [dt, Be] = P && _r(
          he,
          Je(qr(P), !0)
        ) || [];
        ee = new s(
          wr(ee.body, kr, dt, () => {
            Be && Be(), de && de();
          }),
          te
        );
      }
      H = H || "text";
      let xs = await f[l.findKey(f, H) || "text"](ee, y);
      return !ar && de && de(), await new Promise((te, he) => {
        rs(te, he, {
          data: xs,
          headers: M.from(ee.headers),
          status: ee.status,
          statusText: ee.statusText,
          config: y,
          request: Te
        });
      });
    } catch (z) {
      throw de && de(), z && z.name === "TypeError" && /Load failed|fetch/i.test(z.message) ? Object.assign(
        new $("Network Error", $.ERR_NETWORK, y, Te),
        {
          cause: z.cause || z
        }
      ) : $.from(z, z && z.code, y, Te);
    }
  };
}, qa = /* @__PURE__ */ new Map(), as = (t) => {
  let e = t && t.env || {};
  const { fetch: r, Request: s, Response: n } = e, a = [
    s,
    n,
    r
  ];
  let o = a.length, i = o, d, u, c = qa;
  for (; i--; )
    d = a[i], u = c.get(d), u === void 0 && c.set(d, u = i ? /* @__PURE__ */ new Map() : _a(e)), c = u;
  return u;
};
as();
const Jt = {
  http: Nn,
  xhr: fa,
  fetch: {
    get: as
  }
};
l.forEach(Jt, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Tr = (t) => `- ${t}`, ba = (t) => l.isFunction(t) || t === null || t === !1;
function wa(t, e) {
  t = l.isArray(t) ? t : [t];
  const { length: r } = t;
  let s, n;
  const a = {};
  for (let o = 0; o < r; o++) {
    s = t[o];
    let i;
    if (n = s, !ba(s) && (n = Jt[(i = String(s)).toLowerCase()], n === void 0))
      throw new $(`Unknown adapter '${i}'`);
    if (n && (l.isFunction(n) || (n = n.get(e))))
      break;
    a[i || "#" + o] = n;
  }
  if (!n) {
    const o = Object.entries(a).map(
      ([d, u]) => `adapter ${d} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let i = r ? o.length > 1 ? `since :
` + o.map(Tr).join(`
`) : " " + Tr(o[0]) : "as no adapter specified";
    throw new $(
      "There is no suitable adapter to dispatch the request " + i,
      "ERR_NOT_SUPPORT"
    );
  }
  return n;
}
const os = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: wa,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Jt
};
function yt(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new xe(null, t);
}
function Sr(t) {
  return yt(t), t.headers = M.from(t.headers), t.data = ft.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), os.getAdapter(t.adapter || Gt.adapter, t)(t).then(function(s) {
    return yt(t), s.data = ft.call(
      t,
      t.transformResponse,
      s
    ), s.headers = M.from(s.headers), s;
  }, function(s) {
    return ts(s) || (yt(t), s && s.response && (s.response.data = ft.call(
      t,
      t.transformResponse,
      s.response
    ), s.response.headers = M.from(s.response.headers))), Promise.reject(s);
  });
}
const is = "1.13.1", ct = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  ct[t] = function(s) {
    return typeof s === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Ar = {};
ct.transitional = function(e, r, s) {
  function n(a, o) {
    return "[Axios v" + is + "] Transitional option '" + a + "'" + o + (s ? ". " + s : "");
  }
  return (a, o, i) => {
    if (e === !1)
      throw new $(
        n(o, " has been removed" + (r ? " in " + r : "")),
        $.ERR_DEPRECATED
      );
    return r && !Ar[o] && (Ar[o] = !0, console.warn(
      n(
        o,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, o, i) : !0;
  };
};
ct.spelling = function(e) {
  return (r, s) => (console.warn(`${s} is likely a misspelling of ${e}`), !0);
};
function ka(t, e, r) {
  if (typeof t != "object")
    throw new $("options must be an object", $.ERR_BAD_OPTION_VALUE);
  const s = Object.keys(t);
  let n = s.length;
  for (; n-- > 0; ) {
    const a = s[n], o = e[a];
    if (o) {
      const i = t[a], d = i === void 0 || o(i, a, t);
      if (d !== !0)
        throw new $("option " + a + " must be " + d, $.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new $("Unknown option " + a, $.ERR_BAD_OPTION);
  }
}
const ze = {
  assertOptions: ka,
  validators: ct
}, V = ze.validators;
let Ke = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new gr(),
      response: new gr()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (s) {
      if (s instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const a = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          s.stack ? a && !String(s.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (s.stack += `
` + a) : s.stack = a;
        } catch {
        }
      }
      throw s;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = fe(this.defaults, r);
    const { transitional: s, paramsSerializer: n, headers: a } = r;
    s !== void 0 && ze.assertOptions(s, {
      silentJSONParsing: V.transitional(V.boolean),
      forcedJSONParsing: V.transitional(V.boolean),
      clarifyTimeoutError: V.transitional(V.boolean)
    }, !1), n != null && (l.isFunction(n) ? r.paramsSerializer = {
      serialize: n
    } : ze.assertOptions(n, {
      encode: V.function,
      serialize: V.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), ze.assertOptions(r, {
      baseUrl: V.spelling("baseURL"),
      withXsrfToken: V.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let o = a && l.merge(
      a.common,
      a[r.method]
    );
    a && l.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (y) => {
        delete a[y];
      }
    ), r.headers = M.concat(o, a);
    const i = [];
    let d = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(r) === !1 || (d = d && p.synchronous, i.unshift(p.fulfilled, p.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(p) {
      u.push(p.fulfilled, p.rejected);
    });
    let c, f = 0, h;
    if (!d) {
      const y = [Sr.bind(this), void 0];
      for (y.unshift(...i), y.push(...u), h = y.length, c = Promise.resolve(r); f < h; )
        c = c.then(y[f++], y[f++]);
      return c;
    }
    h = i.length;
    let _ = r;
    for (; f < h; ) {
      const y = i[f++], p = i[f++];
      try {
        _ = y(_);
      } catch (g) {
        p.call(this, g);
        break;
      }
    }
    try {
      c = Sr.call(this, _);
    } catch (y) {
      return Promise.reject(y);
    }
    for (f = 0, h = u.length; f < h; )
      c = c.then(u[f++], u[f++]);
    return c;
  }
  getUri(e) {
    e = fe(this.defaults, e);
    const r = ss(e.baseURL, e.url, e.allowAbsoluteUrls);
    return Qr(r, e.params, e.paramsSerializer);
  }
};
l.forEach(["delete", "get", "head", "options"], function(e) {
  Ke.prototype[e] = function(r, s) {
    return this.request(fe(s || {}, {
      method: e,
      url: r,
      data: (s || {}).data
    }));
  };
});
l.forEach(["post", "put", "patch"], function(e) {
  function r(s) {
    return function(a, o, i) {
      return this.request(fe(i || {}, {
        method: e,
        headers: s ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  Ke.prototype[e] = r(), Ke.prototype[e + "Form"] = r(!0);
});
const Ve = Ke;
class Kt {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const s = this;
    this.promise.then((n) => {
      if (!s._listeners)
        return;
      let a = s._listeners.length;
      for (; a-- > 0; )
        s._listeners[a](n);
      s._listeners = null;
    }), this.promise.then = (n) => {
      let a;
      const o = new Promise((i) => {
        s.subscribe(i), a = i;
      }).then(n);
      return o.cancel = function() {
        s.unsubscribe(a);
      }, o;
    }, e(function(a, o, i) {
      s.reason || (s.reason = new xe(a, o, i), r(s.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), r = (s) => {
      e.abort(s);
    };
    return this.subscribe(r), e.signal.unsubscribe = () => this.unsubscribe(r), e.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Kt(function(n) {
        e = n;
      }),
      cancel: e
    };
  }
}
const Ia = Kt;
function $a(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function xa(t) {
  return l.isObject(t) && t.isAxiosError === !0;
}
const bt = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(bt).forEach(([t, e]) => {
  bt[e] = t;
});
const Ta = bt;
function cs(t) {
  const e = new Ve(t), r = Br(Ve.prototype.request, e);
  return l.extend(r, Ve.prototype, e, { allOwnKeys: !0 }), l.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(n) {
    return cs(fe(t, n));
  }, r;
}
const C = cs(Gt);
C.Axios = Ve;
C.CanceledError = xe;
C.CancelToken = Ia;
C.isCancel = ts;
C.VERSION = is;
C.toFormData = ot;
C.AxiosError = $;
C.Cancel = C.CanceledError;
C.all = function(e) {
  return Promise.all(e);
};
C.spread = $a;
C.isAxiosError = xa;
C.mergeConfig = fe;
C.AxiosHeaders = M;
C.formToJSON = (t) => es(l.isHTMLForm(t) ? new FormData(t) : t);
C.getAdapter = os.getAdapter;
C.HttpStatusCode = Ta;
C.default = C;
const Xt = C;
var Sa = Symbol("cache-parser");
function Rr(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, s = new Array(e); r < e; r++)
    s[r] = t[r];
  return s;
}
function me(t) {
  return (typeof t == "string" || typeof t == "number") && (t = Number(t)) >= 0 && t < 1 / 0;
}
function W(t) {
  return t === !0 || typeof t == "number" || typeof t == "string" && t !== "false";
}
var pe = Number;
function us(t) {
  var e = Object.defineProperty({}, Sa, { enumerable: !1, value: 1 });
  if (!t || typeof t != "string")
    return e;
  var r = function(u) {
    for (var c, f = {}, h = function(p, g) {
      var A = typeof Symbol < "u" && p[Symbol.iterator] || p["@@iterator"];
      if (A)
        return (A = A.call(p)).next.bind(A);
      if (Array.isArray(p) || (A = function(R, N) {
        if (R) {
          if (typeof R == "string")
            return Rr(R, N);
          var P = Object.prototype.toString.call(R).slice(8, -1);
          return P === "Object" && R.constructor && (P = R.constructor.name), P === "Map" || P === "Set" ? Array.from(R) : P === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(P) ? Rr(R, N) : void 0;
        }
      }(p))) {
        A && (p = A);
        var U = 0;
        return function() {
          return U >= p.length ? { done: !0 } : { done: !1, value: p[U++] };
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }(u.toLowerCase().replace(/\s+/g, "").split(",")); !(c = h()).done; ) {
      var _, y = c.value.split("=", 2);
      f[y[0]] = (_ = y[1]) == null || _;
    }
    return f;
  }(t), s = r["max-age"], n = r["max-stale"], a = r["min-fresh"], o = r["s-maxage"], i = r["stale-if-error"], d = r["stale-while-revalidate"];
  return W(r.immutable) && (e.immutable = !0), me(s) && (e.maxAge = pe(s)), me(n) && (e.maxStale = pe(n)), me(a) && (e.minFresh = pe(a)), W(r["must-revalidate"]) && (e.mustRevalidate = !0), W(r["must-understand"]) && (e.mustUnderstand = !0), W(r["no-cache"]) && (e.noCache = !0), W(r["no-store"]) && (e.noStore = !0), W(r["no-transform"]) && (e.noTransform = !0), W(r["only-if-cached"]) && (e.onlyIfCached = !0), W(r.private) && (e.private = !0), W(r["proxy-revalidate"]) && (e.proxyRevalidate = !0), W(r.public) && (e.public = !0), me(o) && (e.sMaxAge = pe(o)), me(i) && (e.staleIfError = pe(i)), me(d) && (e.staleWhileRevalidate = pe(d)), e;
}
var Aa = Symbol();
function Ra() {
  var t, e, r = new Promise(function(s, n) {
    t = s, e = n;
  });
  return r.resolve = t, r.reject = e, r[Aa] = 1, r;
}
function Ea(t, e) {
  return t > e ? 1 : -1;
}
function We(t, e) {
  var r = 5381;
  if (typeof t == "object" && t !== null && (t.toString === Object.prototype.toString || t.toString === Array.prototype.toString)) {
    e || (e = /* @__PURE__ */ new WeakSet());
    for (var s = Object.keys(t).sort(Ea), n = 0; n < s.length; n++) {
      var a = s[n], o = t[a];
      if (r = 33 * r ^ We(a, e), typeof o == "object" && o !== null && (t.toString === Object.prototype.toString || t.toString === Array.prototype.toString)) {
        if (e.has(o))
          continue;
        e.add(o);
      }
      r = 33 * r ^ We(o, e);
    }
    return 33 * r ^ We(t.constructor, e);
  }
  var i = typeof t;
  try {
    t instanceof Date ? i += t.getTime() : i += String(t);
  } catch {
    i += String(Object.assign({}, t));
  }
  for (var d = 0; d < i.length; d++)
    r = 33 * r ^ i.charCodeAt(d);
  return r;
}
/*!
 * Axios Cache Interceptor 1.8.0
 * (c) 2021-present Arthur Fiorette & Contributors
 * Released under the MIT License.
 */
const O = Object.freeze({
  /**
   * ```txt
   * If-Modified-Since: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-Modified-Since
   */
  IfModifiedSince: "if-modified-since",
  /**
   * ```txt
   * Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Last-Modified
   */
  LastModified: "last-modified",
  /**
   * ```txt
   * If-None-Match: "<etag_value>"
   * If-None-Match: "<etag_value>", "<etag_value>", …
   * If-None-Match: *
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/If-None-Match
   */
  IfNoneMatch: "if-none-match",
  /**
   * ```txt
   * Cache-Control: max-age=604800
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control
   */
  CacheControl: "cache-control",
  /**
   * ```txt
   * Pragma: no - cache;
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Pragma
   */
  Pragma: "pragma",
  /**
   * ```txt
   * ETag: W / '<etag_value>';
   * ETag: '<etag_value>';
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/ETag
   */
  ETag: "etag",
  /**
   * ```txt
   * Expires: <http-date>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Expires
   */
  Expires: "expires",
  /**
   * ```txt
   * Age: <delta-seconds>
   * ```
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Age
   */
  Age: "age",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state Contains a string of ASCII characters that can be used as ETag for
   * `If-Match` header Provided by user using `cache.etag` value.
   *
   * ```txt
   * X-Axios-Cache-Etag: "<etag_value>"
   * ```
   */
  XAxiosCacheEtag: "x-axios-cache-etag",
  /**
   * Used internally as metadata to mark the cache item as revalidatable and enabling
   * stale cache state may contain `'use-cache-timestamp'` if `cache.modifiedSince` is
   * `true`, otherwise will contain a date from `cache.modifiedSince`. If a date is
   * provided, it can be used for `If-Modified-Since` header, otherwise the cache
   * timestamp can be used for `If-Modified-Since` header.
   *
   * ```txt
   * X-Axios-Cache-Last-Modified: <day-name>, <day> <month> <year> <hour>:<minute>:<second> GMT
   * X-Axios-Cache-Last-Modified: use-cache-timestamp
   * ```
   */
  XAxiosCacheLastModified: "x-axios-cache-last-modified",
  /**
   * Used internally as metadata to mark the cache item able to be used if the server
   * returns an error. The stale-if-error response directive indicates that the cache can
   * reuse a stale response when any error occurs.
   *
   * ```txt
   * XAxiosCacheStaleIfError: <seconds>
   * ```
   */
  XAxiosCacheStaleIfError: "x-axios-cache-stale-if-error"
}), Ca = (t, e) => {
  if (!t)
    return "not enough headers";
  const r = t[O.CacheControl];
  if (r) {
    const n = us(String(r));
    if (
      // Header told that this response should not be cached.
      n.noCache || n.noStore || // Server side handling private data
      e === "server" && n.private
    )
      return "dont cache";
    if (n.immutable)
      return {
        cache: 1e3 * 60 * 60 * 24 * 365
      };
    if (n.maxAge !== void 0) {
      const a = t[O.Age];
      return {
        cache: a ? (
          // If age is present, we must subtract it from maxAge
          (n.maxAge - Number(a)) * 1e3
        ) : n.maxAge * 1e3,
        // Already out of date, must be requested again
        stale: (
          // I couldn't find any documentation about who should be used, as they
          // are not meant to overlap each other. But, as we cannot request in the
          // background, as the stale-while-revalidate says, and we just increase
          // its staleTtl when its present, max-stale is being preferred over
          // stale-while-revalidate.
          n.maxStale !== void 0 ? n.maxStale * 1e3 : n.staleWhileRevalidate !== void 0 ? n.staleWhileRevalidate * 1e3 : void 0
        )
      };
    }
  }
  const s = t[O.Expires];
  if (s) {
    const n = Date.parse(String(s)) - Date.now();
    return n >= 0 ? {
      cache: n
    } : "dont cache";
  }
  return "not enough headers";
};
function Ce() {
  return Ce = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, Ce.apply(this, arguments);
}
async function Oa(t, e) {
  if (typeof e == "function")
    return e(t);
  const {
    statusCheck: r,
    responseMatch: s,
    containsHeaders: n
  } = e;
  if (r && !await r(t.status) || s && !await s(t))
    return !1;
  if (n)
    for (const [o, i] of Object.entries(n)) {
      var a;
      if (!await i(
        // Avoid bugs in case the header is not in lower case
        (a = t.headers[o.toLowerCase()]) != null ? a : t.headers[o]
      ))
        return !1;
    }
  return !0;
}
function Er(t, e) {
  return t instanceof RegExp ? (t.lastIndex = 0, t.test(e)) : e.includes(t);
}
function Pa(t) {
  return t ? (e) => t(e) || e === 304 : (e) => e >= 200 && e < 300 || e === 304;
}
function wt(t = "get", e = []) {
  return t = t.toLowerCase(), e.some((r) => r === t);
}
function Na(t, e) {
  e.headers || (e.headers = {});
  const {
    etag: r,
    modifiedSince: s
  } = e.cache;
  if (r) {
    var n;
    const a = r === !0 ? (n = t.data) == null ? void 0 : n.headers[O.ETag] : r;
    a && (e.headers[O.IfNoneMatch] = a);
  }
  s && (e.headers[O.IfModifiedSince] = s === !0 ? (
    // If last-modified is not present, use the createdAt timestamp
    t.data.headers[O.LastModified] || new Date(t.createdAt).toUTCString()
  ) : s.toUTCString());
}
function Da(t, e) {
  return t.status === 304 && e ? (t.cached = !0, t.data = e.data, t.status = e.status, t.statusText = e.statusText, t.headers = Ce({}, e.headers, t.headers), e) : {
    data: t.data,
    status: t.status,
    statusText: t.statusText,
    headers: t.headers
  };
}
function ja(t) {
  const e = async (r) => {
    if (r.id = t.generateKey(r), r.cache === !1)
      return r;
    if (r.cache = Ce({}, t.defaults.cache, r.cache), typeof r.cache.cachePredicate == "object" && r.cache.cachePredicate.ignoreUrls && r.url) {
      for (const p of r.cache.cachePredicate.ignoreUrls)
        if (Er(p, r.url))
          return r;
    }
    if (typeof r.cache.cachePredicate == "object" && r.cache.cachePredicate.allowUrls && r.url) {
      let p = !1;
      for (const g of r.cache.cachePredicate.allowUrls)
        if (Er(g, r.url)) {
          p = !0;
          break;
        }
      if (!p)
        return r;
    }
    if (r.cache.cacheTakeover) {
      var s, n, a, o, i, d, u, c, f;
      (a = (s = r.headers)[n = O.CacheControl]) != null || (s[n] = "no-cache"), (d = (o = r.headers)[i = O.Pragma]) != null || (o[i] = "no-cache"), (f = (u = r.headers)[c = O.Expires]) != null || (u[c] = "0");
    }
    if (!wt(r.method, r.cache.methods))
      return r;
    let h = await t.storage.get(r.id, r);
    const _ = r.cache.override;
    e:
      if (h.state === "empty" || h.state === "stale" || h.state === "must-revalidate" || _) {
        if (t.waiting.has(r.id) && !_ && (h = await t.storage.get(r.id, r), h.state !== "empty" && h.state !== "must-revalidate"))
          break e;
        const p = Ra();
        return t.waiting.set(r.id, p), p.catch(() => {
        }), await t.storage.set(r.id, {
          state: "loading",
          previous: _ ? (
            // Simply determine if the request is stale or not
            // based if it had previous data or not
            h.data ? "stale" : "empty"
          ) : (
            // Typescript doesn't know that cache.state here can only be 'empty' or 'stale'
            h.state
          ),
          data: h.data,
          // If the cache is empty and asked to override it, use the current timestamp
          createdAt: _ && !h.createdAt ? Date.now() : h.createdAt
        }, r), (h.state === "stale" || h.state === "must-revalidate") && Na(h, r), r.validateStatus = Pa(r.validateStatus), (h.state === "stale" || h.data && h.state !== "must-revalidate") && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(h)), r;
      }
    let y;
    if (h.state === "loading") {
      const p = t.waiting.get(r.id);
      if (!p)
        return h.data && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(h)), r;
      try {
        await p;
        const g = await t.storage.get(r.id, r);
        if (!g.data)
          return e(r);
        y = g.data;
      } catch {
        return h.data && await (r.cache.hydrate == null ? void 0 : r.cache.hydrate(h)), e(r);
      }
    } else
      y = h.data;
    return r.transformResponse = void 0, r.adapter = function() {
      return Promise.resolve({
        config: r,
        data: y.data,
        headers: y.headers,
        status: y.status,
        statusText: y.statusText,
        cached: !0,
        stale: h.previous === "stale",
        id: r.id
      });
    }, r;
  };
  return {
    onFulfilled: e
  };
}
async function Ua(t, e, r) {
  if (typeof r == "function")
    return r(e);
  for (const [s, n] of Object.entries(r)) {
    if (n === "delete") {
      await t.remove(s, e.config);
      continue;
    }
    const a = await t.get(s, e.config);
    if (a.state === "loading")
      continue;
    const o = await n(a, e);
    if (o === "delete") {
      await t.remove(s, e.config);
      continue;
    }
    o !== "ignore" && await t.set(s, o, e.config);
  }
}
function La(t) {
  const e = async (n, a, o) => {
    o && await t.storage.remove(n, a);
    const i = t.waiting.get(n);
    i && (i.reject(), t.waiting.delete(n));
  };
  return {
    onFulfilled: async (n) => {
      var a;
      if (!(n != null && n.config))
        throw n;
      n.id = n.config.id, (a = n.cached) != null || (n.cached = !1);
      const o = n.config, i = o.cache;
      if (n.cached)
        return n;
      if (!i)
        return n.cached = !1, n;
      if (i.update && await Ua(t.storage, n, i.update), !wt(o.method, i.methods))
        return n;
      const d = await t.storage.get(n.id, o);
      if (
        // If the request interceptor had a problem or it wasn't cached
        d.state !== "loading"
      )
        return n;
      if (
        // For 'loading' values (previous: stale), this check already ran in the past.
        !d.data && !await Oa(n, i.cachePredicate)
      )
        return await e(n.id, o, !0), n;
      for (const y of Object.keys(n.headers))
        y.startsWith("x-axios-cache") && delete n.headers[y];
      i.etag && i.etag !== !0 && (n.headers[O.XAxiosCacheEtag] = i.etag), i.modifiedSince && (n.headers[O.XAxiosCacheLastModified] = i.modifiedSince === !0 ? "use-cache-timestamp" : i.modifiedSince.toUTCString());
      let u = i.ttl || -1, c;
      if (i.interpretHeader) {
        const y = t.headerInterpreter(n.headers, t.location);
        if (y === "dont cache")
          return await e(n.id, o, !0), n;
        y !== "not enough headers" && (typeof y == "number" ? u = y : (u = y.cache, c = y.stale));
      }
      const f = Da(n, d.data);
      typeof u == "function" && (u = await u(n)), i.staleIfError && (n.headers[O.XAxiosCacheStaleIfError] = String(u));
      const h = {
        state: "cached",
        ttl: u,
        staleTtl: c,
        createdAt: Date.now(),
        data: f
      };
      await t.storage.set(n.id, h, o);
      const _ = t.waiting.get(n.id);
      return _ && (_.resolve(), t.waiting.delete(n.id)), n;
    },
    onRejected: async (n) => {
      if (!n.isAxiosError || !n.config)
        throw n;
      const a = n.config, o = a.id, i = a.cache, d = n.response;
      if (!i || !o)
        throw n;
      if (!wt(a.method, i.methods))
        throw await e(o, a, !0), n;
      const u = await t.storage.get(o, a);
      if (
        // This will only not be loading if the interceptor broke
        u.state !== "loading" || u.previous !== "stale"
      )
        throw await e(
          o,
          a,
          // Do not clear cache if this request is cached, but the request was cancelled before returning the cached response
          n.code !== "ERR_CANCELED" || n.code === "ERR_CANCELED" && u.state !== "cached"
        ), n;
      if (i.staleIfError) {
        const c = String(d == null ? void 0 : d.headers[O.CacheControl]), f = c && us(c).staleIfError, h = typeof i.staleIfError == "function" ? await i.staleIfError(d, u, n) : i.staleIfError === !0 && f ? f * 1e3 : i.staleIfError;
        if (h === !0 || // staleIfError is the number of seconds that stale is allowed to be used
        typeof h == "number" && u.createdAt + h > Date.now()) {
          await t.storage.set(o, {
            state: "stale",
            createdAt: Date.now(),
            data: u.data
          }, a);
          const _ = t.waiting.get(o);
          return _ && (_.resolve(), t.waiting.delete(o)), {
            cached: !0,
            stale: !0,
            config: a,
            id: o,
            data: u.data.data,
            headers: u.data.headers,
            status: u.data.status,
            statusText: u.data.statusText
          };
        }
      }
      throw await e(o, a, !0), n;
    }
  };
}
const Ba = (t) => !!t && !!t["is-storage"];
function ds(t) {
  const e = t.data.headers;
  return O.ETag in e || O.LastModified in e || O.XAxiosCacheEtag in e || O.XAxiosCacheLastModified in e;
}
function Ha(t) {
  return String(t.data.headers[O.CacheControl]).includes("must-revalidate");
}
function ls(t) {
  return ds(t) ? !0 : t.state === "cached" && t.staleTtl !== void 0 && // Only allow stale values after the ttl is already in the past and the staleTtl is in the future.
  // In cases that just createdAt + ttl > Date.now(), isn't enough because the staleTtl could be <= 0.
  // This logic only returns true when Date.now() is between the (createdAt + ttl) and (createdAt + ttl + staleTtl).
  // Following the example below:
  // |--createdAt--:--ttl--:---staleTtl--->
  // [        past        ][now is in here]
  Math.abs(Date.now() - (t.createdAt + t.ttl)) <= t.staleTtl;
}
function kt(t) {
  return t.ttl !== void 0 && t.createdAt + t.ttl <= Date.now();
}
function Fa({
  set: t,
  find: e,
  remove: r,
  clear: s
}) {
  return {
    //@ts-expect-error - we don't want to expose this
    "is-storage": 1,
    set: t,
    remove: r,
    clear: s,
    get: async (n, a) => {
      let o = await e(n, a);
      if (!o)
        return {
          state: "empty"
        };
      if (o.state === "empty" || o.state === "loading" || o.state === "must-revalidate")
        return o;
      if (o.state === "cached") {
        if (!kt(o))
          return o;
        if (!ls(o))
          return await r(n, a), {
            state: "empty"
          };
        if (o = {
          state: "stale",
          createdAt: o.createdAt,
          data: o.data,
          ttl: o.staleTtl !== void 0 ? o.staleTtl + o.ttl : void 0
        }, await t(n, o, a), Ha(o))
          return Ce({}, o, {
            state: "must-revalidate"
          });
      }
      return !kt(o) || ds(o) ? o : (await r(n, a), {
        state: "empty"
      });
    }
  };
}
const Cr = (
  // https://caniuse.com/mdn-api_structuredclone (10/18/2023 92.51%)
  typeof structuredClone == "function" ? structuredClone : (t) => JSON.parse(JSON.stringify(t))
);
function Ma(t = !1, e = !1, r = !1) {
  const s = Fa({
    set: (n, a) => {
      if (r) {
        let o = Object.keys(s.data);
        if (o.length >= r)
          for (s.cleanup(), o = Object.keys(s.data); o.length >= r; )
            delete s.data[o.shift()];
      }
      s.data[n] = t === "double" ? Cr(a) : a;
    },
    remove: (n) => {
      delete s.data[n];
    },
    find: (n) => {
      const a = s.data[n];
      return t && a !== void 0 ? Cr(a) : a;
    },
    clear: () => {
      s.data = /* @__PURE__ */ Object.create(null);
    }
  });
  return s.data = /* @__PURE__ */ Object.create(null), s.cleanup = () => {
    const n = Object.keys(s.data);
    let a = -1, o, i;
    for (; ++a < n.length; ) {
      if (i = n[a], o = s.data[i], o.state === "empty") {
        s.remove(i);
        continue;
      }
      o.state === "cached" && kt(o) && !ls(o) && s.remove(i);
    }
  }, e && (s.cleaner = setInterval(s.cleanup, e)), s;
}
const Or = /^\/|\/$/g;
function Za(t) {
  return (e) => {
    if (e.id)
      return e.id;
    const r = t(e);
    return typeof r == "string" || typeof r == "number" ? `${r}` : `${We(r)}`;
  };
}
const za = Za(({
  baseURL: t,
  url: e,
  method: r,
  params: s,
  data: n
}) => (t !== void 0 ? t = t.replace(Or, "") : t = "", e !== void 0 ? e = e.replace(Or, "") : e = "", r !== void 0 ? r = r.toLowerCase() : r = "get", {
  url: t + (t && e ? "/" : "") + e,
  params: s,
  method: r,
  data: n
}));
function fs(t, e = {}) {
  var r, s, n, a, o, i, d, u;
  const c = t;
  if (c.defaults.cache)
    throw new Error("setupCache() should be called only once");
  if (c.location = typeof window > "u" ? "server" : "client", c.storage = e.storage || Ma(), !Ba(c.storage))
    throw new Error("Use buildStorage() function");
  return c.waiting = e.waiting || /* @__PURE__ */ new Map(), c.generateKey = e.generateKey || za, c.headerInterpreter = e.headerInterpreter || Ca, c.requestInterceptor = e.requestInterceptor || ja(c), c.responseInterceptor = e.responseInterceptor || La(c), c.debug = e.debug || function() {
  }, c.defaults.cache = {
    update: e.update || {},
    ttl: (r = e.ttl) != null ? r : 1e3 * 60 * 5,
    // Although RFC 7231 also marks POST as cacheable, most users don't know that
    // and may have problems about why their "create X" route not working.
    methods: e.methods || ["get", "head"],
    cachePredicate: e.cachePredicate || {
      // All cacheable status codes defined in RFC 7231
      statusCheck: (f) => [200, 203, 300, 301, 302, 404, 405, 410, 414, 501].includes(f)
    },
    etag: (s = e.etag) != null ? s : !0,
    // This option is going to be ignored by servers when ETag is enabled
    // Checks strict equality to false to avoid undefined-ish values
    modifiedSince: (n = e.modifiedSince) != null ? n : e.etag === !1,
    interpretHeader: (a = e.interpretHeader) != null ? a : !0,
    cacheTakeover: (o = e.cacheTakeover) != null ? o : !0,
    staleIfError: (i = e.staleIfError) != null ? i : !0,
    override: (d = e.override) != null ? d : !1,
    hydrate: (u = e.hydrate) != null ? u : void 0
  }, c.interceptors.request.use(c.requestInterceptor.onFulfilled, c.requestInterceptor.onRejected), c.interceptors.response.use(c.responseInterceptor.onFulfilled, c.responseInterceptor.onRejected), c;
}
const ys = {
  "access-token": "",
  client: "",
  uid: ""
}, Va = ({
  apiUrl: t,
  getDeviceUniqueId: e,
  interceptors: r,
  locale: s,
  source: n,
  storageClient: a
}) => {
  const o = `${t}/${s}/api/`, i = fs(
    Xt.create({
      baseURL: `${o}`,
      headers: { ...ys }
    })
  ), d = async (f) => {
    if (f && f.headers && f.headers["access-token"]) {
      const h = {
        accessToken: f.headers["access-token"],
        client: f.headers.client,
        uid: f.headers.uid,
        httpSource: n
      };
      a == null || a.setItem("headers", JSON.stringify(h));
    }
  }, u = (f) => {
    f.interceptors.response.use(
      function(h) {
        var _, y, p, g;
        return d(h), Array.isArray(r == null ? void 0 : r.response) && (r == null || r.response.forEach((A) => A(h))), (_ = h.data) != null && _.data || (y = h.data) != null && y.success ? {
          ...h.data,
          headers: h.headers,
          included: (p = h.data) == null ? void 0 : p.included
        } : {
          data: h.data,
          headers: h.headers,
          included: (g = h.data) == null ? void 0 : g.included
        };
      },
      (h) => (h.response && d(h.response), Promise.reject(h))
    );
  };
  return ((f) => {
    f.interceptors.request.use(
      async function(h) {
        const _ = await (a == null ? void 0 : a.getItem("headers"));
        return _ && (h.headers["access-token"] = JSON.parse(_).accessToken, h.headers.client = JSON.parse(_).client, h.headers.uid = JSON.parse(_).uid, h.headers.httpSource = JSON.parse(_).httpSource), e && (h.headers.deviceIdentifier = await e()), h;
      },
      (h) => Promise.reject(h)
    );
  })(i), u(i), i;
}, Wa = ({ apiUrl: t }) => {
  const e = `${t}/api/`;
  return Xt.create({
    baseURL: `${e}`,
    headers: ys
  });
}, Ae = ({ apiUrl: t }) => {
  const e = `${t}/`;
  return fs(
    Xt.create({
      baseURL: e,
      headers: {
        "Content-Type": "application/json"
      }
    })
  );
}, Re = {
  lc: (t) => Va(t),
  mindee: (t) => Ae(t),
  ipLocation: (t) => Ae(t),
  sharegroop: (t) => Ae(t),
  strapiAdmin: (t) => Wa(t),
  hubspot: (t) => Ae(t),
  mapbox: (t) => Ae(t)
}, oe = ({
  api: t,
  locale: e,
  storageClient: r,
  unserialized: s = !1
}) => {
  const n = {
    apiUrl: t.url,
    interceptors: t.interceptors,
    locale: e,
    storageClient: r,
    source: t.source,
    getDeviceUniqueId: t.getDeviceUniqueId
  };
  return {
    get: async (a, o) => {
      try {
        const i = await Re[t.name](n).get(a, o);
        return o != null && o.responseType ? Promise.resolve(i) : s ? t.name === "strapiAdmin" ? Promise.resolve(i.data) : Promise.resolve(i) : Promise.resolve(
          ne(i)
        );
      } catch (i) {
        return Promise.resolve({
          errors: i
        });
      }
    },
    post: async (a, o, i) => {
      try {
        const d = await Re[t.name](n).post(
          a,
          o,
          i
        );
        return s ? Promise.resolve(d) : Promise.resolve(ne(d));
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    put: async (a, o, i) => {
      try {
        const d = await Re[t.name](n).put(
          a,
          o,
          i
        );
        return s ? Promise.resolve(d) : Promise.resolve(ne(d));
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    delete: async (a) => {
      try {
        const o = await Re[t.name](n).delete(a);
        return s ? Promise.resolve(o) : Promise.resolve(ne(o));
      } catch (o) {
        return Promise.resolve({
          errors: o
        });
      }
    },
    raw: async (a, o) => {
      const i = await Re[t.name](n).request({
        url: a,
        method: "GET",
        ...o,
        responseType: o.responseType.toLowerCase()
      });
      return {
        headers: new Headers(Object.entries(i.headers)),
        _data: i.data
      };
    }
  };
}, Ga = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, Ja = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, Ka = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function Xa(t, e) {
  if (t === "__proto__" || t === "constructor" && e && typeof e == "object" && "prototype" in e) {
    Qa(t);
    return;
  }
  return e;
}
function Qa(t) {
  console.warn(`[destr] Dropping "${t}" key to prevent prototype pollution.`);
}
function Ya(t, e = {}) {
  if (typeof t != "string")
    return t;
  if (t[0] === '"' && t[t.length - 1] === '"' && t.indexOf("\\") === -1)
    return t.slice(1, -1);
  const r = t.trim();
  if (r.length <= 9)
    switch (r.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!Ka.test(t)) {
    if (e.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return t;
  }
  try {
    if (Ga.test(t) || Ja.test(t)) {
      if (e.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(t, Xa);
    }
    return JSON.parse(t);
  } catch (s) {
    if (e.strict)
      throw s;
    return t;
  }
}
const eo = /#/g, to = /&/g, ro = /\//g, so = /=/g, Qt = /\+/g, no = /%5e/gi, ao = /%60/gi, oo = /%7c/gi, io = /%20/gi;
function co(t) {
  return encodeURI("" + t).replace(oo, "|");
}
function It(t) {
  return co(typeof t == "string" ? t : JSON.stringify(t)).replace(Qt, "%2B").replace(io, "+").replace(eo, "%23").replace(to, "%26").replace(ao, "`").replace(no, "^").replace(ro, "%2F");
}
function ht(t) {
  return It(t).replace(so, "%3D");
}
function hs(t = "") {
  try {
    return decodeURIComponent("" + t);
  } catch {
    return "" + t;
  }
}
function uo(t) {
  return hs(t.replace(Qt, " "));
}
function lo(t) {
  return hs(t.replace(Qt, " "));
}
function fo(t = "") {
  const e = /* @__PURE__ */ Object.create(null);
  t[0] === "?" && (t = t.slice(1));
  for (const r of t.split("&")) {
    const s = r.match(/([^=]+)=?(.*)/) || [];
    if (s.length < 2)
      continue;
    const n = uo(s[1]);
    if (n === "__proto__" || n === "constructor")
      continue;
    const a = lo(s[2] || "");
    e[n] === void 0 ? e[n] = a : Array.isArray(e[n]) ? e[n].push(a) : e[n] = [e[n], a];
  }
  return e;
}
function yo(t, e) {
  return (typeof e == "number" || typeof e == "boolean") && (e = String(e)), e ? Array.isArray(e) ? e.map(
    (r) => `${ht(t)}=${It(r)}`
  ).join("&") : `${ht(t)}=${It(e)}` : ht(t);
}
function ho(t) {
  return Object.keys(t).filter((e) => t[e] !== void 0).map((e) => yo(e, t[e])).filter(Boolean).join("&");
}
const mo = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, po = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, go = /^([/\\]\s*){2,}[^/\\]/, vo = /\/$|\/\?|\/#/, _o = /^\.?\//;
function ms(t, e = {}) {
  return typeof e == "boolean" && (e = { acceptRelative: e }), e.strict ? mo.test(t) : po.test(t) || (e.acceptRelative ? go.test(t) : !1);
}
function $t(t = "", e) {
  return e ? vo.test(t) : t.endsWith("/");
}
function qo(t = "", e) {
  if (!e)
    return ($t(t) ? t.slice(0, -1) : t) || "/";
  if (!$t(t, !0))
    return t || "/";
  let r = t, s = "";
  const n = t.indexOf("#");
  n !== -1 && (r = t.slice(0, n), s = t.slice(n));
  const [a, ...o] = r.split("?");
  return ((a.endsWith("/") ? a.slice(0, -1) : a) || "/") + (o.length > 0 ? `?${o.join("?")}` : "") + s;
}
function bo(t = "", e) {
  if (!e)
    return t.endsWith("/") ? t : t + "/";
  if ($t(t, !0))
    return t || "/";
  let r = t, s = "";
  const n = t.indexOf("#");
  if (n !== -1 && (r = t.slice(0, n), s = t.slice(n), !r))
    return s;
  const [a, ...o] = r.split("?");
  return a + "/" + (o.length > 0 ? `?${o.join("?")}` : "") + s;
}
function wo(t, e) {
  if (Io(e) || ms(t))
    return t;
  const r = qo(e);
  return t.startsWith(r) ? t : xo(r, t);
}
function ko(t, e) {
  const r = gs(t), s = { ...fo(r.search), ...e };
  return r.search = ho(s), To(r);
}
function Io(t) {
  return !t || t === "/";
}
function $o(t) {
  return t && t !== "/";
}
function xo(t, ...e) {
  let r = t || "";
  for (const s of e.filter((n) => $o(n)))
    if (r) {
      const n = s.replace(_o, "");
      r = bo(r) + n;
    } else
      r = s;
  return r;
}
const ps = Symbol.for("ufo:protocolRelative");
function gs(t = "", e) {
  const r = t.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (r) {
    const [, f, h = ""] = r;
    return {
      protocol: f.toLowerCase(),
      pathname: h,
      href: f + h,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!ms(t, { acceptRelative: !0 }))
    return e ? gs(e + t) : Pr(t);
  const [, s = "", n, a = ""] = t.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, o = "", i = ""] = a.match(/([^#/?]*)(.*)?/) || [];
  s === "file:" && (i = i.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: d, search: u, hash: c } = Pr(i);
  return {
    protocol: s.toLowerCase(),
    auth: n ? n.slice(0, Math.max(0, n.length - 1)) : "",
    host: o,
    pathname: d,
    search: u,
    hash: c,
    [ps]: !s
  };
}
function Pr(t = "") {
  const [e = "", r = "", s = ""] = (t.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: e,
    search: r,
    hash: s
  };
}
function To(t) {
  const e = t.pathname || "", r = t.search ? (t.search.startsWith("?") ? "" : "?") + t.search : "", s = t.hash || "", n = t.auth ? t.auth + "@" : "", a = t.host || "";
  return (t.protocol || t[ps] ? (t.protocol || "") + "//" : "") + n + a + e + r + s;
}
class So extends Error {
  constructor(e, r) {
    super(e, r), this.name = "FetchError", r != null && r.cause && !this.cause && (this.cause = r.cause);
  }
}
function Ao(t) {
  var d, u, c, f, h;
  const e = ((d = t.error) == null ? void 0 : d.message) || ((u = t.error) == null ? void 0 : u.toString()) || "", r = ((c = t.request) == null ? void 0 : c.method) || ((f = t.options) == null ? void 0 : f.method) || "GET", s = ((h = t.request) == null ? void 0 : h.url) || String(t.request) || "/", n = `[${r}] ${JSON.stringify(s)}`, a = t.response ? `${t.response.status} ${t.response.statusText}` : "<no response>", o = `${n}: ${a}${e ? ` ${e}` : ""}`, i = new So(
    o,
    t.error ? { cause: t.error } : void 0
  );
  for (const _ of ["request", "options", "response"])
    Object.defineProperty(i, _, {
      get() {
        return t[_];
      }
    });
  for (const [_, y] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(i, _, {
      get() {
        return t.response && t.response[y];
      }
    });
  return i;
}
const Ro = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function Nr(t = "GET") {
  return Ro.has(t.toUpperCase());
}
function Eo(t) {
  if (t === void 0)
    return !1;
  const e = typeof t;
  return e === "string" || e === "number" || e === "boolean" || e === null ? !0 : e !== "object" ? !1 : Array.isArray(t) ? !0 : t.buffer ? !1 : t.constructor && t.constructor.name === "Object" || typeof t.toJSON == "function";
}
const Co = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), Oo = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function Po(t = "") {
  if (!t)
    return "json";
  const e = t.split(";").shift() || "";
  return Oo.test(e) ? "json" : Co.has(e) || e.startsWith("text/") ? "text" : "blob";
}
function No(t, e, r, s) {
  const n = Do(
    (e == null ? void 0 : e.headers) ?? (t == null ? void 0 : t.headers),
    r == null ? void 0 : r.headers,
    s
  );
  let a;
  return (r != null && r.query || r != null && r.params || e != null && e.params || e != null && e.query) && (a = {
    ...r == null ? void 0 : r.params,
    ...r == null ? void 0 : r.query,
    ...e == null ? void 0 : e.params,
    ...e == null ? void 0 : e.query
  }), {
    ...r,
    ...e,
    query: a,
    params: a,
    headers: n
  };
}
function Do(t, e, r) {
  if (!e)
    return new r(t);
  const s = new r(e);
  if (t)
    for (const [n, a] of Symbol.iterator in t || Array.isArray(t) ? t : new r(t))
      s.set(n, a);
  return s;
}
async function Fe(t, e) {
  if (e)
    if (Array.isArray(e))
      for (const r of e)
        await r(t);
    else
      await e(t);
}
const jo = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), Uo = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function vs(t = {}) {
  const {
    fetch: e = globalThis.fetch,
    Headers: r = globalThis.Headers,
    AbortController: s = globalThis.AbortController
  } = t;
  async function n(i) {
    const d = i.error && i.error.name === "AbortError" && !i.options.timeout || !1;
    if (i.options.retry !== !1 && !d) {
      let c;
      typeof i.options.retry == "number" ? c = i.options.retry : c = Nr(i.options.method) ? 0 : 1;
      const f = i.response && i.response.status || 500;
      if (c > 0 && (Array.isArray(i.options.retryStatusCodes) ? i.options.retryStatusCodes.includes(f) : jo.has(f))) {
        const h = typeof i.options.retryDelay == "function" ? i.options.retryDelay(i) : i.options.retryDelay || 0;
        return h > 0 && await new Promise((_) => setTimeout(_, h)), a(i.request, {
          ...i.options,
          retry: c - 1
        });
      }
    }
    const u = Ao(i);
    throw Error.captureStackTrace && Error.captureStackTrace(u, a), u;
  }
  const a = async function(d, u = {}) {
    const c = {
      request: d,
      options: No(
        d,
        u,
        t.defaults,
        r
      ),
      response: void 0,
      error: void 0
    };
    c.options.method && (c.options.method = c.options.method.toUpperCase()), c.options.onRequest && await Fe(c, c.options.onRequest), typeof c.request == "string" && (c.options.baseURL && (c.request = wo(c.request, c.options.baseURL)), c.options.query && (c.request = ko(c.request, c.options.query), delete c.options.query), "query" in c.options && delete c.options.query, "params" in c.options && delete c.options.params), c.options.body && Nr(c.options.method) && (Eo(c.options.body) ? (c.options.body = typeof c.options.body == "string" ? c.options.body : JSON.stringify(c.options.body), c.options.headers = new r(c.options.headers || {}), c.options.headers.has("content-type") || c.options.headers.set("content-type", "application/json"), c.options.headers.has("accept") || c.options.headers.set("accept", "application/json")) : (
      // ReadableStream Body
      ("pipeTo" in c.options.body && typeof c.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof c.options.body.pipe == "function") && ("duplex" in c.options || (c.options.duplex = "half"))
    ));
    let f;
    if (!c.options.signal && c.options.timeout) {
      const _ = new s();
      f = setTimeout(() => {
        const y = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        y.name = "TimeoutError", y.code = 23, _.abort(y);
      }, c.options.timeout), c.options.signal = _.signal;
    }
    try {
      c.response = await e(
        c.request,
        c.options
      );
    } catch (_) {
      return c.error = _, c.options.onRequestError && await Fe(
        c,
        c.options.onRequestError
      ), await n(c);
    } finally {
      f && clearTimeout(f);
    }
    if ((c.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    c.response._bodyInit) && !Uo.has(c.response.status) && c.options.method !== "HEAD") {
      const _ = (c.options.parseResponse ? "json" : c.options.responseType) || Po(c.response.headers.get("content-type") || "");
      switch (_) {
        case "json": {
          const y = await c.response.text(), p = c.options.parseResponse || Ya;
          c.response._data = p(y);
          break;
        }
        case "stream": {
          c.response._data = c.response.body || c.response._bodyInit;
          break;
        }
        default:
          c.response._data = await c.response[_]();
      }
    }
    return c.options.onResponse && await Fe(
      c,
      c.options.onResponse
    ), !c.options.ignoreResponseError && c.response.status >= 400 && c.response.status < 600 ? (c.options.onResponseError && await Fe(
      c,
      c.options.onResponseError
    ), await n(c)) : c.response;
  }, o = async function(d, u) {
    return (await a(d, u))._data;
  };
  return o.raw = a, o.native = (...i) => e(...i), o.create = (i = {}, d = {}) => vs({
    ...t,
    ...d,
    defaults: {
      ...t.defaults,
      ...d.defaults,
      ...i
    }
  }), o;
}
const Xe = function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
}(), Lo = Xe.fetch ? (...t) => Xe.fetch(...t) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), Bo = Xe.Headers, Ho = Xe.AbortController, X = vs({ fetch: Lo, Headers: Bo, AbortController: Ho }), je = ({ api: t }) => {
  const e = `${t.url}/`;
  return {
    get: async (r, s) => {
      try {
        const n = await X(`${e}${r}`, {
          method: "GET",
          ...s
        });
        return s != null && s.responseType, Promise.resolve(n);
      } catch (n) {
        return Promise.resolve({
          errors: n
        });
      }
    },
    post: async (r, s, n) => {
      try {
        const a = await X(`${e}${r}`, {
          method: "POST",
          body: s,
          ...n
        });
        return Promise.resolve(a);
      } catch (a) {
        return Promise.resolve({
          errors: a
        });
      }
    },
    put: async (r, s, n) => {
      try {
        const a = await X(`${e}${r}`, {
          method: "PUT",
          body: s,
          ...n
        });
        return Promise.resolve(a);
      } catch (a) {
        return Promise.resolve({
          errors: a
        });
      }
    },
    delete: async (r) => {
      try {
        const s = await X(`${e}${r}`, {
          method: "DELETE"
        });
        return Promise.resolve(s);
      } catch (s) {
        return Promise.resolve({
          errors: s
        });
      }
    }
  };
};
class Rf {
  constructor(e) {
    this.provider = e, this.headers = {}, this.http = {}, this.apiUrl = "", this.headers = {
      headers: { Authorization: `Token ${this.provider.apiKey}` }
    }, this.apiUrl = this.provider.apiUrl, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(e) {
    const r = { name: "mindee", url: this.apiUrl };
    return e === "axios" ? oe({ api: r, unserialized: !0 }) : je({ api: r });
  }
  getPredictData(e, r) {
    return e.reduce(
      (s, n) => {
        const a = [
          "surname",
          "given_names",
          "alternate_name"
        ].includes(n);
        if (Array.isArray(r[n])) {
          const o = r[n];
          s[n] = o.filter((i) => i.value).map((i) => a ? ur(i.value) : i.value);
        } else {
          const o = r[n];
          o.value && (s[n] = a ? ur(o.value) : o.value);
        }
        return s;
      },
      {}
    );
  }
  dataFormatter(e) {
    return e.map((r) => {
      const s = Object.keys(r.prediction);
      return this.getPredictData(s, r.prediction);
    });
  }
  async verifyPassport(e) {
    const r = await this.http.post(
      "v1/products/mindee/passport/v1/predict",
      { document: e },
      this.headers
    ).then(
      (n) => typeof n.data == "object" ? n : { data: n }
    );
    return {
      data: this.dataFormatter(
        r.data.document.inference.pages
      ),
      error: r.data.api_request.error,
      status: r.data.api_request.status,
      code: r.data.api_request.status_code
    };
  }
  async verifyIdentityCard(e) {
    const r = await this.http.post(
      "v1/products/mindee/idcard_fr/v2/predict",
      { document: e },
      this.headers
    ).then(
      (n) => typeof n.data == "object" ? n : { data: n }
    );
    return {
      data: this.dataFormatter(
        r.data.document.inference.pages
      ),
      error: r.data.api_request.error,
      status: r.data.api_request.status,
      code: r.data.api_request.status_code
    };
  }
}
class Ef {
  constructor(e) {
    this.provider = e, this.http = {}, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(e) {
    const r = { name: "mapbox", url: this.provider.apiUrl };
    return e === "axios" ? oe({ api: r, unserialized: !0 }) : je({ api: r });
  }
  /** Get place(s) based on a string query */
  async forwardSearch(e, r = {}) {
    const s = Object.fromEntries(
      Object.entries(r).filter(([o, i]) => typeof i < "u").map(([o, i]) => [o, i.toString()])
    ), n = new URLSearchParams({
      access_token: this.provider.apiKey,
      autocomplete: "true",
      limit: "4",
      q: e,
      types: "country,region,places",
      ...s
    }).toString(), a = await this.http.get(`search/geocode/v6/forward?${n}`);
    if (a.errors)
      throw a.errors;
    return a.features ?? [];
  }
}
var S;
(function(t) {
  t.assertEqual = (n) => {
  };
  function e(n) {
  }
  t.assertIs = e;
  function r(n) {
    throw new Error();
  }
  t.assertNever = r, t.arrayToEnum = (n) => {
    const a = {};
    for (const o of n)
      a[o] = o;
    return a;
  }, t.getValidEnumValues = (n) => {
    const a = t.objectKeys(n).filter((i) => typeof n[n[i]] != "number"), o = {};
    for (const i of a)
      o[i] = n[i];
    return t.objectValues(o);
  }, t.objectValues = (n) => t.objectKeys(n).map(function(a) {
    return n[a];
  }), t.objectKeys = typeof Object.keys == "function" ? (n) => Object.keys(n) : (n) => {
    const a = [];
    for (const o in n)
      Object.prototype.hasOwnProperty.call(n, o) && a.push(o);
    return a;
  }, t.find = (n, a) => {
    for (const o of n)
      if (a(o))
        return o;
  }, t.isInteger = typeof Number.isInteger == "function" ? (n) => Number.isInteger(n) : (n) => typeof n == "number" && Number.isFinite(n) && Math.floor(n) === n;
  function s(n, a = " | ") {
    return n.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  t.joinValues = s, t.jsonStringifyReplacer = (n, a) => typeof a == "bigint" ? a.toString() : a;
})(S || (S = {}));
var Dr;
(function(t) {
  t.mergeShapes = (e, r) => ({
    ...e,
    ...r
    // second overwrites first
  });
})(Dr || (Dr = {}));
const q = S.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), re = (t) => {
  switch (typeof t) {
    case "undefined":
      return q.undefined;
    case "string":
      return q.string;
    case "number":
      return Number.isNaN(t) ? q.nan : q.number;
    case "boolean":
      return q.boolean;
    case "function":
      return q.function;
    case "bigint":
      return q.bigint;
    case "symbol":
      return q.symbol;
    case "object":
      return Array.isArray(t) ? q.array : t === null ? q.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? q.promise : typeof Map < "u" && t instanceof Map ? q.map : typeof Set < "u" && t instanceof Set ? q.set : typeof Date < "u" && t instanceof Date ? q.date : q.object;
    default:
      return q.unknown;
  }
}, m = S.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
class Y extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, s = { _errors: [] }, n = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(n);
        else if (o.code === "invalid_return_type")
          n(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          n(o.argumentsError);
        else if (o.path.length === 0)
          s._errors.push(r(o));
        else {
          let i = s, d = 0;
          for (; d < o.path.length; ) {
            const u = o.path[d];
            d === o.path.length - 1 ? (i[u] = i[u] || { _errors: [] }, i[u]._errors.push(r(o))) : i[u] = i[u] || { _errors: [] }, i = i[u], d++;
          }
        }
    };
    return n(this), s;
  }
  static assert(e) {
    if (!(e instanceof Y))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, S.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, s = [];
    for (const n of this.issues)
      if (n.path.length > 0) {
        const a = n.path[0];
        r[a] = r[a] || [], r[a].push(e(n));
      } else
        s.push(e(n));
    return { formErrors: s, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Y.create = (t) => new Y(t);
const Fo = (t, e) => {
  let r;
  switch (t.code) {
    case m.invalid_type:
      t.received === q.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case m.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, S.jsonStringifyReplacer)}`;
      break;
    case m.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${S.joinValues(t.keys, ", ")}`;
      break;
    case m.invalid_union:
      r = "Invalid input";
      break;
    case m.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${S.joinValues(t.options)}`;
      break;
    case m.invalid_enum_value:
      r = `Invalid enum value. Expected ${S.joinValues(t.options)}, received '${t.received}'`;
      break;
    case m.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case m.invalid_return_type:
      r = "Invalid function return type";
      break;
    case m.invalid_date:
      r = "Invalid date";
      break;
    case m.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : S.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case m.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "bigint" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case m.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case m.custom:
      r = "Invalid input";
      break;
    case m.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case m.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case m.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, S.assertNever(t);
  }
  return { message: r };
}, xt = Fo;
let Mo = xt;
function Zo() {
  return Mo;
}
const zo = (t) => {
  const { data: e, path: r, errorMaps: s, issueData: n } = t, a = [...r, ...n.path || []], o = {
    ...n,
    path: a
  };
  if (n.message !== void 0)
    return {
      ...n,
      path: a,
      message: n.message
    };
  let i = "";
  const d = s.filter((u) => !!u).slice().reverse();
  for (const u of d)
    i = u(o, { data: e, defaultError: i }).message;
  return {
    ...n,
    path: a,
    message: i
  };
};
function v(t, e) {
  const r = Zo(), s = zo({
    issueData: e,
    data: t.data,
    path: t.path,
    errorMaps: [
      t.common.contextualErrorMap,
      // contextual error map is first priority
      t.schemaErrorMap,
      // then schema-bound map if available
      r,
      // then global override map
      r === xt ? void 0 : xt
      // then global default map
    ].filter((n) => !!n)
  });
  t.common.issues.push(s);
}
class L {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, r) {
    const s = [];
    for (const n of r) {
      if (n.status === "aborted")
        return I;
      n.status === "dirty" && e.dirty(), s.push(n.value);
    }
    return { status: e.value, value: s };
  }
  static async mergeObjectAsync(e, r) {
    const s = [];
    for (const n of r) {
      const a = await n.key, o = await n.value;
      s.push({
        key: a,
        value: o
      });
    }
    return L.mergeObjectSync(e, s);
  }
  static mergeObjectSync(e, r) {
    const s = {};
    for (const n of r) {
      const { key: a, value: o } = n;
      if (a.status === "aborted" || o.status === "aborted")
        return I;
      a.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || n.alwaysSet) && (s[a.value] = o.value);
    }
    return { status: e.value, value: s };
  }
}
const I = Object.freeze({
  status: "aborted"
}), Ee = (t) => ({ status: "dirty", value: t }), F = (t) => ({ status: "valid", value: t }), jr = (t) => t.status === "aborted", Ur = (t) => t.status === "dirty", _e = (t) => t.status === "valid", Qe = (t) => typeof Promise < "u" && t instanceof Promise;
var b;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(b || (b = {}));
class J {
  constructor(e, r, s, n) {
    this._cachedPath = [], this.parent = e, this.data = r, this._path = s, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const Lr = (t, e) => {
  if (_e(e))
    return { success: !0, data: e.value };
  if (!t.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const r = new Y(t.common.issues);
      return this._error = r, this._error;
    }
  };
};
function x(t) {
  if (!t)
    return {};
  const { errorMap: e, invalid_type_error: r, required_error: s, description: n } = t;
  if (e && (r || s))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: n } : { errorMap: (o, i) => {
    const { message: d } = t;
    return o.code === "invalid_enum_value" ? { message: d ?? i.defaultError } : typeof i.data > "u" ? { message: d ?? s ?? i.defaultError } : o.code !== "invalid_type" ? { message: i.defaultError } : { message: d ?? r ?? i.defaultError };
  }, description: n };
}
class T {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return re(e.data);
  }
  _getOrReturnCtx(e, r) {
    return r || {
      common: e.parent.common,
      data: e.data,
      parsedType: re(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new L(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: re(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const r = this._parse(e);
    if (Qe(r))
      throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(e) {
    const r = this._parse(e);
    return Promise.resolve(r);
  }
  parse(e, r) {
    const s = this.safeParse(e, r);
    if (s.success)
      return s.data;
    throw s.error;
  }
  safeParse(e, r) {
    const s = {
      common: {
        issues: [],
        async: (r == null ? void 0 : r.async) ?? !1,
        contextualErrorMap: r == null ? void 0 : r.errorMap
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: re(e)
    }, n = this._parseSync({ data: e, path: s.path, parent: s });
    return Lr(s, n);
  }
  "~validate"(e) {
    var s, n;
    const r = {
      common: {
        issues: [],
        async: !!this["~standard"].async
      },
      path: [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: re(e)
    };
    if (!this["~standard"].async)
      try {
        const a = this._parseSync({ data: e, path: [], parent: r });
        return _e(a) ? {
          value: a.value
        } : {
          issues: r.common.issues
        };
      } catch (a) {
        (n = (s = a == null ? void 0 : a.message) == null ? void 0 : s.toLowerCase()) != null && n.includes("encountered") && (this["~standard"].async = !0), r.common = {
          issues: [],
          async: !0
        };
      }
    return this._parseAsync({ data: e, path: [], parent: r }).then((a) => _e(a) ? {
      value: a.value
    } : {
      issues: r.common.issues
    });
  }
  async parseAsync(e, r) {
    const s = await this.safeParseAsync(e, r);
    if (s.success)
      return s.data;
    throw s.error;
  }
  async safeParseAsync(e, r) {
    const s = {
      common: {
        issues: [],
        contextualErrorMap: r == null ? void 0 : r.errorMap,
        async: !0
      },
      path: (r == null ? void 0 : r.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: re(e)
    }, n = this._parse({ data: e, path: s.path, parent: s }), a = await (Qe(n) ? n : Promise.resolve(n));
    return Lr(s, a);
  }
  refine(e, r) {
    const s = (n) => typeof r == "string" || typeof r > "u" ? { message: r } : typeof r == "function" ? r(n) : r;
    return this._refinement((n, a) => {
      const o = e(n), i = () => a.addIssue({
        code: m.custom,
        ...s(n)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((d) => d ? !0 : (i(), !1)) : o ? !0 : (i(), !1);
    });
  }
  refinement(e, r) {
    return this._refinement((s, n) => e(s) ? !0 : (n.addIssue(typeof r == "function" ? r(s, n) : r), !1));
  }
  _refinement(e) {
    return new ce({
      schema: this,
      typeName: k.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
      version: 1,
      vendor: "zod",
      validate: (r) => this["~validate"](r)
    };
  }
  optional() {
    return ae.create(this, this._def);
  }
  nullable() {
    return Ie.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return G.create(this);
  }
  promise() {
    return rt.create(this, this._def);
  }
  or(e) {
    return Ye.create([this, e], this._def);
  }
  and(e) {
    return et.create(this, e, this._def);
  }
  transform(e) {
    return new ce({
      ...x(this._def),
      schema: this,
      typeName: k.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Lt({
      ...x(this._def),
      innerType: this,
      defaultValue: r,
      typeName: k.ZodDefault
    });
  }
  brand() {
    return new hi({
      typeName: k.ZodBranded,
      type: this,
      ...x(this._def)
    });
  }
  catch(e) {
    const r = typeof e == "function" ? e : () => e;
    return new Bt({
      ...x(this._def),
      innerType: this,
      catchValue: r,
      typeName: k.ZodCatch
    });
  }
  describe(e) {
    const r = this.constructor;
    return new r({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return Yt.create(this, e);
  }
  readonly() {
    return Ft.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Vo = /^c[^\s-]{8,}$/i, Wo = /^[0-9a-z]+$/, Go = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Jo = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ko = /^[a-z0-9_-]{21}$/i, Xo = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Qo = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Yo = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, ei = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let mt;
const ti = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, ri = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, si = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, ni = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ai = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, oi = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, _s = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", ii = new RegExp(`^${_s}$`);
function qs(t) {
  let e = "[0-5]\\d";
  t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`);
  const r = t.precision ? "+" : "?";
  return `([01]\\d|2[0-3]):[0-5]\\d(:${e})${r}`;
}
function ci(t) {
  return new RegExp(`^${qs(t)}$`);
}
function ui(t) {
  let e = `${_s}T${qs(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${r.join("|")})`, new RegExp(`^${e}$`);
}
function di(t, e) {
  return !!((e === "v4" || !e) && ti.test(t) || (e === "v6" || !e) && si.test(t));
}
function li(t, e) {
  if (!Xo.test(t))
    return !1;
  try {
    const [r] = t.split(".");
    if (!r)
      return !1;
    const s = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), n = JSON.parse(atob(s));
    return !(typeof n != "object" || n === null || "typ" in n && (n == null ? void 0 : n.typ) !== "JWT" || !n.alg || e && n.alg !== e);
  } catch {
    return !1;
  }
}
function fi(t, e) {
  return !!((e === "v4" || !e) && ri.test(t) || (e === "v6" || !e) && ni.test(t));
}
class Q extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== q.string) {
      const a = this._getOrReturnCtx(e);
      return v(a, {
        code: m.invalid_type,
        expected: q.string,
        received: a.parsedType
      }), I;
    }
    const s = new L();
    let n;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), s.dirty());
      else if (a.kind === "length") {
        const o = e.data.length > a.value, i = e.data.length < a.value;
        (o || i) && (n = this._getOrReturnCtx(e, n), o ? v(n, {
          code: m.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : i && v(n, {
          code: m.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), s.dirty());
      } else if (a.kind === "email")
        Yo.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "email",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "emoji")
        mt || (mt = new RegExp(ei, "u")), mt.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "emoji",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "uuid")
        Jo.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "uuid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "nanoid")
        Ko.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "nanoid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid")
        Vo.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "cuid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "cuid2")
        Wo.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "cuid2",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "ulid")
        Go.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "ulid",
          code: m.invalid_string,
          message: a.message
        }), s.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          n = this._getOrReturnCtx(e, n), v(n, {
            validation: "url",
            code: m.invalid_string,
            message: a.message
          }), s.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "regex",
          code: m.invalid_string,
          message: a.message
        }), s.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), s.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), s.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), s.dirty()) : a.kind === "datetime" ? ui(a).test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.invalid_string,
          validation: "datetime",
          message: a.message
        }), s.dirty()) : a.kind === "date" ? ii.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.invalid_string,
          validation: "date",
          message: a.message
        }), s.dirty()) : a.kind === "time" ? ci(a).test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          code: m.invalid_string,
          validation: "time",
          message: a.message
        }), s.dirty()) : a.kind === "duration" ? Qo.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "duration",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "ip" ? di(e.data, a.version) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "ip",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "jwt" ? li(e.data, a.alg) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "jwt",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "cidr" ? fi(e.data, a.version) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "cidr",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "base64" ? ai.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "base64",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : a.kind === "base64url" ? oi.test(e.data) || (n = this._getOrReturnCtx(e, n), v(n, {
          validation: "base64url",
          code: m.invalid_string,
          message: a.message
        }), s.dirty()) : S.assertNever(a);
    return { status: s.value, value: e.data };
  }
  _regex(e, r, s) {
    return this.refinement((n) => e.test(n), {
      validation: r,
      code: m.invalid_string,
      ...b.errToObj(s)
    });
  }
  _addCheck(e) {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...b.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...b.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...b.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...b.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...b.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...b.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...b.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...b.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...b.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({
      kind: "base64url",
      ...b.errToObj(e)
    });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...b.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...b.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...b.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (e == null ? void 0 : e.offset) ?? !1,
      local: (e == null ? void 0 : e.local) ?? !1,
      ...b.errToObj(e == null ? void 0 : e.message)
    });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: e
    }) : this._addCheck({
      kind: "time",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      ...b.errToObj(e == null ? void 0 : e.message)
    });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...b.errToObj(e) });
  }
  regex(e, r) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...b.errToObj(r)
    });
  }
  includes(e, r) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: r == null ? void 0 : r.position,
      ...b.errToObj(r == null ? void 0 : r.message)
    });
  }
  startsWith(e, r) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...b.errToObj(r)
    });
  }
  endsWith(e, r) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...b.errToObj(r)
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...b.errToObj(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...b.errToObj(r)
    });
  }
  length(e, r) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...b.errToObj(r)
    });
  }
  /**
   * Equivalent to `.min(1)`
   */
  nonempty(e) {
    return this.min(1, b.errToObj(e));
  }
  trim() {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Q({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
Q.create = (t) => new Q({
  checks: [],
  typeName: k.ZodString,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...x(t)
});
function yi(t, e) {
  const r = (t.toString().split(".")[1] || "").length, s = (e.toString().split(".")[1] || "").length, n = r > s ? r : s, a = Number.parseInt(t.toFixed(n).replace(".", "")), o = Number.parseInt(e.toFixed(n).replace(".", ""));
  return a % o / 10 ** n;
}
class qe extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== q.number) {
      const a = this._getOrReturnCtx(e);
      return v(a, {
        code: m.invalid_type,
        expected: q.number,
        received: a.parsedType
      }), I;
    }
    let s;
    const n = new L();
    for (const a of this._def.checks)
      a.kind === "int" ? S.isInteger(e.data) || (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), n.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), n.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), n.dirty()) : a.kind === "multipleOf" ? yi(e.data, a.value) !== 0 && (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), n.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.not_finite,
        message: a.message
      }), n.dirty()) : S.assertNever(a);
    return { status: n.value, value: e.data };
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, b.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, b.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, b.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, b.toString(r));
  }
  setLimit(e, r, s, n) {
    return new qe({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: s,
          message: b.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new qe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: b.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: b.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: b.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: b.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: b.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: b.toString(r)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: b.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: b.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: b.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && S.isInteger(e.value));
  }
  get isFinite() {
    let e = null, r = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf")
        return !0;
      s.kind === "min" ? (r === null || s.value > r) && (r = s.value) : s.kind === "max" && (e === null || s.value < e) && (e = s.value);
    }
    return Number.isFinite(r) && Number.isFinite(e);
  }
}
qe.create = (t) => new qe({
  checks: [],
  typeName: k.ZodNumber,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...x(t)
});
class be extends T {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce)
      try {
        e.data = BigInt(e.data);
      } catch {
        return this._getInvalidInput(e);
      }
    if (this._getType(e) !== q.bigint)
      return this._getInvalidInput(e);
    let s;
    const n = new L();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), n.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), n.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (s = this._getOrReturnCtx(e, s), v(s, {
        code: m.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), n.dirty()) : S.assertNever(a);
    return { status: n.value, value: e.data };
  }
  _getInvalidInput(e) {
    const r = this._getOrReturnCtx(e);
    return v(r, {
      code: m.invalid_type,
      expected: q.bigint,
      received: r.parsedType
    }), I;
  }
  gte(e, r) {
    return this.setLimit("min", e, !0, b.toString(r));
  }
  gt(e, r) {
    return this.setLimit("min", e, !1, b.toString(r));
  }
  lte(e, r) {
    return this.setLimit("max", e, !0, b.toString(r));
  }
  lt(e, r) {
    return this.setLimit("max", e, !1, b.toString(r));
  }
  setLimit(e, r, s, n) {
    return new be({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: r,
          inclusive: s,
          message: b.toString(n)
        }
      ]
    });
  }
  _addCheck(e) {
    return new be({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: b.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: b.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: b.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: b.toString(e)
    });
  }
  multipleOf(e, r) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: b.toString(r)
    });
  }
  get minValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e;
  }
}
be.create = (t) => new be({
  checks: [],
  typeName: k.ZodBigInt,
  coerce: (t == null ? void 0 : t.coerce) ?? !1,
  ...x(t)
});
class Tt extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== q.boolean) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: q.boolean,
        received: s.parsedType
      }), I;
    }
    return F(e.data);
  }
}
Tt.create = (t) => new Tt({
  typeName: k.ZodBoolean,
  coerce: (t == null ? void 0 : t.coerce) || !1,
  ...x(t)
});
class Oe extends T {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== q.date) {
      const a = this._getOrReturnCtx(e);
      return v(a, {
        code: m.invalid_type,
        expected: q.date,
        received: a.parsedType
      }), I;
    }
    if (Number.isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return v(a, {
        code: m.invalid_date
      }), I;
    }
    const s = new L();
    let n;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (n = this._getOrReturnCtx(e, n), v(n, {
        code: m.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), s.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (n = this._getOrReturnCtx(e, n), v(n, {
        code: m.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), s.dirty()) : S.assertNever(a);
    return {
      status: s.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new Oe({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, r) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: b.toString(r)
    });
  }
  max(e, r) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: b.toString(r)
    });
  }
  get minDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "min" && (e === null || r.value > e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const r of this._def.checks)
      r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    return e != null ? new Date(e) : null;
  }
}
Oe.create = (t) => new Oe({
  checks: [],
  coerce: (t == null ? void 0 : t.coerce) || !1,
  typeName: k.ZodDate,
  ...x(t)
});
class St extends T {
  _parse(e) {
    if (this._getType(e) !== q.symbol) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: q.symbol,
        received: s.parsedType
      }), I;
    }
    return F(e.data);
  }
}
St.create = (t) => new St({
  typeName: k.ZodSymbol,
  ...x(t)
});
class At extends T {
  _parse(e) {
    if (this._getType(e) !== q.undefined) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: q.undefined,
        received: s.parsedType
      }), I;
    }
    return F(e.data);
  }
}
At.create = (t) => new At({
  typeName: k.ZodUndefined,
  ...x(t)
});
class Rt extends T {
  _parse(e) {
    if (this._getType(e) !== q.null) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: q.null,
        received: s.parsedType
      }), I;
    }
    return F(e.data);
  }
}
Rt.create = (t) => new Rt({
  typeName: k.ZodNull,
  ...x(t)
});
class Et extends T {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return F(e.data);
  }
}
Et.create = (t) => new Et({
  typeName: k.ZodAny,
  ...x(t)
});
class Ct extends T {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return F(e.data);
  }
}
Ct.create = (t) => new Ct({
  typeName: k.ZodUnknown,
  ...x(t)
});
class ie extends T {
  _parse(e) {
    const r = this._getOrReturnCtx(e);
    return v(r, {
      code: m.invalid_type,
      expected: q.never,
      received: r.parsedType
    }), I;
  }
}
ie.create = (t) => new ie({
  typeName: k.ZodNever,
  ...x(t)
});
class Ot extends T {
  _parse(e) {
    if (this._getType(e) !== q.undefined) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: q.void,
        received: s.parsedType
      }), I;
    }
    return F(e.data);
  }
}
Ot.create = (t) => new Ot({
  typeName: k.ZodVoid,
  ...x(t)
});
class G extends T {
  _parse(e) {
    const { ctx: r, status: s } = this._processInputParams(e), n = this._def;
    if (r.parsedType !== q.array)
      return v(r, {
        code: m.invalid_type,
        expected: q.array,
        received: r.parsedType
      }), I;
    if (n.exactLength !== null) {
      const o = r.data.length > n.exactLength.value, i = r.data.length < n.exactLength.value;
      (o || i) && (v(r, {
        code: o ? m.too_big : m.too_small,
        minimum: i ? n.exactLength.value : void 0,
        maximum: o ? n.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: n.exactLength.message
      }), s.dirty());
    }
    if (n.minLength !== null && r.data.length < n.minLength.value && (v(r, {
      code: m.too_small,
      minimum: n.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.minLength.message
    }), s.dirty()), n.maxLength !== null && r.data.length > n.maxLength.value && (v(r, {
      code: m.too_big,
      maximum: n.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: n.maxLength.message
    }), s.dirty()), r.common.async)
      return Promise.all([...r.data].map((o, i) => n.type._parseAsync(new J(r, o, r.path, i)))).then((o) => L.mergeArray(s, o));
    const a = [...r.data].map((o, i) => n.type._parseSync(new J(r, o, r.path, i)));
    return L.mergeArray(s, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, r) {
    return new G({
      ...this._def,
      minLength: { value: e, message: b.toString(r) }
    });
  }
  max(e, r) {
    return new G({
      ...this._def,
      maxLength: { value: e, message: b.toString(r) }
    });
  }
  length(e, r) {
    return new G({
      ...this._def,
      exactLength: { value: e, message: b.toString(r) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
G.create = (t, e) => new G({
  type: t,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: k.ZodArray,
  ...x(e)
});
function ge(t) {
  if (t instanceof E) {
    const e = {};
    for (const r in t.shape) {
      const s = t.shape[r];
      e[r] = ae.create(ge(s));
    }
    return new E({
      ...t._def,
      shape: () => e
    });
  } else
    return t instanceof G ? new G({
      ...t._def,
      type: ge(t.element)
    }) : t instanceof ae ? ae.create(ge(t.unwrap())) : t instanceof Ie ? Ie.create(ge(t.unwrap())) : t instanceof ye ? ye.create(t.items.map((e) => ge(e))) : t;
}
class E extends T {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), r = S.objectKeys(e);
    return this._cached = { shape: e, keys: r }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== q.object) {
      const u = this._getOrReturnCtx(e);
      return v(u, {
        code: m.invalid_type,
        expected: q.object,
        received: u.parsedType
      }), I;
    }
    const { status: s, ctx: n } = this._processInputParams(e), { shape: a, keys: o } = this._getCached(), i = [];
    if (!(this._def.catchall instanceof ie && this._def.unknownKeys === "strip"))
      for (const u in n.data)
        o.includes(u) || i.push(u);
    const d = [];
    for (const u of o) {
      const c = a[u], f = n.data[u];
      d.push({
        key: { status: "valid", value: u },
        value: c._parse(new J(n, f, n.path, u)),
        alwaysSet: u in n.data
      });
    }
    if (this._def.catchall instanceof ie) {
      const u = this._def.unknownKeys;
      if (u === "passthrough")
        for (const c of i)
          d.push({
            key: { status: "valid", value: c },
            value: { status: "valid", value: n.data[c] }
          });
      else if (u === "strict")
        i.length > 0 && (v(n, {
          code: m.unrecognized_keys,
          keys: i
        }), s.dirty());
      else if (u !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of i) {
        const f = n.data[c];
        d.push({
          key: { status: "valid", value: c },
          value: u._parse(
            new J(n, f, n.path, c)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: c in n.data
        });
      }
    }
    return n.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of d) {
        const f = await c.key, h = await c.value;
        u.push({
          key: f,
          value: h,
          alwaysSet: c.alwaysSet
        });
      }
      return u;
    }).then((u) => L.mergeObjectSync(s, u)) : L.mergeObjectSync(s, d);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return b.errToObj, new E({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (r, s) => {
          var a, o;
          const n = ((o = (a = this._def).errorMap) == null ? void 0 : o.call(a, r, s).message) ?? s.defaultError;
          return r.code === "unrecognized_keys" ? {
            message: b.errToObj(e).message ?? n
          } : {
            message: n
          };
        }
      } : {}
    });
  }
  strip() {
    return new E({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new E({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new E({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new E({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: k.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, r) {
    return this.augment({ [e]: r });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new E({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const r = {};
    for (const s of S.objectKeys(e))
      e[s] && this.shape[s] && (r[s] = this.shape[s]);
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  omit(e) {
    const r = {};
    for (const s of S.objectKeys(this.shape))
      e[s] || (r[s] = this.shape[s]);
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ge(this);
  }
  partial(e) {
    const r = {};
    for (const s of S.objectKeys(this.shape)) {
      const n = this.shape[s];
      e && !e[s] ? r[s] = n : r[s] = n.optional();
    }
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  required(e) {
    const r = {};
    for (const s of S.objectKeys(this.shape))
      if (e && !e[s])
        r[s] = this.shape[s];
      else {
        let a = this.shape[s];
        for (; a instanceof ae; )
          a = a._def.innerType;
        r[s] = a;
      }
    return new E({
      ...this._def,
      shape: () => r
    });
  }
  keyof() {
    return bs(S.objectKeys(this.shape));
  }
}
E.create = (t, e) => new E({
  shape: () => t,
  unknownKeys: "strip",
  catchall: ie.create(),
  typeName: k.ZodObject,
  ...x(e)
});
E.strictCreate = (t, e) => new E({
  shape: () => t,
  unknownKeys: "strict",
  catchall: ie.create(),
  typeName: k.ZodObject,
  ...x(e)
});
E.lazycreate = (t, e) => new E({
  shape: t,
  unknownKeys: "strip",
  catchall: ie.create(),
  typeName: k.ZodObject,
  ...x(e)
});
class Ye extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), s = this._def.options;
    function n(a) {
      for (const i of a)
        if (i.result.status === "valid")
          return i.result;
      for (const i of a)
        if (i.result.status === "dirty")
          return r.common.issues.push(...i.ctx.common.issues), i.result;
      const o = a.map((i) => new Y(i.ctx.common.issues));
      return v(r, {
        code: m.invalid_union,
        unionErrors: o
      }), I;
    }
    if (r.common.async)
      return Promise.all(s.map(async (a) => {
        const o = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: r.data,
            path: r.path,
            parent: o
          }),
          ctx: o
        };
      })).then(n);
    {
      let a;
      const o = [];
      for (const d of s) {
        const u = {
          ...r,
          common: {
            ...r.common,
            issues: []
          },
          parent: null
        }, c = d._parseSync({
          data: r.data,
          path: r.path,
          parent: u
        });
        if (c.status === "valid")
          return c;
        c.status === "dirty" && !a && (a = { result: c, ctx: u }), u.common.issues.length && o.push(u.common.issues);
      }
      if (a)
        return r.common.issues.push(...a.ctx.common.issues), a.result;
      const i = o.map((d) => new Y(d));
      return v(r, {
        code: m.invalid_union,
        unionErrors: i
      }), I;
    }
  }
  get options() {
    return this._def.options;
  }
}
Ye.create = (t, e) => new Ye({
  options: t,
  typeName: k.ZodUnion,
  ...x(e)
});
function Pt(t, e) {
  const r = re(t), s = re(e);
  if (t === e)
    return { valid: !0, data: t };
  if (r === q.object && s === q.object) {
    const n = S.objectKeys(e), a = S.objectKeys(t).filter((i) => n.indexOf(i) !== -1), o = { ...t, ...e };
    for (const i of a) {
      const d = Pt(t[i], e[i]);
      if (!d.valid)
        return { valid: !1 };
      o[i] = d.data;
    }
    return { valid: !0, data: o };
  } else if (r === q.array && s === q.array) {
    if (t.length !== e.length)
      return { valid: !1 };
    const n = [];
    for (let a = 0; a < t.length; a++) {
      const o = t[a], i = e[a], d = Pt(o, i);
      if (!d.valid)
        return { valid: !1 };
      n.push(d.data);
    }
    return { valid: !0, data: n };
  } else
    return r === q.date && s === q.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
class et extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e), n = (a, o) => {
      if (jr(a) || jr(o))
        return I;
      const i = Pt(a.value, o.value);
      return i.valid ? ((Ur(a) || Ur(o)) && r.dirty(), { status: r.value, value: i.data }) : (v(s, {
        code: m.invalid_intersection_types
      }), I);
    };
    return s.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      }),
      this._def.right._parseAsync({
        data: s.data,
        path: s.path,
        parent: s
      })
    ]).then(([a, o]) => n(a, o)) : n(this._def.left._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }), this._def.right._parseSync({
      data: s.data,
      path: s.path,
      parent: s
    }));
  }
}
et.create = (t, e, r) => new et({
  left: t,
  right: e,
  typeName: k.ZodIntersection,
  ...x(r)
});
class ye extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== q.array)
      return v(s, {
        code: m.invalid_type,
        expected: q.array,
        received: s.parsedType
      }), I;
    if (s.data.length < this._def.items.length)
      return v(s, {
        code: m.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), I;
    !this._def.rest && s.data.length > this._def.items.length && (v(s, {
      code: m.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), r.dirty());
    const a = [...s.data].map((o, i) => {
      const d = this._def.items[i] || this._def.rest;
      return d ? d._parse(new J(s, o, s.path, i)) : null;
    }).filter((o) => !!o);
    return s.common.async ? Promise.all(a).then((o) => L.mergeArray(r, o)) : L.mergeArray(r, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new ye({
      ...this._def,
      rest: e
    });
  }
}
ye.create = (t, e) => {
  if (!Array.isArray(t))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new ye({
    items: t,
    typeName: k.ZodTuple,
    rest: null,
    ...x(e)
  });
};
class tt extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== q.object)
      return v(s, {
        code: m.invalid_type,
        expected: q.object,
        received: s.parsedType
      }), I;
    const n = [], a = this._def.keyType, o = this._def.valueType;
    for (const i in s.data)
      n.push({
        key: a._parse(new J(s, i, s.path, i)),
        value: o._parse(new J(s, s.data[i], s.path, i)),
        alwaysSet: i in s.data
      });
    return s.common.async ? L.mergeObjectAsync(r, n) : L.mergeObjectSync(r, n);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, r, s) {
    return r instanceof T ? new tt({
      keyType: e,
      valueType: r,
      typeName: k.ZodRecord,
      ...x(s)
    }) : new tt({
      keyType: Q.create(),
      valueType: e,
      typeName: k.ZodRecord,
      ...x(r)
    });
  }
}
class Nt extends T {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== q.map)
      return v(s, {
        code: m.invalid_type,
        expected: q.map,
        received: s.parsedType
      }), I;
    const n = this._def.keyType, a = this._def.valueType, o = [...s.data.entries()].map(([i, d], u) => ({
      key: n._parse(new J(s, i, s.path, [u, "key"])),
      value: a._parse(new J(s, d, s.path, [u, "value"]))
    }));
    if (s.common.async) {
      const i = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const d of o) {
          const u = await d.key, c = await d.value;
          if (u.status === "aborted" || c.status === "aborted")
            return I;
          (u.status === "dirty" || c.status === "dirty") && r.dirty(), i.set(u.value, c.value);
        }
        return { status: r.value, value: i };
      });
    } else {
      const i = /* @__PURE__ */ new Map();
      for (const d of o) {
        const u = d.key, c = d.value;
        if (u.status === "aborted" || c.status === "aborted")
          return I;
        (u.status === "dirty" || c.status === "dirty") && r.dirty(), i.set(u.value, c.value);
      }
      return { status: r.value, value: i };
    }
  }
}
Nt.create = (t, e, r) => new Nt({
  valueType: e,
  keyType: t,
  typeName: k.ZodMap,
  ...x(r)
});
class we extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.parsedType !== q.set)
      return v(s, {
        code: m.invalid_type,
        expected: q.set,
        received: s.parsedType
      }), I;
    const n = this._def;
    n.minSize !== null && s.data.size < n.minSize.value && (v(s, {
      code: m.too_small,
      minimum: n.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.minSize.message
    }), r.dirty()), n.maxSize !== null && s.data.size > n.maxSize.value && (v(s, {
      code: m.too_big,
      maximum: n.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: n.maxSize.message
    }), r.dirty());
    const a = this._def.valueType;
    function o(d) {
      const u = /* @__PURE__ */ new Set();
      for (const c of d) {
        if (c.status === "aborted")
          return I;
        c.status === "dirty" && r.dirty(), u.add(c.value);
      }
      return { status: r.value, value: u };
    }
    const i = [...s.data.values()].map((d, u) => a._parse(new J(s, d, s.path, u)));
    return s.common.async ? Promise.all(i).then((d) => o(d)) : o(i);
  }
  min(e, r) {
    return new we({
      ...this._def,
      minSize: { value: e, message: b.toString(r) }
    });
  }
  max(e, r) {
    return new we({
      ...this._def,
      maxSize: { value: e, message: b.toString(r) }
    });
  }
  size(e, r) {
    return this.min(e, r).max(e, r);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
we.create = (t, e) => new we({
  valueType: t,
  minSize: null,
  maxSize: null,
  typeName: k.ZodSet,
  ...x(e)
});
class Dt extends T {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
Dt.create = (t, e) => new Dt({
  getter: t,
  typeName: k.ZodLazy,
  ...x(e)
});
class jt extends T {
  _parse(e) {
    if (e.data !== this._def.value) {
      const r = this._getOrReturnCtx(e);
      return v(r, {
        received: r.data,
        code: m.invalid_literal,
        expected: this._def.value
      }), I;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
jt.create = (t, e) => new jt({
  value: t,
  typeName: k.ZodLiteral,
  ...x(e)
});
function bs(t, e) {
  return new ke({
    values: t,
    typeName: k.ZodEnum,
    ...x(e)
  });
}
class ke extends T {
  _parse(e) {
    if (typeof e.data != "string") {
      const r = this._getOrReturnCtx(e), s = this._def.values;
      return v(r, {
        expected: S.joinValues(s),
        received: r.parsedType,
        code: m.invalid_type
      }), I;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const r = this._getOrReturnCtx(e), s = this._def.values;
      return v(r, {
        received: r.data,
        code: m.invalid_enum_value,
        options: s
      }), I;
    }
    return F(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Values() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  get Enum() {
    const e = {};
    for (const r of this._def.values)
      e[r] = r;
    return e;
  }
  extract(e, r = this._def) {
    return ke.create(e, {
      ...this._def,
      ...r
    });
  }
  exclude(e, r = this._def) {
    return ke.create(this.options.filter((s) => !e.includes(s)), {
      ...this._def,
      ...r
    });
  }
}
ke.create = bs;
class Ut extends T {
  _parse(e) {
    const r = S.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(e);
    if (s.parsedType !== q.string && s.parsedType !== q.number) {
      const n = S.objectValues(r);
      return v(s, {
        expected: S.joinValues(n),
        received: s.parsedType,
        code: m.invalid_type
      }), I;
    }
    if (this._cache || (this._cache = new Set(S.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const n = S.objectValues(r);
      return v(s, {
        received: s.data,
        code: m.invalid_enum_value,
        options: n
      }), I;
    }
    return F(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
Ut.create = (t, e) => new Ut({
  values: t,
  typeName: k.ZodNativeEnum,
  ...x(e)
});
class rt extends T {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    if (r.parsedType !== q.promise && r.common.async === !1)
      return v(r, {
        code: m.invalid_type,
        expected: q.promise,
        received: r.parsedType
      }), I;
    const s = r.parsedType === q.promise ? r.data : Promise.resolve(r.data);
    return F(s.then((n) => this._def.type.parseAsync(n, {
      path: r.path,
      errorMap: r.common.contextualErrorMap
    })));
  }
}
rt.create = (t, e) => new rt({
  type: t,
  typeName: k.ZodPromise,
  ...x(e)
});
class ce extends T {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === k.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e), n = this._def.effect || null, a = {
      addIssue: (o) => {
        v(s, o), o.fatal ? r.abort() : r.dirty();
      },
      get path() {
        return s.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), n.type === "preprocess") {
      const o = n.transform(s.data, a);
      if (s.common.async)
        return Promise.resolve(o).then(async (i) => {
          if (r.value === "aborted")
            return I;
          const d = await this._def.schema._parseAsync({
            data: i,
            path: s.path,
            parent: s
          });
          return d.status === "aborted" ? I : d.status === "dirty" || r.value === "dirty" ? Ee(d.value) : d;
        });
      {
        if (r.value === "aborted")
          return I;
        const i = this._def.schema._parseSync({
          data: o,
          path: s.path,
          parent: s
        });
        return i.status === "aborted" ? I : i.status === "dirty" || r.value === "dirty" ? Ee(i.value) : i;
      }
    }
    if (n.type === "refinement") {
      const o = (i) => {
        const d = n.refinement(i, a);
        if (s.common.async)
          return Promise.resolve(d);
        if (d instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return i;
      };
      if (s.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return i.status === "aborted" ? I : (i.status === "dirty" && r.dirty(), o(i.value), { status: r.value, value: i.value });
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((i) => i.status === "aborted" ? I : (i.status === "dirty" && r.dirty(), o(i.value).then(() => ({ status: r.value, value: i.value }))));
    }
    if (n.type === "transform")
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: s.data,
          path: s.path,
          parent: s
        });
        if (!_e(o))
          return I;
        const i = n.transform(o.value, a);
        if (i instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: i };
      } else
        return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => _e(o) ? Promise.resolve(n.transform(o.value, a)).then((i) => ({
          status: r.value,
          value: i
        })) : I);
    S.assertNever(n);
  }
}
ce.create = (t, e, r) => new ce({
  schema: t,
  typeName: k.ZodEffects,
  effect: e,
  ...x(r)
});
ce.createWithPreprocess = (t, e, r) => new ce({
  schema: e,
  effect: { type: "preprocess", transform: t },
  typeName: k.ZodEffects,
  ...x(r)
});
class ae extends T {
  _parse(e) {
    return this._getType(e) === q.undefined ? F(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
ae.create = (t, e) => new ae({
  innerType: t,
  typeName: k.ZodOptional,
  ...x(e)
});
class Ie extends T {
  _parse(e) {
    return this._getType(e) === q.null ? F(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ie.create = (t, e) => new Ie({
  innerType: t,
  typeName: k.ZodNullable,
  ...x(e)
});
class Lt extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e);
    let s = r.data;
    return r.parsedType === q.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({
      data: s,
      path: r.path,
      parent: r
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Lt.create = (t, e) => new Lt({
  innerType: t,
  typeName: k.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ...x(e)
});
class Bt extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), s = {
      ...r,
      common: {
        ...r.common,
        issues: []
      }
    }, n = this._def.innerType._parse({
      data: s.data,
      path: s.path,
      parent: {
        ...s
      }
    });
    return Qe(n) ? n.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new Y(s.common.issues);
        },
        input: s.data
      })
    })) : {
      status: "valid",
      value: n.status === "valid" ? n.value : this._def.catchValue({
        get error() {
          return new Y(s.common.issues);
        },
        input: s.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Bt.create = (t, e) => new Bt({
  innerType: t,
  typeName: k.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ...x(e)
});
class Ht extends T {
  _parse(e) {
    if (this._getType(e) !== q.nan) {
      const s = this._getOrReturnCtx(e);
      return v(s, {
        code: m.invalid_type,
        expected: q.nan,
        received: s.parsedType
      }), I;
    }
    return { status: "valid", value: e.data };
  }
}
Ht.create = (t) => new Ht({
  typeName: k.ZodNaN,
  ...x(t)
});
class hi extends T {
  _parse(e) {
    const { ctx: r } = this._processInputParams(e), s = r.data;
    return this._def.type._parse({
      data: s,
      path: r.path,
      parent: r
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class Yt extends T {
  _parse(e) {
    const { status: r, ctx: s } = this._processInputParams(e);
    if (s.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: s.data,
          path: s.path,
          parent: s
        });
        return a.status === "aborted" ? I : a.status === "dirty" ? (r.dirty(), Ee(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: s.path,
          parent: s
        });
      })();
    {
      const n = this._def.in._parseSync({
        data: s.data,
        path: s.path,
        parent: s
      });
      return n.status === "aborted" ? I : n.status === "dirty" ? (r.dirty(), {
        status: "dirty",
        value: n.value
      }) : this._def.out._parseSync({
        data: n.value,
        path: s.path,
        parent: s
      });
    }
  }
  static create(e, r) {
    return new Yt({
      in: e,
      out: r,
      typeName: k.ZodPipeline
    });
  }
}
class Ft extends T {
  _parse(e) {
    const r = this._def.innerType._parse(e), s = (n) => (_e(n) && (n.value = Object.freeze(n.value)), n);
    return Qe(r) ? r.then((n) => s(n)) : s(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Ft.create = (t, e) => new Ft({
  innerType: t,
  typeName: k.ZodReadonly,
  ...x(e)
});
E.lazycreate;
var k;
(function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
})(k || (k = {}));
const D = Q.create, se = qe.create;
Ht.create;
be.create;
const Ge = Tt.create;
Oe.create;
St.create;
At.create;
Rt.create;
Et.create;
Ct.create;
ie.create;
Ot.create;
const pt = G.create, K = E.create;
E.strictCreate;
const mi = Ye.create;
et.create;
ye.create;
const ws = tt.create;
Nt.create;
we.create;
Dt.create;
jt.create;
ke.create;
Ut.create;
rt.create;
ce.create;
const gt = ae.create;
Ie.create;
ce.createWithPreprocess;
K({
  duration: se(),
  email: D().email(),
  firstName: D(),
  formFields: gt(
    ws(D(), mi([D(), se(), Ge()]))
  ),
  guestEmails: gt(D().array()),
  lastName: D(),
  likelyAvailableUserIds: gt(D().array()),
  slug: D(),
  startTime: se(),
  timezone: D().default("Europe/Paris")
});
const pi = K({
  linkAvailability: K({
    hasMore: Ge(),
    linkAvailabilityByDuration: ws(
      D(),
      // Key is a string like "900000"
      K({
        meetingDurationMillis: se().int(),
        availabilities: pt(
          K({
            startMillisUtc: se().int(),
            endMillisUtc: se().int()
          })
        )
      })
    )
  }),
  allUsersBusyTimes: pt(
    K({
      isOffline: Ge(),
      meetingsUser: K({
        id: D(),
        userId: D(),
        isSalesStarter: Ge(),
        userProfile: K({
          firstName: D(),
          lastName: D(),
          email: D(),
          fullName: D()
        }),
        calendarProvider: D()
      }),
      busyTimes: pt(
        K({
          start: se().int(),
          end: se().int()
        })
      )
    })
  )
});
class Cf {
  constructor(e) {
    this.provider = e, this.httpOptions = {}, this.hubspotApiDomain = "", this.hubspotMeetingSchedulerToken = "", this.http = {}, this.hubspotApiDomain = this.provider.hubspotApiDomain, this.hubspotMeetingSchedulerToken = this.provider.hubspotMeetingSchedulerToken, this.http = this.setHttp(this.provider.httpClient);
  }
  setHttp(e) {
    const r = { name: "hubspot", url: this.hubspotApiDomain };
    return e === "axios" ? oe({ api: r, unserialized: !0 }) : je({ api: r });
  }
  async postBooking(e) {
    const r = new URL(
      "/scheduler/v3/meetings/meeting-links/book",
      this.hubspotApiDomain
    );
    return await this.http.post(
      r.toString(),
      {
        ...e,
        formFields: [
          { name: "mobilephone", value: e.phone },
          { name: "message", value: e.message }
        ],
        duration: 9e5
      },
      {
        headers: {
          Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
        }
      }
    );
  }
  async getMeetings() {
    return (await this.http.get(`${this.hubspotApiDomain}/scheduler/v3/meetings/meeting-links`, {
      headers: {
        Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
      }
    })).data.results;
  }
  async getMeeting(e, r) {
    if (!e)
      throw new Error("Meeting ID is required");
    const s = new URL(
      `/scheduler/v3/meetings/meeting-links/book/${encodeURIComponent(e)}?timezone=${encodeURIComponent(r)}`,
      this.hubspotApiDomain
    );
    return await this.http.get(s.toString(), {
      headers: {
        Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
      }
    });
  }
  async getAvailabilities(e, r, s = "0") {
    if (!e)
      throw new Error("Meeting Slug is required");
    const n = s ? `&monthOffset=${s}` : "", a = new URL(
      `/scheduler/v3/meetings/meeting-links/book/availability-page/${encodeURIComponent(e)}?timezone=${encodeURIComponent(r)}&montOffset=${n}`,
      this.hubspotApiDomain
    ), o = await this.http.get(a.toString(), {
      ...this.httpOptions,
      headers: {
        Authorization: `Bearer ${this.hubspotMeetingSchedulerToken}`
      }
    });
    return pi.safeParse(o.data).data;
  }
  async getAvailableDurations(e, r) {
    const s = await this.getAvailabilities(e, r);
    return Object.keys(
      (s == null ? void 0 : s.linkAvailability.linkAvailabilityByDuration) ?? {}
    ).map(Number);
  }
  async getComputedAvailabilities(e, r) {
    var n;
    return {
      availabilities: (((n = e.linkAvailability.linkAvailabilityByDuration[r.toString()]) == null ? void 0 : n.availabilities) ?? []).filter((a) => a.startMillisUtc > Date.now()).reduce(
        (a, o) => {
          const i = new Date(o.startMillisUtc), d = new Date(
            i.getFullYear(),
            i.getMonth(),
            i.getDate()
          ).getTime();
          return {
            ...a,
            [d]: [...a[d] ?? [], o.startMillisUtc]
          };
        },
        {}
      ),
      hasMore: e.linkAvailability.hasMore
    };
  }
  async getAllComputedAvailabilities(e) {
    var n;
    const r = {}, s = Object.keys(
      e.linkAvailability.linkAvailabilityByDuration || {}
    ).map((a) => parseInt(a));
    for (const a of s) {
      const o = (((n = e.linkAvailability.linkAvailabilityByDuration[a.toString()]) == null ? void 0 : n.availabilities) ?? []).filter((i) => i.startMillisUtc > Date.now()).reduce(
        (i, d) => {
          const u = new Date(d.startMillisUtc), c = new Date(
            u.getFullYear(),
            u.getMonth(),
            u.getDate()
          ).getTime();
          return i[c] || (i[c] = []), i[c].push(d.startMillisUtc), i;
        },
        {}
      );
      Object.entries(o).forEach(
        ([i, d]) => {
          const u = parseInt(i);
          r[u] || (r[u] = []), r[u] = [
            ...r[u],
            ...d
          ];
        }
      );
    }
    return r;
  }
  async getMeetingDates(e, r, s) {
    const n = await this.getAvailabilities(
      e,
      r,
      s
    );
    if (!n)
      return null;
    const a = {}, o = await this.getAllComputedAvailabilities(n);
    return Object.entries(o).forEach(
      ([u, c]) => {
        const f = parseInt(u);
        a[f] || (a[f] = []), a[f] = [
          ...a[f],
          ...c
        ];
      }
    ), {
      dates: Object.keys(a).map((u) => parseInt(u)).sort((u, c) => u - c).map((u) => {
        const c = new Date(u), f = c.getTimezoneOffset() * 6e4, h = c.getTime() - f;
        return new Date(h).toISOString();
      }),
      hasMore: n.linkAvailability.hasMore
    };
  }
  async getAvailabilitiesForDate(e, r, s) {
    const n = [], a = new Date(Date.now()), o = new Date(e), i = o.getMonth() - a.getMonth(), d = await this.getAvailabilities(
      r,
      s,
      i.toString()
    );
    if (!d)
      return null;
    const u = await this.getAllComputedAvailabilities(d);
    return Object.entries(u).forEach(
      ([c, f]) => {
        const h = new Date(Number(c));
        o.toDateString() === h.toDateString() && n.push(
          ...f.map(
            (_) => new Date(_).toISOString()
          )
        );
      }
    ), n;
  }
}
class Of {
  constructor(e) {
    this.provider = e, this.apiKey = "", this.http = {}, this.apiUrl = "", this.apiKey = this.provider.apiKey, this.apiUrl = this.provider.apiUrl, this.http = this.setHttp(this.provider.httpClientType);
  }
  setHttp(e) {
    const r = { name: "ipLocation", url: this.apiUrl };
    return e === "axios" ? oe({ api: r, unserialized: !0 }) : je({ api: r });
  }
  async getUserLocation() {
    var r, s, n, a, o, i, d, u, c, f, h, _, y, p;
    const e = await this.http.get(`?key=${this.apiKey}`).then(
      (g) => typeof g.data == "object" ? g : { data: g }
    ).catch(console.error);
    if (e != null && e.data)
      return {
        location: {
          countryCode: (n = (s = (r = e.data) == null ? void 0 : r.location) == null ? void 0 : s.country) == null ? void 0 : n.code,
          country: (i = (o = (a = e.data) == null ? void 0 : a.location) == null ? void 0 : o.country) == null ? void 0 : i.name,
          city: (u = (d = e.data) == null ? void 0 : d.location) == null ? void 0 : u.city,
          postal: (f = (c = e.data) == null ? void 0 : c.location) == null ? void 0 : f.postal
        },
        currency: (_ = (h = e.data) == null ? void 0 : h.currency) == null ? void 0 : _.code,
        timezone: (p = (y = e.data) == null ? void 0 : y.time_zone) == null ? void 0 : p.id
      };
  }
}
class gi {
  constructor(e) {
    this.httpOptions = {}, this.http = {}, this.apiUrl = "", this.httpOptions = {
      headers: { Authorization: e.apiKey }
    }, this.apiUrl = e.apiUrl;
    const r = { name: "sharegroop", url: this.apiUrl };
    this.http = e.httpClientType === "axios" ? oe({ api: r, unserialized: !0 }) : je({ api: r });
  }
  async getOrderById(e) {
    return (await this.http.get(`v1/orders/${e}`, this.httpOptions)).data;
  }
}
gi.SUCCESSFUL_STATUSES = [
  "completed",
  "confirmed",
  "pendingCommit"
];
const vi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(
      `v3/user/availability_requests/${e.availabilityRequestId}${r}`
    );
  }
}), _i = (t) => ({
  query: (e) => t.put(
    `v3/user/availability_requests/${e.availabilityRequestId}`,
    { availability_request: { ...e } }
  )
}), qi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(`v3/user/awaiting_user_actions${r}`);
  }
}), bi = (t) => ({
  query: (e) => t.put(`v3/user/owner_nps/${e.id}`, e.body)
}), wi = (t) => ({
  query: async (e) => {
    var d;
    if (typeof t.raw != "function")
      throw new Error("HttpClient does not implement the .raw method");
    const r = await t.raw(
      `v3/user/checks/${e.checkId}.pdf`,
      {
        responseType: "blob"
      }
    ), { headers: s, _data: n } = r;
    if (!n)
      throw new Error("noContent");
    const a = (d = s.get("content-disposition")) == null ? void 0 : d.toString(), [o, i] = (a == null ? void 0 : a.split("filename=")) ?? [];
    if (o != null && o.startsWith("attachment")) {
      const [u] = i.split(";").map((c) => c.replace(/"/g, ""));
      return [n, decodeURIComponent(u)];
    }
    throw new Error("noAttachment");
  }
}), ki = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.includes
    });
    return t.get(
      `v3/user/client_contracts/${e.clientContractId}${r}`
    );
  }
}), Ii = (t) => ({
  query: (e) => t.post(
    `v3/user/client_contracts/${e.clientContractId}/confirms`,
    {
      contract: {
        approved_by_client_at: (/* @__PURE__ */ new Date()).toISOString()
      }
    }
  )
}), $i = (t) => ({
  query: (e, r) => {
    const s = w({
      includes: e.includes
    });
    return t.put(
      `v3/user/client_contracts/${e.clientContractId}${s}`,
      e.information,
      r
    );
  }
}), xi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    }), s = r ? `${r}&type=${e.type}` : `?type=${e.type}`;
    return t.get(`v3/user/contracts${s}`);
  }
}), Ti = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(
      `v3/user/contracts/${e.type}/${e.contractId}${r}`
    );
  }
}), Si = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/user/contracts/${e.contractId}/guest_contacts${r}`
    );
  }
}), Ai = (t) => ({
  query: (e) => t.get(
    `v3/user/contracts/${e.type}/${e.contractId}.pdf`,
    { responseType: "arraybuffer" }
  )
}), Ri = (t) => ({
  query: (e) => t.delete(
    `v3/user/house_multi_inquiry_wishlists/${e.houseId}`
  )
}), Ei = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filters,
      pagination: e.paginate
    });
    return t.get(`v3/user/houses/${e.houseId}/bookings${r}`);
  }
}), Ci = (t) => ({
  query: (e) => t.post(
    `v3/user/houses/${e.houseId}/bookings/${e.bookingId}/owner_bookings/comments`,
    { comment: { content: e.comment } }
  )
}), Oi = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes,
      pagination: e.pagination
    });
    return t.get(`v3/user/houses/${e.houseId}/contracts${r}`);
  }
}), Pi = (t) => ({
  query: (e) => {
    const r = w({ filter: e.filters });
    return t.get(
      `v3/user/houses/${e.houseId}/signatory_owner_contracts${r}`
    );
  }
}), Ni = (t) => ({
  query: (e) => t.get(
    `v3/user/houses/${e.houseId}/contracts/${e.contractId}/timeline_items`
  )
}), Di = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/contract_information`)
}), ji = (t) => ({
  query: (e) => {
    const r = e.context === "company" ? "?context=company" : "";
    return t.put(
      `v3/user/houses/${e.houseId}/contract_information${r}`,
      e.formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
  }
}), Ui = (t) => ({
  query: (e) => t.post(
    `v3/user/houses/${e.houseId}/contracts/${e.contractId}/guest_contacts`,
    { guest_contact: e.guestContact }
  )
}), Li = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/dashboard_analytics`)
}), Bi = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/areas_equipments`)
}), Hi = (t) => ({
  query: (e) => t.get(`v3/user/houses/${e.houseId}/house_staffs`)
}), Fi = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filter,
      pagination: e.paginate
    });
    return t.get(`v3/user/houses${r}`);
  }
}), Mi = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/user/houses/${e.houseId}/stay_information${r}`
    );
  }
}), Zi = (t) => ({
  query: (e) => t.get(
    `v3/user/houses/${e.houseId}/owner_tax_certificates.pdf?year=${e.year}`,
    { responseType: "arraybuffer" }
  )
}), zi = (t) => ({
  query: (e) => t.get(
    `v3/user/houses/${e.houseId}/owner_tax_certificate_available_years`
  )
}), Vi = (t) => ({
  query: (e) => t.post(`v3/user/wishlists/${e.wishlistToken}/houses`, {
    wishlist: e.wishlist
  })
}), Wi = (t) => ({
  query: () => t.get("v3/user/informations")
}), Gi = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      pagination: e.pagination
    });
    return t.get(`v3/user/wishlists/${e.wishlistToken}/houses${r}`);
  }
}), Ji = (t) => ({
  query: (e) => t.put("v3/user/informations", e)
}), Ki = (t) => ({
  query: (e) => t.put("v1/user/informations", e)
}), Xi = (t) => ({
  query: (e) => t.delete(
    `v3/user/wishlists/${e.wishlistToken}/houses/${e.wishlist.house_id}`
  )
}), Qi = (t) => ({
  query: () => t.post("v3/user/messaging/tokens", {})
}), Yi = (t) => ({
  query: (e) => t.put(`v3/users/${e.userId}`, { user: { ...e.user } })
}), ec = (t) => ({
  query: (e) => t.get(
    `v3/user/multi_inquiry_wishlist_availabilities?private_token=${e.privateToken}&check_in=${e.checkIn}&check_out=${e.checkOut}`
  )
}), tc = (t) => ({
  query: (e) => t.post("v3/user/multi_inquiry_wishlists", {
    multi_inquiry_wishlist: { ...e }
  })
}), rc = (t) => ({
  query: (e) => t.delete(
    `v3/user/multi_inquiry_wishlists/${e.wishlistToken}`
  )
}), sc = (t) => ({
  query: (e) => t.get(`v3/user/multi_inquiry_wishlists/${e.wishlistToken}`)
}), nc = (t) => ({
  query: () => t.get("v3/user/multi_inquiry_wishlists")
}), ac = (t) => ({
  query: (e) => t.put(
    `v3/user/multi_inquiry_wishlists/${e.wishlistToken}`,
    { multi_inquiry_wishlist: { ...e } }
  )
}), oc = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filters,
      includes: e.includes
    });
    return t.get(`v3/user/owner_contracts/${e.contractId}${r}`);
  }
}), ic = (t) => ({
  query: (e) => t.post(`v3/user/owner_contracts/${e.contractId}/confirms`, {
    contract: { approved_by_owner_at: e.contract.approved_by_owner_at },
    owner_general_rental_condition_signed: e.owner_general_rental_condition_signed
  })
}), cc = (t) => ({
  modifyUser: Yi(t).query,
  auth: {
    emailSignUp: Bs(t).query,
    finishSignUp: Zs(t).query,
    phoneSignIn: Hs(t).query,
    tokenSignIn: Fs(t).query,
    tokenSignUp: Ms(t).query
  },
  automaticProposal: {
    automaticProposalComments: {
      createAutomaticProposalComment: zs(t).query,
      modifyAutomaticProposalComment: Vs(t).query
    }
  },
  availabilityRequest: {
    getAvailabilityRequestById: vi(t).query,
    modifyAvailabilityRequest: _i(t).query
  },
  awaitingActions: {
    getAwaitingActions: qi(t).query,
    updateOwnerNps: bi(t).query
  },
  checks: {
    downloadCheckPdf: wi(t).query
  },
  clientContracts: {
    getClientContract: ki(t).query,
    confirmClientContract: Ii(t).query,
    sendClientContractInformation: $i(t).query
  },
  contracts: {
    getContractsByType: xi(t).query,
    getContractsById: Ti(t).query,
    getContractPdf: Ai(t).query,
    getGuestContracts: Si(t).query
  },
  houses: {
    getAreasEquipments: Bi(t).query,
    getHouses: Fi(t).query,
    getHouseContacts: Hi(t).query,
    bookings: {
      getBookings: Ei(t).query,
      owner: {
        addComment: Ci(t).query
      }
    },
    getStayInformation: Mi(t).query,
    contracts: {
      addGuestContacts: Ui(t).query,
      getHouseContracts: Oi(t).query,
      modifyContractInformation: ji(t).query,
      getContractInformation: Di(t).query,
      getPaymentTimeline: Ni(t).query,
      getSignatoryOwnerContracts: Pi(t).query
    },
    dashboardAnalytics: {
      getDashboardAnalytics: Li(t).query
    },
    taxCertificates: {
      getOwnerTaxCertificateById: Zi(t).query,
      getOwnerTaxCertificateAvailableYears: zi(t).query
    }
  },
  information: {
    addHouseToUserWishlist: Vi(t).query,
    getUserInfo: Wi(t).query,
    getUserWishlist: Gi(t).query,
    modifyUserInfo: Ji(t).query,
    oldModifyUserInfo: Ki(t).query,
    removeHouseToUserWishlist: Xi(t).query
  },
  messaging: {
    getFirebaseToken: Qi(t).query
  },
  multiInquiryWishlistAvailabilities: {
    getWishlistAvailability: ec(t).query
  },
  multiInquiryWishlists: {
    createWishlist: tc(t).query,
    deleteWishlist: rc(t).query,
    getWishlist: sc(t).query,
    getWishlists: nc(t).query,
    modifyWishlist: ac(t).query
  },
  houseMultiInquiryWishlists: {
    deleteHouseWishlist: Ri(t).query
  },
  ownerContracts: {
    getOwnerContractById: oc(t).query,
    confirmOwnerContractById: ic(t).query
  }
}), uc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include
    });
    return t.get(
      `v3/automatic_proposals${r}&private_token=${e.privateToken}`
    );
  }
}), dc = (t) => ({
  getAutomaticProposals: uc(t).query
}), lc = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas${r}&page=all`
    );
  }
}), fc = (t) => ({
  query: (e) => t.get(
    `v1/houses/${e.houseId}/bookings?private_token=${e.privateToken}&start_date=${e.startAt}&end_date=${e.endAt}&page=1&per=50`
  )
}), yc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/destinations/${e.destinationId}${r}`);
  }
}), hc = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/areas_equipments${e.privateToken ? `?private_token=${e.privateToken}` : ""}`
  )
}), mc = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/houses/${e.houseId}${r}${e.privateToken ? `&private_token=${e.privateToken}` : ""}`
    );
  }
}), pc = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/included_services`.concat(
      e.privateToken ? `?private_token=${e.privateToken}` : ""
    )
  )
}), gc = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/key_features${e.privateToken ? `?private_token=${e.privateToken}` : ""}`
  )
}), vc = (t) => ({
  query: (e) => {
    const r = e.privateToken ? `?private_token=${e.privateToken}` : "";
    return t.get(`v3/houses/${e.houseId}/next_available_dates${r}`);
  }
}), _c = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/house_truth_links${e.privateToken ? `?private_token=${e.privateToken}` : ""}`
  )
}), qc = (t) => ({
  query: (e) => {
    const r = w({
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/houses/${e.houseId}/photos${r}${e.privateToken ? `&private_token=${e.privateToken}` : ""}`
    );
  }
}), bc = (t) => ({
  query: ({
    currency: e = "EUR",
    endDate: r,
    maxBudget: s = "1000000",
    minBudget: n = "0",
    page: a = "all",
    sortBy: o = "recommended",
    startDate: i,
    states: d,
    destinationIds: u,
    housesIds: c
  }) => {
    const f = d ? `&states[]=${d}` : "", h = u && u.length > 0 ? `&${u.map((y) => `destination_ids[]=${y}`).join("&")}` : "", _ = c && c.length > 0 ? `&${c.map((y) => `house_ids[]=${y}`).join("&")}` : "";
    return t.get(
      `v3/ids/house_periods?currency=${e}&end_at=${r}&max_budget=${s}&min_budget=${n}&page=${a}&start_at=${i}&sort_by=${o}${f}${h}${_}`
    );
  }
}), wc = (t) => ({
  query: ({
    currency: e = "EUR",
    endDate: r,
    maxBudget: s = "1000000",
    minBudget: n = "0",
    page: a = "all",
    sortBy: o = "recommended",
    startDate: i,
    houseIds: d,
    destinationIds: u = []
  }) => {
    const c = `&${d.map((f) => `house_ids[]=${f.toString()}`).concat(
      ...u.map((f) => `destination_ids[]=${f.toString()}`)
    ).join("&")}`;
    return t.get(
      `v1/house_periods?currency=${e}&end_at=${r}&max_budget=${s}&min_budget=${n}&page=${a}&start_at=${i}&sort_by=${o}${c}`
    );
  }
}), kc = (t) => ({
  query: (e) => t.get(
    `v3/houses/${e.houseId}/period_durations?private_token=${e.privateToken}&start_at=${e.startAt}&end_at=${e.endAt}&page=all`
  )
}), Ic = (t) => ({
  query: ({
    currency: e = "EUR",
    endDate: r,
    startDate: s,
    houseId: n
  }) => t.get(
    `v1/house_periods/${n}?currency=${e}&end_at=${r}&start_at=${s}`
  )
}), $c = (t) => ({
  query: (e) => {
    const r = `?start_at=${e.startDate}&${e.destinationId.map((s) => `destination_ids[]=${s}`).join("&")}`;
    return t.get(`v3/period_durations/count_by_period_types${r}`);
  }
}), xc = (t) => ({
  getDestinationById: yc(t).query,
  getHouseById: mc(t).query,
  getHouseIncludedServices: pc(t).query,
  getHouseTruthLinks: _c(t).query,
  getHouseKeyFeatures: gc(t).query,
  getPhotosByHouseId: qc(t).query,
  getHouseAreaEquipments: hc(t).query,
  areaGroups: {
    areas: {
      getHouseAreaGroupsAreas: lc(t).query
    }
  },
  bookings: {
    getBookingsByHouseId: fc(t).query
  },
  periods: {
    getHousePeriodsIds: bc(t).query,
    getHousePeriods: wc(t).query,
    getHousePeriodsById: Ic(t).query,
    getPeriodDurations: kc(t).query,
    getCountByPeriodTypes: $c(t).query,
    getHouseNextValidPeriod: vc(t).query
  }
}), Tc = (t) => ({
  query: (e) => t.post("v3/admin/admin_users", e)
}), Sc = (t) => ({
  query: (e) => t.get(`v3/admin/admin_users/${e.userId}`)
}), Ac = (t) => ({
  query: (e) => t.put(`v3/admin/admin_users/${e.userId}`, {
    admin_user: e.admin_user
  })
}), Rc = (t) => ({
  query: (e) => t.delete(`v3/admin/admin_users/${e.userId}`)
}), Ec = (t) => ({
  query: (e) => t.post(
    `v3/admin/admin_users/${e.adminUserId}/house_contacts`,
    { house_contact: e.house_contact }
  )
}), Cc = (t) => ({
  query: (e) => t.delete(
    `v3/admin/admin_users/${e.adminUserId}/house_contacts/${e.houseId}`
  )
}), Oc = (t) => ({
  query: () => t.get("v3/admin/ad_partner_types")
}), Pc = (t) => ({
  query: (e) => t.post(`v3/admin/areas/${e.areaId}/equipments`, e.payload)
}), Nc = (t) => ({
  query: (e) => t.delete(
    `v3/admin/areas/${e.areaId}/equipments/${e.equipmentId}`
  )
}), Dc = (t) => ({
  query: (e) => t.get(`v3/admin/areas/${e.areaId}/equipments`)
}), jc = (t) => ({
  query: (e) => t.put(
    `v3/admin/areas/${e.areaId}/equipments/${e.equipmentId}`,
    e.payload
  )
}), Uc = (t) => ({
  query: () => t.get("v3/admin/area_types?page=all")
}), Lc = (t) => ({
  query: (e) => {
    const r = e.attribute ? `/${e.attribute}` : "", s = w({
      filter: e.filter,
      includes: e.include,
      pagination: e.pagination
    });
    return t.get(`v3/admin/audits/${e.model}/${e.id}${r}${s}`);
  }
}), Bc = (t) => ({
  query: (e) => t.post("v3/admin/auth/password", e)
}), Hc = (t) => ({
  query: (e) => t.get(
    `v3/admin/auth/google_oauth2?access_token=${e.accessToken}&email=${e.email}`
  )
}), Fc = (t) => ({
  query: (e) => t.put("v3/admin/auth/password", e)
}), Mc = (t) => ({
  query: (e) => t.post("v3/admin/auth/sign_in", e)
}), Zc = (t) => ({
  query: () => t.delete("v3/admin/auth/sign_out")
}), zc = (t) => ({
  query: () => t.get("v3/admin/auth/validate_token")
}), Vc = (t) => ({
  query: (e) => t.put(`v3/admin/bank_exports/${e.id}/cancel`, {})
}), Wc = (t) => ({
  query: (e) => t.put(
    `v3/admin/bank_exports/${e.id}/confirm`,
    e.formData,
    {
      headers: { "Content-Type": "multipart/form-data" }
    }
  )
}), Gc = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter
    });
    return t.get(`v3/admin/bank_exports/${e.id}${r}`);
  }
}), Jc = (t) => ({
  query: () => t.get("v3/admin/booking_apis")
}), Kc = (t) => ({
  query: () => t.get("v3/admin/brands?page=all")
}), Xc = (t) => ({
  query: () => t.get("v3/admin/cancelation_causes")
}), Qc = (t) => ({
  query: (e) => t.put(`v3/admin/change_requests/${e.id}`, e.payload)
}), Yc = (t) => ({
  query: (e) => t.post(
    `v3/admin/contracts/${e.contractId}/comments`,
    e.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), eu = (t) => ({
  query: (e) => t.delete(
    `v3/admin/contracts/${e.contractId}/comments/${e.commentId}`
  )
}), tu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/contracts/${e.contractId}/comments${r}`);
  }
}), ru = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/comments/${e.commentId}`,
    e.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), su = (t) => ({
  query: (e) => t.post(
    `v3/admin/contracts/${e.contractId}/client_receipts`,
    { ...e.receipt },
    {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob"
    }
  )
}), nu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/client_receipts${r}`
    );
  }
}), au = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/contracts/${e.contractId}/client_receipts/${e.receiptId}.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), ou = (t) => ({
  query: (e) => t.post(
    `v3/admin/contracts/${e.contractId}/owner_receipts`,
    { ...e.receipt },
    { responseType: "blob" }
  )
}), iu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/owner_receipts${r}`
    );
  }
}), cu = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/contracts/${e.contractId}/owner_receipts/${e.receiptId}.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), uu = (t) => ({
  query: (e) => t.delete(
    `v3/admin/contracts/${e.contractId}/payment_transaction_deposits`
  )
}), du = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/payment_transactions${r}`
    );
  }
}), lu = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/payment_transactions/${e.ptId}`,
    e.payment_transaction
  )
}), fu = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/payment_transactions/${e.ptId}`,
    { payment_transaction: e.payment_transaction }
  )
}), yu = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/manually_signed_client_contracts`,
    e.FormData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), hu = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/manually_signed_owner_contracts`,
    e.FormData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), mu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/contracts/${e.contractId}/timeline_items${r}`
    );
  }
}), pu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/contracts/${e.contractId}${r}`);
  }
}), gu = (t) => ({
  query: (e) => t.put(`v3/admin/contracts/${e.contractId}`, e.contract)
}), vu = (t) => ({
  query: (e) => t.put(
    `v3/admin/contracts/${e.contractId}/cancelation`,
    e.payload
  )
}), _u = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/contracts/${e.contractId}/signed_${e.contractVersion}_contract.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), qu = (t) => ({
  query: (e) => t.put(`v3/admin/contracts/${e.contractId}`, e.formData, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}), bu = (t) => ({
  query: (e) => t.post("v3/admin/credits", e.payload)
}), wu = (t) => ({
  query: (e) => t.delete(`v3/admin/credits/${e.creditId}`)
}), ku = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/credits/${e.creditId}${r}`);
  }
}), Iu = (t) => ({
  query: (e) => t.put(`v3/admin/credits/${e.creditId}`, e.payload)
}), $u = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/destinations/${e.destinationId}${r}`);
  }
}), xu = (t) => ({
  query: (e) => t.post("v3/admin/destinations", e)
}), Tu = (t) => ({
  query: (e) => t.post(`v3/admin/destinations/${e.destinationId}`, {
    ...e.destination
  })
}), Su = (t) => ({
  query: (e) => t.delete(`v3/admin/destinations/${e.destinationId}`)
}), Au = (t) => ({
  query: (e) => {
    const r = w({
      pagination: (e == null ? void 0 : e.pagination) ?? { page: "1", per: "100" }
    });
    return t.get(`v3/admin/experiences${r}`);
  }
}), Ru = (t) => ({
  query: (e) => {
    const r = w({
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/destinations/${e.destinationId}/experiences${r}`
    );
  }
}), Eu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/destination_trees${r}`);
  }
}), Cu = (t) => ({
  query: () => t.get("v3/admin/equipment_types?page=all")
}), Ou = (t) => ({
  query: () => t.get("v3/admin/event_types")
}), Pu = (t) => ({
  query: (e) => t.put(
    `v3/admin/expected_pay_outs/${e.expectedPayOutId}/assigns`,
    e.formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  )
}), Nu = (t) => ({
  query: (e) => t.put(
    `v3/admin/expected_pay_outs/${e.expectedPayOutId}/credits/assigns`,
    { credit_ids: e.creditIds }
  )
}), Du = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(
      `v3/admin/expected_pay_outs/${e.expectedPayOutId}${r}`
    );
  }
}), ju = (t) => ({
  query: () => t.post("v3/admin/exports/figaro", {})
}), Uu = (t) => ({
  query: (e) => t.post("v3/admin/exports/incoming_payment_transactions", {
    ...e
  })
}), Lu = (t) => ({
  query: (e) => t.post("v3/admin/exports/tourist_taxes", e.payload)
}), Bu = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/exports/figaro${r}`);
  }
}), Hu = (t) => ({
  query: (e) => t.get(
    `v3/admin/exports/incoming_payment_transactions/${e.id}`,
    { responseType: "blob" }
  )
}), Fu = (t) => ({
  query: (e) => t.get(`v3/admin/exports/pay_outs/${e.id}`, {
    responseType: "blob"
  })
}), Mu = (t) => ({
  query: (e) => t.get(`v3/admin/exports/tourist_taxes/${e.id}`, {
    responseType: "blob"
  })
}), Zu = (t) => ({
  query: (e) => t.post(
    `v3/admin/exports/incoming_payment_transactions/${e.id}`,
    { ...e.export }
  )
}), zu = (t) => ({
  query: (e) => t.put(`v3/admin/exports/tourist_taxes/${e.id}`, e.payload)
}), Vu = (t) => ({
  query: (e) => t.post("v3/admin/financial_reports/houses_vat_recoverys", e, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}), er = (t = "terms_of_services") => ["terms_of_services", "privacy_policy"].includes(t) ? t : `${t}_general_rental_conditions`, Wu = (t) => ({
  query: ({
    type: e,
    ...r
  }) => t.post(`v3/admin/${er(e)}`, r)
}), Gu = (t) => ({
  query: (e) => t.get(
    `v3/admin/${er(e.type)}?page=${e.page}`
  )
}), Ju = (t) => ({
  query: (e) => t.get(
    `v3/admin/${er(e.type)}/${e.id}`
  )
}), Ku = (t) => ({
  query: () => t.get("v3/admin/house_architectural_styles")
}), Xu = (t) => ({
  query: () => t.get("v3/admin/house_categories")
}), Qu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/ad_partners`,
    e.payload
  )
}), Yu = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas`,
    e.payload
  )
}), ed = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/areas/${e.areaId}/duplicate_areas`,
    {
      area: e.area
    }
  )
}), td = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/area_groups`,
    e.payload
  )
}), rd = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/calendar_import`,
    e.payload
  )
}), sd = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/stay_information/codes`,
    e.payload
  )
}), nd = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/places/${e.placeId}/distances`,
    { ...e.params }
  )
}), ad = (t) => ({
  query: (e) => t.post("v3/admin/houses", e)
}), od = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/house_truth_links`,
    e.payload
  )
}), id = (t) => ({
  query: (e) => t.post(`v3/admin/houses/${e.houseId}/links`, e.payload)
}), cd = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/period_durations`,
    e.payload
  )
}), ud = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/period_prices`,
    e.payload
  )
}), dd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas/${e.areaId}`
  )
}), ld = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}`
  )
}), fd = (t) => ({
  query: (e) => t.delete(`v3/admin/houses/${e.houseId}/calendar_import`)
}), yd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/stay_information/codes/${e.codeId}`
  )
}), hd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/house_truth_links/${e.houseTruthLinkId}`
  )
}), md = (t) => ({
  query: (e) => t.delete(`v3/admin/houses/${e.houseId}/links/${e.linkId}`)
}), pd = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/ad_partners`)
}), gd = (t) => ({
  query: (e) => t.get(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas/${e.areaId}`
  )
}), vd = (t) => ({
  query: (e) => t.get(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}`
  )
}), _d = (t) => ({
  query: (e) => {
    var s;
    const r = w({ filter: (s = e == null ? void 0 : e.included) == null ? void 0 : s.filter });
    return t.get(`v3/admin/houses/${e.houseId}/area_groups${r}`);
  }
}), qd = (t) => ({
  query: (e) => {
    var s, n;
    const r = w({
      filter: (s = e.included) == null ? void 0 : s.filter,
      pagination: (n = e == null ? void 0 : e.included) == null ? void 0 : n.pagination
    });
    return t.get(
      `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas${r}`
    );
  }
}), bd = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/calendar_import`)
}), wd = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(
      `v3/admin/houses/${e.houseId}/signatory/credits${r}`
    );
  }
}), kd = (t) => ({
  query: (e) => t.get(
    `v3/admin/houses/${e.houseId}/places/${e.placeId}/distances`
  )
}), Id = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.included,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}${r}`);
  }
}), $d = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    if (e.houseIds.length > 0) {
      const s = `?ids=${e.houseIds.join(",")}`;
      return t.get(`v3/admin/houses${s}`, {
        ...e.params
      });
    }
    return t.get(`v3/admin/houses${r}`);
  }
}), xd = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/house_truth_links`)
}), Td = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/period_durations${r}`);
  }
}), Sd = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/period_prices${r}`);
  }
}), Ad = (t) => ({
  query: (e) => {
    var s, n, a;
    const r = w({
      filter: (s = e.included) == null ? void 0 : s.filter,
      includes: (n = e.included) == null ? void 0 : n.includes,
      pagination: (a = e.included) == null ? void 0 : a.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/reviews${r}`);
  }
}), Rd = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/sale_information`)
}), Ed = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/houses/${e.houseId}/stay_information${r}`);
  }
}), Cd = (t) => ({
  query: (e) => t.get(`v3/admin/houses/${e.houseId}/surrounding_information`)
}), Od = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/ad_partners`,
    e.payload
  )
}), Pd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}/areas/${e.areaId}`,
    e.payload
  )
}), Nd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/area_groups/${e.areaGroupId}`,
    e.payload
  )
}), Dd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/areas/${e.areaId}/area_photos`,
    {
      area: {
        area_photos_attributes: e.photoIds.map((r) => ({
          photo_id: r
        }))
      }
    }
  )
}), jd = (t) => ({
  query: (e) => t.put(`v3/admin/houses/${e.houseId}/automatic_offer`, {
    automatic_offer: e.automatic_offer
  })
}), Ud = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/calendar_import`,
    e.payload
  )
}), Ld = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/stay_information/codes/${e.codeId}`,
    e.payload
  )
}), Bd = (t) => ({
  query: (e) => e.formData ? t.put(`v3/admin/houses/${e.houseId}`, e.formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }) : t.put(`v3/admin/houses/${e.houseId}`, {
    house: e.house
  })
}), Hd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/house_truth_links/${e.houseTruthLinkId}`,
    e.payload
  )
}), Fd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/links/${e.linkId}`,
    e.payload
  )
}), Md = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/period_durations/${e.periodDurationId}`,
    e.payload
  )
}), Zd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/period_prices/${e.periodPriceId}`,
    e.payload
  )
}), zd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/reviews/${e.reviewId}`,
    e.payload
  )
}), Vd = (t) => ({
  query: (e) => {
    const r = e.isFormData ? { "Content-Type": "multipart/form-data" } : void 0;
    return t.put(
      `v3/admin/houses/${e.houseId}/sale_information`,
      e.payload,
      { headers: r }
    );
  }
}), Wd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/stay_information`,
    e.payload
  )
}), Gd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/surrounding_information`,
    e.payload
  )
}), Jd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/period_durations/${e.periodDurationId}`
  )
}), Kd = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/period_prices/${e.periodPriceId}`
  )
}), Xd = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/pricing_periods`,
    e.payload
  )
}), Qd = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/pricing_periods${r}`);
  }
}), Yd = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/pricing_periods/${e.pricingPeriodId}`,
    e.payload
  )
}), el = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/pricing_periods/${e.pricingPeriodId}`
  )
}), tl = (t) => ({
  query: (e) => t.post(
    `v3/admin/houses/${e.houseId}/rack_rates`,
    e.payload
  )
}), rl = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/houses/${e.houseId}/rack_rates${r}`);
  }
}), sl = (t) => ({
  query: (e) => t.put(
    `v3/admin/houses/${e.houseId}/rack_rates/${e.rackRateId}`,
    e.payload
  )
}), nl = (t) => ({
  query: (e) => t.delete(
    `v3/admin/houses/${e.houseId}/rack_rates/${e.rackRateId}`
  )
}), al = (t) => ({
  query: (e) => t.post("v3/admin/house_staffs", e.payload)
}), ol = (t) => ({
  query: (e) => t.put(
    `v3/admin/house_staffs/${e.houseStaffId}`,
    e.payload
  )
}), il = (t) => ({
  query: (e) => t.delete(`v3/admin/house_staffs/${e.houseStaffId}`)
}), cl = (t) => ({
  query: () => t.get("v3/admin/house_styles")
}), ul = (t) => ({
  query: async (e) => {
    const r = await t.get(
      `v3/admin/hubspot/contracts/${e.contractVersion}_contracts/${e.contractId}.pdf`,
      { responseType: "blob" }
    );
    return "data" in r ? r.data : r;
  }
}), dl = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/included_services${r}`);
  }
}), ll = (t) => ({
  query: (e) => t.get(
    `v3/admin/owner_tax_certificates/${e.houseId}.pdf?year=${e.year}`,
    { responseType: "blob" }
  )
}), fl = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/pay_ins/${e.payInId}${r}`);
  }
}), yl = (t) => ({
  query: (e) => t.post(`v3/admin/pay_ins/${e.payInId}/assigns`, e.params)
}), hl = (t) => ({
  query: () => t.get("v3/admin/payment_schedules")
}), ml = (t) => ({
  query: (e) => t.get(
    `v3/admin/payment_transactions/${e.paymentTransactionId}/pay_outs`
  )
}), pl = (t) => ({
  query: (e) => t.get(
    `v3/admin/pending_damage_control_checks${e.query || ""}`
  )
}), gl = (t) => ({
  query: (e) => t.put(`v3/admin/photos/${e.photoId}`, {
    position: e.position,
    hidden: e.hidden
  })
}), vl = (t) => ({
  query: (e) => t.delete(`v3/admin/photos/${e.photoId}`)
}), _l = (t) => ({
  query: (e) => t.post(
    `v3/admin/places/${e.placeId}/destination_places`,
    e.payload
  )
}), ql = (t) => ({
  query: (e) => t.post(
    `v3/admin/places/${e.placeId}/house_places`,
    e.payload
  )
}), bl = (t) => ({
  query: (e) => t.post("v3/admin/places", e.payload)
}), wl = (t) => ({
  query: (e) => t.get(`v3/admin/places/${e.placeId}`)
}), kl = (t) => ({
  query: (e) => t.put(`v3/admin/places/${e.placeId}`, e.payload)
}), Il = (t) => ({
  query: (e) => t.delete(
    `v3/admin/places/${e.placeId}/destination_places/${e.destinationId}`
  )
}), $l = (t) => ({
  query: (e) => t.delete(
    `v3/admin/places/${e.placeId}/house_places/${e.houseId}`
  )
}), xl = (t) => ({
  query: (e) => t.delete(`v3/admin/places/${e.placeId}`)
}), Tl = (t) => ({
  query: (e) => {
    const r = w({
      includes: e.include,
      filter: e.filter,
      pagination: e.pagination
    });
    return t.get(`v3/admin/place_types${r}`);
  }
}), Sl = (t) => ({
  query: (e) => t.post("v3/admin/pools", e.payload)
}), Al = (t) => ({
  query: (e) => t.get(`v3/admin/pools/${e.poolId}`)
}), Rl = (t) => ({
  query: (e) => t.get(`v3/admin/pools?ids=${e.poolIds.join()}`)
}), El = (t) => ({
  query: (e) => t.put(`v3/admin/pools/${e.poolId}`, e.payload)
}), Cl = (t) => ({
  query: () => t.get("v3/admin/subsidiaries")
}), Ol = (t) => ({
  query: (e) => t.get(
    `v3/admin/tailor/contracts/${e.contractId}/appointments`
  )
}), Pl = (t) => ({
  query: (e) => t.get(
    `v3/admin/tailor/contracts/${e.contractId}/appointments/${e.appointmentId}`
  )
}), Nl = (t) => ({
  query: () => t.get("v3/admin/themes")
}), Dl = (t) => ({
  query: (e) => t.post("v3/admin/users/invitation", e)
}), jl = (t) => ({
  query: (e) => t.put(`v3/admin/users/${e.userId}/invitation`, {})
}), Ul = (t) => ({
  query: (e) => t.post("v3/admin/vouchers", e.payload)
}), Ll = (t) => ({
  query: (e) => t.post(
    `v3/admin/vouchers/${e.voucherId}/assigns`,
    e.params
  )
}), Bl = (t) => ({
  query: (e) => {
    const r = w({ includes: e.included });
    return t.get(`v3/admin/vouchers/${e.voucherId}${r}`);
  }
}), Hl = (t) => ({
  query: (e) => t.put(`v3/admin/vouchers/${e.voucherId}`, e.payload)
}), Fl = (t) => ({
  query: (e) => t.delete(`v3/admin/vouchers/${e.voucherId}`)
}), Ml = (t) => ({
  adminUser: {
    createAdminUser: Tc(t).query,
    getAdminUser: Sc(t).query,
    modifyAdminUser: Ac(t).query,
    removeAdminUser: Rc(t).query,
    houseContacts: {
      createHouseContact: Ec(t).query,
      removeHouseContact: Cc(t).query
    }
  },
  adPartnerType: {
    getAdPartnerTypes: Oc(t).query
  },
  areaTypes: {
    getAreaTypes: Uc(t).query
  },
  audits: {
    getAuditById: Lc(t).query
  },
  auth: {
    forgotPassword: Bc(t).query,
    googleSignIn: Hc(t).query,
    resetPassword: Fc(t).query,
    signIn: Mc(t).query,
    signOut: Zc(t).query,
    validateToken: zc(t).query
  },
  areas: {
    equipements: {
      createEquipement: Pc(t).query,
      deleteEquipement: Nc(t).query,
      getEquipements: Dc(t).query,
      modifyEquipement: jc(t).query
    }
  },
  bankExports: {
    cancelBankExport: Vc(t).query,
    confirmBankExport: Wc(t).query,
    getBankExports: Gc(t).query
  },
  bookingApis: {
    getBookingApis: Jc(t).query
  },
  brands: {
    getBrands: Kc(t).query
  },
  cancelationCauses: {
    getCancelationCauses: Xc(t).query
  },
  changeRequests: {
    modifyChangeRequest: Qc(t).query
  },
  generalConditions: {
    createCondition: Wu(t).query,
    getConditionById: Ju(t).query,
    getConditions: Gu(t).query
  },
  contracts: {
    cancelContract: vu(t).query,
    comments: {
      addComment: Yc(t).query,
      deleteComment: eu(t).query,
      getComments: tu(t).query,
      modifyComment: ru(t).query
    },
    getContractById: pu(t).query,
    getSignedContractPdf: _u(t).query,
    manuallySignedContracts: {
      modifyClientContract: yu(t).query,
      modifyOwnerContract: hu(t).query
    },
    modifyContract: gu(t).query,
    modifyClientInfo: qu(t).query,
    receipts: {
      createClientReceiptByContractId: su(t).query,
      createOwnerReceiptByContractId: ou(t).query,
      getClientReceipByContractId: nu(t).query,
      getClientReceiptPdf: au(t).query,
      getOwnerReceipByContractId: iu(t).query,
      getOwnerReceiptPdf: cu(t).query
    },
    paymentTransactions: {
      getPaymentTransactionByContractId: du(t).query,
      modifyPaymentTransaction: lu(t).query,
      modifyPayOut: fu(t).query
    },
    paymentTransactionDeposits: {
      deletePaymentTransactionDeposits: uu(t).query
    },
    timeline: {
      getTimelineItemsByContractId: mu(t).query
    }
  },
  credits: {
    createCredit: bu(t).query,
    deleteCredit: wu(t).query,
    getCredit: ku(t).query,
    modifyCredit: Iu(t).query
  },
  destinations: {
    addDestination: xu(t).query,
    experiences: {
      getDestinationExperiences: Ru(t).query,
      getExperiences: Au(t).query
    },
    getDestinationById: $u(t).query,
    modifyDestination: Tu(t).query,
    removeDestination: Su(t).query
  },
  destinationTree: {
    getTree: Eu(t).query
  },
  equipementTypes: {
    getEquipementTypes: Cu(t).query
  },
  eventTypes: {
    getEventTypes: Ou(t).query
  },
  expectedPayOuts: {
    approveExpectedPayOut: Pu(t).query,
    getExpectedPayOut: Du(t).query,
    credits: {
      assignCredits: Nu(t).query
    }
  },
  exports: {
    figaro: {
      addExport: ju(t).query,
      getExport: Bu(t).query
    },
    incomingPaymentTransaction: {
      addExport: Uu(t).query,
      getIncomingPaymentTransaction: Hu(t).query,
      modifyExport: Zu(t).query
    },
    payOuts: {
      getPayOut: Fu(t).query
    },
    touristTaxe: {
      addExport: Lu(t).query,
      getTouristTax: Mu(t).query,
      modifyExport: zu(t).query
    }
  },
  financialReports: {
    sendHousesVatRecovery: Vu(t).query
  },
  houseArchitecturalStyles: {
    getArchitecturalStyles: Ku(t).query
  },
  houses: {
    adPartners: {
      addAdPartner: Qu(t).query,
      getAdPartners: pd(t).query,
      modifyAdPartner: Od(t).query
    },
    areaGroups: {
      areas: {
        addArea: Yu(t).query,
        deleteArea: dd(t).query,
        getArea: gd(t).query,
        getAreas: qd(t).query,
        modifyArea: Pd(t).query
      },
      addAreaGroup: td(t).query,
      deleteAreaGroup: ld(t).query,
      getAreaGroup: vd(t).query,
      getAreaGroups: _d(t).query,
      modifyAreaGroup: Nd(t).query
    },
    areas: {
      addAreaDuplicate: ed(t).query,
      areaPhotos: {
        modifyAreaPhotos: Dd(t).query
      }
    },
    automaticOffer: {
      modifyAutomaticOffer: jd(t).query
    },
    calendarImport: {
      addCalendarImport: rd(t).query,
      deleteCalendarImport: fd(t).query,
      getCalendarImport: bd(t).query,
      modifyCalendarImport: Ud(t).query
    },
    houseTruthLinks: {
      addHouseTruthLink: od(t).query,
      deleteHouseTruthLink: hd(t).query,
      getHouseTruthLinks: xd(t).query,
      modifyHouseTruthLink: Hd(t).query
    },
    links: {
      addLink: id(t).query,
      deleteLink: md(t).query,
      modifyLink: Fd(t).query
    },
    periodDurations: {
      addPeriodDuration: cd(t).query,
      getPeriodDurations: Td(t).query,
      modifyPeriodDuration: Md(t).query,
      removePeriodDuration: Jd(t).query
    },
    periodPrices: {
      addPeriodPrice: ud(t).query,
      getPeriodPrices: Sd(t).query,
      modifyPeriodPrice: Zd(t).query,
      removePeriodPrice: Kd(t).query
    },
    pricingPeriods: {
      addPricingPeriod: Xd(t).query,
      getPricingPeriods: Qd(t).query,
      modifyPricingPeriod: Yd(t).query,
      removePricingPeriod: el(t).query
    },
    places: {
      distances: {
        addDistance: nd(t).query,
        getDistances: kd(t).query
      }
    },
    signatory: {
      credits: {
        getCredits: wd(t).query
      }
    },
    rackRates: {
      addRackRate: tl(t).query,
      getRackRates: rl(t).query,
      modifyRackRate: sl(t).query,
      removeRackRate: nl(t).query
    },
    reviews: {
      getReviews: Ad(t).query,
      modifyReview: zd(t).query
    },
    saleInformation: {
      getSaleInformation: Rd(t).query,
      modifySaleInformation: Vd(t).query
    },
    surroundingInformation: {
      getSurroundingInformation: Cd(t).query,
      modifySurroundingInformation: Gd(t).query
    },
    stayInformation: {
      codes: {
        addCode: sd(t).query,
        deleteCode: yd(t).query,
        modifyCode: Ld(t).query
      },
      getStayInformation: Ed(t).query,
      modifyStayInformation: Wd(t).query
    },
    addHouse: ad(t).query,
    getHouseById: Id(t).query,
    getHouses: $d(t).query,
    modifyHouse: Bd(t).query
  },
  houseCategories: {
    getHouseCategories: Xu(t).query
  },
  houseStaffs: {
    addHouseStaff: al(t).query,
    modifyHouseStaff: ol(t).query,
    removeHouseStaff: il(t).query
  },
  houseStyles: {
    getHouseStyles: cl(t).query
  },
  hubspot: {
    getHubspotContractPdf: ul(t).query
  },
  includedServices: {
    getIncludedServices: dl(t).query
  },
  ownerTaxCertificates: {
    getTaxCertificateById: ll(t).query
  },
  payIns: {
    assign: {
      assignPayIn: yl(t).query
    },
    getPayIn: fl(t).query
  },
  paymentSchedules: {
    getPaymentSchedules: hl(t).query
  },
  paymentTransactions: {
    payOuts: {
      getPayOuts: ml(t).query
    }
  },
  pendingDamageControlChecks: {
    getPendingDamageControlChecks: pl(t).query
  },
  photos: {
    modifyPhoto: gl(t).query,
    removePhoto: vl(t).query
  },
  places: {
    destinationPlaces: {
      addDestinationPlace: _l(t).query,
      removeDestinationPlace: Il(t).query
    },
    housePlaces: {
      addHousePlace: ql(t).query,
      removeHousePlace: $l(t).query
    },
    addPlace: bl(t).query,
    getPlaceById: wl(t).query,
    modifyPlace: kl(t).query,
    removePlace: xl(t).query
  },
  placeTypes: {
    getPlaceTypes: Tl(t).query
  },
  pools: {
    addPool: Sl(t).query,
    getPoolById: Al(t).query,
    getPools: Rl(t).query,
    modifyPool: El(t).query
  },
  subsidiaries: {
    getSubsidiaries: Cl(t).query
  },
  tailor: {
    getAppointments: Ol(t).query,
    getAppointment: Pl(t).query
  },
  themes: {
    getThemes: Nl(t).query
  },
  user: {
    invitation: {
      addInvitation: Dl(t).query,
      modifyInvitation: jl(t).query
    }
  },
  vouchers: {
    assign: {
      assignVoucher: Ll(t).query
    },
    addVoucher: Ul(t).query,
    getVoucher: Bl(t).query,
    modifyVoucher: Hl(t).query,
    removeVoucher: Fl(t).query
  }
}), Zl = (t) => ({
  query: (e) => t.post("v3/contacts", e.payload)
}), zl = (t) => ({
  createContactRequest: Zl(t).query
}), Vl = (t) => ({
  query: (e) => t.post("v3/request_wishlists", {
    request_wishlist: { ...e }
  })
}), Wl = (t) => ({
  query: (e) => t.put("v3/request_wishlists", {
    request_wishlist: { ...e }
  })
}), Gl = (t) => ({
  makeRequestWishlist: Vl(t).query,
  modifyRequestWishlist: Wl(t).query
}), Jl = (t) => ({
  query: () => t.get("v3/searchable_tags/identifiers")
}), Kl = (t) => ({
  getIdentifiers: Jl(t).query
}), Xl = (t) => ({
  query: (e) => t.get(
    `v3/multi_inquiry_wishlists?private_token=${e.wishlistToken}`
  )
}), Ql = (t) => ({
  getWishlistShared: Xl(t).query
}), Yl = (t) => ({
  query: (e) => t.get(
    `v3/tailor/contracts/${e.contractId}/client_itinerary`
  )
}), ef = (t) => ({
  query: (e) => t.get(`v3/tailor/contracts/${e}/links_and_documents`)
}), tf = (t) => ({
  query: (e) => t.get(`v3/tailor/contracts/${e.contractId}/appointments`)
}), rf = (t) => ({
  contracts: {
    getClientItinerary: Yl(t).query,
    getAllDocuments: ef(t).query,
    getAppointments: tf(t).query
  }
}), sf = (t) => ({
  query: () => t.get("v3/marketplace/user/permission")
}), nf = (t) => ({
  getMarketplacePermission: sf(t).query
}), af = (t) => ({
  query: () => t.get("v1/privacy_policy")
}), of = (t) => ({
  getPrivacyPolicy: af(t).query
}), cf = (t) => ({
  query: (e) => t.post("v3/newsletter_emails", e)
}), uf = (t) => ({
  subscribeNewsletter: cf(t).query
}), df = (t) => ({
  query: () => t.get("v1/auth/validate_token")
}), lf = (t) => ({
  query: (e) => t.post("v1/auth/sign_in", e)
}), ff = (t) => ({
  query: () => t.delete("v1/auth/sign_out")
}), yf = (t) => ({
  query: (e) => t.get(
    `v1/auth/invitation?email=${encodeURIComponent(e.email)}`
  )
}), hf = (t) => ({
  session: {
    getValidateToken: df(t).query,
    signIn: lf(t).query,
    signOut: ff(t).query,
    verifyUserEmail: yf(t).query
  }
}), mf = (t) => hf(t), pf = (t) => ({
  query: (e) => t.get(`v1/owner_contracts/${e.contractId}`)
}), gf = (t) => ({
  query: () => t.get("v1/owner_general_rental_condition")
}), vf = (t) => ({
  query: (e) => {
    const r = e.ownerIsCompany ? "company" : "individual";
    return t.put(
      `v1/owner_contracts/${e.contractId}?context=${r}`,
      { contract: e.authSystem }
    );
  }
}), _f = (t) => ({
  owner: {
    getContractById: pf(t).query,
    getOwnerGeneralRentalCondition: gf(t).query,
    sendSmsOrEmailAuthSystem: vf(t).query
  }
}), qf = (t) => ({
  query: (e) => t.post("v2/waiting_searches", e.payload)
}), bf = (t) => ({
  addWaitingSearch: qf(t).query
}), wf = (t) => Mt(Ds(t), cc(t)), kf = (t) => Mt(Es(t), Ls(t)), If = (t) => ({
  query: (e) => t.get(
    `lp-destinations/find-by-slug/${e.slug}?locale=${e.locale}`
  )
}), $f = (t) => ({
  query: (e) => t.get(
    `collection-groups?sort=id&filters[lp_inspiration]&filters[lp_destination]=${e.destinationId}`
  )
}), xf = (t) => ({
  query: (e) => t.get(
    `popular-destinations?sort=position&filters[lp_inspiration]&filters[lp_destination]=${e.destinationId}`
  )
}), Tf = (t) => ({
  getLandingPageDestination: If(t).query,
  getLandingPageDestinationHouses: $f(t).query,
  getLandingPagePopularDestinations: xf(t).query
});
class ks {
  constructor(e) {
    this.httpSource = e, this.headersCustom = null;
  }
  setHeaders({ accessToken: e, client: r, uid: s }) {
    this.headersCustom = { accessToken: e, client: r, uid: s };
  }
  getHeaders() {
    return this.headersCustom ? {
      "access-token": this.headersCustom.accessToken,
      client: this.headersCustom.client,
      uid: this.headersCustom.uid,
      ...this.httpSource ? { Httpsource: this.httpSource } : {}
    } : null;
  }
  clearHeaders() {
    this.headersCustom = null;
  }
}
class Is {
  constructor() {
    this.localeCustom = null;
  }
  setLocale(e) {
    this.localeCustom = e;
  }
  getLocale() {
    return this.localeCustom;
  }
}
const Pf = () => ({
  en: "",
  fr: ""
}), Sf = ({
  interceptors: t,
  source: e,
  storageClient: r
}) => {
  const s = (a) => {
    const o = (a == null ? void 0 : a.get("access-token")) || "", i = (a == null ? void 0 : a.get("client")) || "", d = (a == null ? void 0 : a.get("uid")) || "";
    return {
      accessToken: o,
      client: i,
      uid: d
    };
  }, n = (a) => {
    const { accessToken: o, client: i, uid: d } = s(a.headers);
    o && i && d && (r == null || r.setItem("accessToken", o), r == null || r.setItem("client", i), r == null || r.setItem("uid", d));
  };
  return {
    triggerOnResponse: (a) => (n(a), Array.isArray(t == null ? void 0 : t.response) && (t == null || t.response.forEach((o) => o(a))), a.status === 200 ? { ...a } : Promise.reject({
      response: { data: a._data, status: a.status }
    })),
    getHeaders: async () => {
      const a = await (r == null ? void 0 : r.getItem("accessToken")), o = await (r == null ? void 0 : r.getItem("client")), i = await (r == null ? void 0 : r.getItem("uid"));
      let d = { Httpsource: e };
      return a && o && i && (d = {
        "access-token": a,
        client: o,
        uid: i,
        Httpsource: d.Httpsource
      }), d;
    }
  };
}, $s = ({
  api: t,
  locale: e,
  storageClient: r,
  headersCustom: s,
  localeCustom: n
}) => {
  const a = (i) => `${t.url}/${i}/api/`, o = Sf({
    apiUrl: t.url,
    getDeviceUniqueId: t.getDeviceUniqueId,
    interceptors: t.interceptors,
    locale: e,
    source: t.source,
    storageClient: r
  });
  return {
    get: async (i, d) => {
      try {
        const u = n == null ? void 0 : n.getLocale(), c = a(u || e), f = s != null && s.getHeaders() ? s.getHeaders() : await o.getHeaders(), h = await X(`${c}${i}`, {
          method: "GET",
          onResponse: ({ response: _ }) => o.triggerOnResponse(
            _
          ),
          ...d ?? {},
          headers: { ...f, ...(d == null ? void 0 : d.headers) ?? {} }
        });
        return d != null && d.responseType ? Promise.resolve(h) : Promise.resolve(
          ne(h)
        );
      } catch (u) {
        return Promise.resolve({
          errors: u
        });
      }
    },
    post: async (i, d, u) => {
      try {
        const c = n == null ? void 0 : n.getLocale(), f = a(c || e), h = s != null && s.getHeaders() ? s.getHeaders() : await o.getHeaders(), _ = await X(`${f}${i}`, {
          method: "POST",
          body: d,
          onResponse: ({ response: y }) => o.triggerOnResponse(
            y
          ),
          ...u ?? {},
          headers: { ...h, ...(u == null ? void 0 : u.headers) ?? {} }
        });
        return Promise.resolve(ne(_));
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    put: async (i, d, u) => {
      try {
        const c = n == null ? void 0 : n.getLocale(), f = a(c || e), h = s != null && s.getHeaders() ? s.getHeaders() : await o.getHeaders(), _ = await X(`${f}${i}`, {
          method: "PUT",
          body: d,
          onResponse: ({ response: y }) => o.triggerOnResponse(
            y
          ),
          ...u ?? {},
          headers: { ...h, ...(u == null ? void 0 : u.headers) ?? {} }
        });
        return Promise.resolve(ne(_));
      } catch (c) {
        return Promise.resolve({
          errors: c
        });
      }
    },
    delete: async (i) => {
      try {
        const d = n == null ? void 0 : n.getLocale(), u = a(d || e), c = s != null && s.getHeaders() ? s.getHeaders() : await o.getHeaders(), f = await X(`${u}${i}`, {
          method: "DELETE",
          headers: c,
          onResponse: ({ response: h }) => o.triggerOnResponse(
            h
          )
        });
        return Promise.resolve(ne(f));
      } catch (d) {
        return Promise.resolve({
          errors: d
        });
      }
    },
    raw: async (i, d) => {
      const u = (n == null ? void 0 : n.getLocale()) ?? e, c = a(u), f = s != null && s.getHeaders() ? s.getHeaders() : await o.getHeaders(), h = await X.raw(`${c}${i}`, {
        method: "GET",
        onResponse: ({ response: _ }) => o.triggerOnResponse(
          _
        ),
        ...d,
        headers: { ...f, ...d.headers ?? {} }
      });
      return { headers: h.headers, _data: h._data };
    }
  };
}, Nf = {
  lc: ({
    api: t,
    locale: e,
    storageClient: r,
    httpClientType: s = "axios"
  }) => {
    const n = new ks(t.source), a = new Is(), o = (s === "axios" ? oe : $s)({
      // @ts-expect-error ResT can be instanciated with an unrelated type
      api: t,
      locale: e,
      localeCustom: a,
      storageClient: r,
      headersCustom: n
    });
    return {
      admin: Ml(o),
      auth: mf(o),
      contacts: zl(o),
      contracts: _f(o),
      user: wf(o),
      houses: xc(o),
      legal: of(o),
      request: kf(o),
      requestWishlists: Gl(o),
      searchableTag: Kl(o),
      multiInquiryWishlists: Ql(o),
      tailor: rf(o),
      automaticProposals: dc(o),
      marketplace: nf(o),
      newsletterEmails: uf(o),
      waitingSearches: bf(o),
      headers: n,
      localeCustom: a
    };
  },
  strapiAdmin: ({ api: t }) => {
    const e = oe({ api: t, unserialized: !0 });
    return {
      lpDestination: Tf(e)
    };
  }
}, Df = {
  lc: ({
    api: t,
    locale: e,
    storageClient: r,
    httpClientType: s = "axios"
  }) => {
    const n = new ks(t.source), a = new Is();
    return {
      httpClient: (s === "axios" ? oe : $s)({
        // @ts-expect-error ResT can be instanciated with an unrelated type
        api: t,
        locale: e,
        localeCustom: a,
        storageClient: r,
        headersCustom: n
      }),
      headers: n,
      localeCustom: a
    };
  }
};
export {
  Ml as AdminRepository,
  mf as AuthRepository,
  zl as ContactsRepository,
  _f as ContractRepository,
  Rf as DocVerifier,
  Ef as GeoCoding,
  xc as HouseRepository,
  Cf as Hubspot,
  Tf as LPRepository,
  of as LegalRepository,
  nf as MarketplaceRepository,
  Ql as MultiInquiryWishlistsRepository,
  uf as NewsletterEmailsRepository,
  Ls as RequestRepository,
  kf as RequestRepositoryMerged,
  Es as RequestRepositoryV1,
  Gl as RequestWishlistsRepository,
  Kl as SearchableTagRepository,
  gi as ShareGroop,
  rf as TailorRepository,
  Of as UserLocation,
  cc as UserRepository,
  wf as UserRepositoryMerged,
  Ds as UserRepositoryV1,
  bf as WaitingSearchRepositoryV2,
  Qu as addAdPartner,
  Yu as addArea,
  ed as addAreaDuplicate,
  td as addAreaGroup,
  rd as addCalendarImport,
  sd as addCode,
  Yc as addComment,
  xu as addDestination,
  _l as addDestinationPlace,
  nd as addDistance,
  ju as addFigaroExport,
  ad as addHouse,
  ql as addHousePlace,
  al as addHouseStaff,
  od as addHouseTruthLink,
  Uu as addIncomingExport,
  Dl as addInvitation,
  id as addLink,
  cd as addPeriodDuration,
  ud as addPeriodPrice,
  bl as addPlace,
  Sl as addPool,
  Xd as addPricingPeriod,
  tl as addRackRate,
  Lu as addTouristTaxeExport,
  Ul as addVoucher,
  Pu as approveExpectedPayOut,
  Nu as assignCredits,
  yl as assignPayIn,
  Ll as assignVoucher,
  dc as automaticProposalsRepository,
  Nf as buildRepositories,
  Df as buildRepositoriesV2,
  Vc as cancelBankExport,
  vu as cancelContract,
  Wc as confirmBankExport,
  Tc as createAdminUser,
  su as createClientReceiptByContractId,
  bu as createCredit,
  Pc as createEquipement,
  Wu as createGeneralConditions,
  Ec as createHouseContact,
  ou as createOwnerReceiptByContractId,
  Pf as defaultLocalizedString,
  dd as deleteArea,
  ld as deleteAreaGroup,
  fd as deleteCalendarImport,
  yd as deleteCode,
  eu as deleteComment,
  wu as deleteCredit,
  Nc as deleteEquipement,
  hd as deleteHouseTruthLink,
  md as deleteLink,
  uu as deletePaymentTransactionDeposits,
  Bs as emailSignUp,
  Zs as finishSignUp,
  Bc as forgotPassword,
  pd as getAdPartners,
  Sc as getAdminUser,
  Ku as getArchitecturalStyles,
  gd as getArea,
  vd as getAreaGroup,
  _d as getAreaGroups,
  qd as getAreas,
  Lc as getAuditById,
  vi as getAvailabilityRequestById,
  qi as getAwaitingActions,
  Gc as getBankExports,
  Kc as getBrands,
  bd as getCalendarImport,
  nu as getClientReceipByContractId,
  au as getClientReceiptPdf,
  tu as getComments,
  pu as getContractById,
  ku as getCredit,
  wd as getCredits,
  $u as getDestinationById,
  Ru as getDestinationExperiences,
  kd as getDistances,
  Cu as getEquipementTypes,
  Dc as getEquipements,
  Ou as getEventTypes,
  Du as getExpectedPayOut,
  Au as getExperiences,
  Bu as getFigaroExports,
  Gu as getGeneralConditions,
  Ju as getGeneralConditionsById,
  Id as getHouseById,
  Xu as getHouseCategories,
  cl as getHouseStyles,
  xd as getHouseTruthLinks,
  $d as getHouses,
  dl as getIncludedServices,
  Hu as getIncomingPaymentTransactionExport,
  iu as getOwnerReceipByContractId,
  cu as getOwnerReceiptPdf,
  fl as getPayIn,
  Fu as getPayOutExport,
  du as getPaymentTransactionByContractId,
  Td as getPeriodDurations,
  Sd as getPeriodPrices,
  wl as getPlaceById,
  Tl as getPlaceTypes,
  Al as getPoolById,
  Rl as getPools,
  Qd as getPricingPeriods,
  rl as getRackRates,
  Ad as getReviews,
  Rd as getSaleInformation,
  _u as getSignedContractPdf,
  Ed as getStayInformation,
  Cl as getSubsidiaries,
  Cd as getSurroundingInformation,
  ll as getTaxCertificateById,
  Nl as getThemes,
  mu as getTimelineItemsByContractId,
  Mu as getTouristTaxExport,
  Eu as getTree,
  Bl as getVoucher,
  Hc as googleSignIn,
  Od as modifyAdPartner,
  Ac as modifyAdminUser,
  Pd as modifyArea,
  Nd as modifyAreaGroup,
  Dd as modifyAreaPhotos,
  jd as modifyAutomaticOffer,
  _i as modifyAvailabilityRequest,
  Ud as modifyCalendarImport,
  Qc as modifyChangeRequest,
  yu as modifyClientContract,
  qu as modifyClientInfo,
  Ld as modifyCode,
  ru as modifyComment,
  gu as modifyContract,
  Iu as modifyCredit,
  Tu as modifyDestination,
  jc as modifyEquipement,
  Bd as modifyHouse,
  ol as modifyHouseStaff,
  Hd as modifyHouseTruthLink,
  Zu as modifyIncomingExport,
  jl as modifyInvitation,
  Fd as modifyLink,
  hu as modifyOwnerContract,
  fu as modifyPayOut,
  lu as modifyPaymentTransaction,
  Md as modifyPeriodDuration,
  Zd as modifyPeriodPrice,
  gl as modifyPhoto,
  kl as modifyPlace,
  El as modifyPool,
  Yd as modifyPricingPeriod,
  sl as modifyRackRate,
  zd as modifyReview,
  Vd as modifySaleInformation,
  Wd as modifyStayInformation,
  Gd as modifySurroundingInformation,
  zu as modifyTouristTaxeExport,
  Hl as modifyVoucher,
  Hs as phoneSignIn,
  Rc as removeAdminUser,
  Su as removeDestination,
  Il as removeDestinationPlace,
  Cc as removeHouseContact,
  $l as removeHousePlace,
  il as removeHouseStaff,
  Jd as removePeriodDuration,
  Kd as removePeriodPrice,
  vl as removePhoto,
  xl as removePlace,
  el as removePricingPeriod,
  nl as removeRackRate,
  Fl as removeVoucher,
  Fc as resetPassword,
  Mc as signIn,
  Zc as signOut,
  Fs as tokenSignIn,
  Ms as tokenSignUp,
  bi as updateOwnerNps,
  zc as validateToken
};
